/**
 * @license
 * @qwik.dev/core 2.0.0-beta.34-dev+b4e2356
 * Copyright QwikDev. All Rights Reserved.
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/QwikDev/qwik/blob/main/LICENSE
 */
import { isBrowser as oe, isServer as se } from "@qwik.dev/core/build";

export { isBrowser, isServer } from "@qwik.dev/core/build";

import { p as ie } from "@qwik.dev/core/preloader";

const le = !1;

const ue = globalThis;

const ce = ue.qDev !== !1;

const fe = ue.qDynamicPlatform !== !1;

const ae = ue.qTest === !0;

const he = ue.qRuntimeQrl === !0;

const de = t => {
    ce && Object.seal(t);
};

const pe = ce ? "background: #564CE0; color: white; padding: 2px 3px; border-radius: 2px; font-size: 0.8em;" : "";

const $e = /*#__PURE__*/ new Set;

const me = (t, ...n) => {
    if (ce) {
        const e = "warn" + t;
        if (!$e.has(e)) {
            $e.add(e);
            ye(t, ...n);
        }
    }
};

const ye = (t, ...n) => {
    ce && console.warn("%cQWIK WARN", pe, t, ...n);
};

const we = (t, n, ...e) => {
    const s = n instanceof Error ? n : Error(n);
    !ae && console.error("%cQWIK ERROR", pe, s.message, ...e, s.stack);
    t && !ae && setTimeout(() => {
        throw s;
    }, 0);
    return s;
};

/*@__INLINE__*/ const be = (t, n, e) => {
    let s = e >> 1;
    let o = t.length - 2 >> 1;
    for (;s <= o; ) {
        const e = s + (o - s >> 1);
        const r = t[e << 1];
        if (r === n) {
            return e << 1;
        }
        r < n ? s = e + 1 : o = e - 1;
    }
    return ~(s << 1);
};

const ve = (t, n, e, s, o = !1) => {
    const r = be(t, n, s);
    r >= 0 ? e != null || o ? t[r + 1] = e : t.splice(r, 2) : (e != null || o) && t.splice(r ^ -1, 0, n, e);
};

const ge = (t, n, e) => {
    const s = be(t, n, e);
    return s >= 0 ? t[s + 1] : null;
};

const Se = (t, n, e) => be(t, n, e) >= 0;

const _e = t => {
    const n = Object.getPrototypeOf(t);
    return n === Object.prototype || n === Array.prototype || n === null;
};

const ke = t => typeof t === "object" && t !== null;

const Ee = t => Array.isArray(t);

const xe = t => typeof t === "string";

const Re = t => typeof t === "function";

const Te = (t, n = []) => {
    const e = ((t, ...n) => {
        if (ce) {
            const e = [ "Error while serializing class or style attributes", "Scheduler not found", "track() received object, without prop to track", "Only primitive and object literals can be serialized. {{0}}", "You can render over a existing q:container. Skipping render().", "QRL is not a function", "Dynamic import {{0}} not found", "Unknown type argument", "Actual value for useContext({{0}}) can not be found, make sure some ancestor component has set a value using useContextProvider(). In the browser make sure that the context was used during SSR so its state was serialized.", "Invoking 'use*()' method outside of invocation context.", "Calling a 'use*()' method outside 'component$(() => { HERE })' is not allowed. 'use*()' methods provide hooks to the 'component$' state and lifecycle, ie 'use' hooks can only be called synchronously within the 'component$' function or another 'use' method.\nSee https://qwik.dev/docs/core/tasks/#use-method-rules", 'The provided Context reference "{{0}}" is not a valid context created by createContextId()', "SsrError(tag): {{0}}", "QRLs can not be resolved because it does not have an attached container. This means that the QRL does not know where it belongs inside the DOM, so it cant dynamically import() from a relative path.", "QRLs can not be dynamically resolved, because it does not have a chunk path", "{{0}}\nThe JSX ref attribute must be a Signal", "Serialization Error: Deserialization of data type {{0}} is not implemented", "Serialization Error: Expected vnode for ref prop, but got {{0}}", "Serialization Error: Cannot allocate data type {{0}}", "Serialization Error: Missing root id for {{0}}", "Serialization Error: Serialization of data type {{0}} is not implemented", "Serialization Error: Unvisited {{0}}", "Serialization Error: Missing QRL chunk for {{0}}", "{{0}}\nThe value of the textarea must be a string found {{1}}", "Unable to find q:container", "Element must have 'q:container' attribute.", "Unknown vnode type {{0}}.", "Materialize error: missing element: {{0}} {{1}} {{2}}", "Cannot coerce a Signal, use `.value` instead", "useComputed$ QRL {{0}} {{1}} cannot return a Promise", '===\nQwik version {{0}} already imported while importing {{1}}.\nThis can lead to issues due to duplicated shared structures.\nVerify that the Qwik libraries you\'re using are in "resolve.noExternal[]" and in "optimizeDeps.exclude".\n===\n', "WrappedSignal is read-only", "Attribute value is unsafe for SSR {{0}}", "SerializerSymbol function returned rejected promise", "Serialization Error: Cannot serialize function: {{0}}", "Cannot read .value of a clientOnly async signal during SSR. Use .loading to check state, or provide an initial value." ];
            let s = e[t] ?? "";
            n.length && (s = s.replaceAll(/{{(\d+)}}/g, (t, e) => {
                let s = n[e];
                s && ke(s) && s.constructor === Object && (s = JSON.stringify(s).slice(0, 50));
                return s;
            }));
            return `Code(Q${t}): ${s}`;
        }
        return `Code(Q${t}) https://qwikdev-build-v2.qwik-8nx.pages.dev/docs/errors/#q${t}`;
    })(t, ...n);
    return ((t, ...n) => {
        const e = we(ce, t, ...n);
        debugger;
        return e;
    })(e, ...n);
};

const qe = "<sync>";

const Pe = t => typeof t === "function" && typeof t.getSymbol === "function";

const nh = t => {
    const n = t.lastIndexOf("_") + 1;
    return t.slice(n);
};

const Me = "q:type";

const Ae = {
    ["V"]: "Virtual",
    ["F"]: "Fragment",
    ["S"]: "Signal",
    ["A"]: "Awaited",
    ["C"]: "Component",
    ["I"]: "InlineComponent",
    ["P"]: "Projection"
};

const Ce = 124;

function t(t) {
    let n = "";
    for (let e = 0; e < t.length; e++) {
        if (t.charAt(e) === "\\" && e + 1 < t.length) {
            n += t.charAt(e + 1);
            e++;
        } else {
            n += t.charAt(e);
        }
    }
    return n;
}

const Ne = "q:renderFn";

const Ie = "q:targetEl";

const je = "⚡️";

const Oe = "q:slot";

const Le = "q:s";

const Fe = "q:style";

const De = "style[q\\:style]";

const ze = De + ",style[q\\:sstyle]";

const Ue = "q:sstyle";

const Ve = "q:ctx";

const We = "q:brefs";

const Qe = (t, n) => t["qFuncs_" + n] || [];

const Xe = "q:base";

const Be = "q:container-island";

const Je = "/" + Be;

const He = "q:ignore";

const Ye = "/" + He;

const Ge = "q:container";

const Ke = "/" + Ge;

const Ze = "q:template";

const tr = "http://www.w3.org/1999/xhtml";

const nr = "http://www.w3.org/2000/svg";

const er = "http://www.w3.org/1998/Math/MathML";

const rr = "qRender";

const sr = "q:key";

const or = "q:props";

const lr = "q:seq";

const ur = "q:seqIdx";

const cr = "q:p";

const fr = "q:ps";

const hr = ":on";

const dr = ":onIdx";

const pr = ":onFlags";

const $r = "q:cursorBoundary";

const mr = ":nearestCursorBoundary";

const yr = ":";

const wr = "dangerouslySetInnerHTML";

const br = "__scopedStyleIdPrefix__";

const vr = 100;

const gr = t => !!t && typeof t == "object" && typeof t.then === "function";

const Sr = (t, n, e) => {
    try {
        const s = t();
        return gr(s) ? s.then(n, e) : n(s);
    } catch (t) {
        return e(t);
    }
};

const _r = (t, n) => gr(t) ? t.then(n) : n(t);

const kr = t => {
    throw t;
};

function n(t, n = kr) {
    let e = !1;
    let s;
    try {
        s = t();
        e = !0;
    } catch (t) {
        s = t;
    }
    if (!gr(s)) {
        if (e) {
            return s;
        }
        return n(s);
    }
    let o = vr;
    const r = async e => {
        for (;gr(e); ) {
            try {
                await e;
                return await t();
            } catch (t) {
                if (!gr(t)) {
                    e = t;
                    break;
                }
                if (! --o) {
                    e = Error("Exceeded max retry count in retryOnPromise");
                    break;
                }
                e = t;
            }
        }
        return n(e);
    };
    return e ? s.catch(r) : r(s);
}

const Er = t => je + t;

const xr = t => {
    if (t) {
        let n = 0;
        do {
            t = t.substring(0, n) + Er(t.substring(n));
        } while ((n = t.indexOf(" ", n) + 1) !== 0);
    }
    return t || null;
};

const Rr = t => t.charCodeAt(0) === 113 && t.charCodeAt(1) === 45 && (t.charCodeAt(3) === 58 || t.charCodeAt(3) === 112 && t.charCodeAt(4) === 58);

function e(t, n = !1) {
    if (t.endsWith("$")) {
        const [e, s] = function o(t, n = !1) {
            let e;
            let s = -1;
            if (t.startsWith("on")) {
                e = n ? "q-ep:" : "q-e:";
                s = 2;
            } else if (t.startsWith("window:on")) {
                e = n ? "q-wp:" : "q-w:";
                s = 9;
            } else if (t.startsWith("document:on")) {
                e = n ? "q-dp:" : "q-d:";
                s = 11;
            }
            return [ e, s ];
        }(t, n);
        if (s !== -1) {
            return e + Tr(t.slice(s, -1));
        }
    }
    return null;
}

const Tr = t => t === "DOMContentLoaded" ? "-d-o-m-content-loaded" : function n(t, e = "") {
    const s = qr(t);
    return e + s;
}(t.charAt(0) === "-" ? t.slice(1) : t.toLowerCase());

const qr = t => t.replace(/([A-Z-])/g, t => "-" + t.toLowerCase());

const Pr = t => {
    const n = t.indexOf(":");
    return [ t.slice(2, n), t.slice(n + 1) ];
};

const Mr = new Set([ "animationIterationCount", "aspectRatio", "borderImageOutset", "borderImageSlice", "borderImageWidth", "boxFlex", "boxFlexGroup", "boxOrdinalGroup", "columnCount", "columns", "flex", "flexGrow", "flexShrink", "gridArea", "gridRow", "gridRowEnd", "gridRowStart", "gridColumn", "gridColumnEnd", "gridColumnStart", "fontWeight", "lineClamp", "lineHeight", "opacity", "order", "orphans", "scale", "tabSize", "widows", "zIndex", "zoom", "MozAnimationIterationCount", "MozBoxFlex", "msFlex", "msFlexPositive", "WebkitAnimationIterationCount", "WebkitBoxFlex", "WebkitBoxOrdinalGroup", "WebkitColumnCount", "WebkitColumns", "WebkitFlex", "WebkitFlexGrow", "WebkitFlexShrink", "WebkitLineClamp" ]);

const Ar = (t, n = 0) => {
    for (let e = 0; e < t.length; e++) {
        const s = t.charCodeAt(e);
        n = (n << 5) - n + s;
        n |= 0;
    }
    return (+Math.abs(n)).toString(36);
};

const Cr = t => {
    if (!t) {
        return "";
    }
    if (xe(t)) {
        return t.trim();
    }
    const n = [];
    if (Ee(t)) {
        for (let e = 0; e < t.length; e++) {
            const s = t[e];
            const o = Cr(s);
            o && n.push(o);
        }
    } else {
        for (const [e, s] of Object.entries(t)) {
            s && n.push(e.trim());
        }
    }
    return n.join(" ");
};

const Nr = t => t.replace(/([A-Z])/g, "-$1").toLowerCase();

function r(t, n, e) {
    if (function s(t) {
        return t === "class";
    }(t)) {
        const t = Cr(n);
        n = e ? e + (t.length ? " " + t : t) : t;
    } else {
        t === "style" ? n = (t => {
            if (t == null) {
                return "";
            }
            if (typeof t == "object") {
                if (Ee(t)) {
                    throw Te(0, [ t, "style" ]);
                }
                {
                    const n = [];
                    for (const e in t) {
                        if (Object.prototype.hasOwnProperty.call(t, e)) {
                            const s = t[e];
                            s != null && typeof s !== "function" && (e.startsWith("--") ? n.push(e + ":" + s) : n.push(Nr(e) + ":" + Ir(e, s)));
                        }
                    }
                    return n.join(";");
                }
            }
            return t + "";
        })(n) : function o(t) {
            return function n(t) {
                return t.startsWith("aria-");
            }(t) || [ "spellcheck", "draggable", "contenteditable" ].includes(t);
        }(t) || typeof n === "number" ? n = (t => t != null ? t + "" : null)(n) : n === !1 || n == null ? n = null : n === !0 && function r(t) {
            return t.startsWith("preventdefault:");
        }(t) && (n = "");
    }
    return n;
}

const Ir = (t, n) => {
    if (typeof n === "number" && n !== 0 && !(t => Mr.has(t))(t)) {
        return n + "px";
    }
    return n;
};

const jr = t => {
    let n;
    if (typeof MessageChannel !== "undefined") {
        const e = new MessageChannel;
        e.port1.onmessage = () => t();
        n = () => e.port2.postMessage(null);
    } else {
        n = () => setTimeout(t);
    }
    return n;
};

const Or = oe ? document : void 0;

const Lr = oe && Or.createElement("link").relList?.supports?.("modulepreload") ? "modulePreload" : "preload";

performance.now();

const Fr = /\.[mc]?js$/;

const Dr = 1e3 / 60;

const zr = t => {
    let n = Ur.get(t);
    if (!n) {
        let e;
        n = ((t, n) => ({
            Dt: t,
            Nt: Fr.test(t) ? 0 : 3,
            zt: n,
            Ut: 1,
            Vt: performance.now(),
            Wt: 0,
            Qt: 0
        }))(t, e);
        Ur.set(t, n);
    }
    return n;
};

const Ur = new Map;

let Vr = 0;

const Wr = [];

const Qr = jr(function eh() {
    Br = !1;
    if (!Wr.length) {
        return;
    }
    const t = performance.now() + Dr;
    let n = !1;
    for (;Wr.length; ) {
        const e = Wr[0];
        const s = e.Ut;
        const o = 1 - s;
        if (!(o >= .99 || Vr < 25)) {
            break;
        }
        Wr.shift();
        Kr(e);
        if (performance.now() >= t) {
            n = !0;
            break;
        }
    }
    if (n && Wr.length && !Br) {
        Br = !0;
        Qr();
    }
});

const Xr = jr(sh);

let Br = !1;

let Jr = !1;

let Hr = !1;

const Yr = [];

const Gr = () => {
    const t = Yr[Yr.length - 1];
    const n = t.Xt;
    if (t.zt) {
        const e = t.Bt;
        if (e >= t.zt.length) {
            Yr.pop();
            return !1;
        }
        const s = t.zt[e];
        t.Bt = e + 1;
        const o = zr(s.Dt);
        if (o.Ut === 0) {
            return !0;
        }
        const r = 1 - n.Ut;
        let i;
        if (r === 1 || r >= .99) {
            i = Math.min(.01, 1 - s.Jt);
        } else {
            const t = 1 - s.Jt * r;
            const n = s.Ht;
            const e = t / n;
            i = Math.max(.02, o.Ut * e);
            s.Ht = e;
        }
        Yr.push({
            Xt: o,
            Ut: i,
            Yt: t.Yt
        });
        return !0;
    }
    if (t.Yt?.has(n)) {
        Yr.pop();
        return !1;
    }
    const e = n.Ut;
    n.Ut = t.Ut;
    if (e - n.Ut < .01) {
        Yr.pop();
        return !1;
    }
    if (n.zt?.length) {
        const e = t.Yt || new Set;
        e.add(n);
        t.Yt = e;
        t.zt = n.zt;
        t.Bt = 0;
        return !1;
    }
    Yr.pop();
    return !1;
};

function sh() {
    if (Hr || !Yr.length) {
        return;
    }
    Jr = !1;
    Hr = !0;
    const t = oe ? performance.now() + Dr : 0;
    let n = !1;
    for (;Yr.length; ) {
        n = !0;
        const e = Gr();
        if (oe && e && performance.now() >= t) {
            if (!Jr) {
                Jr = !0;
                Xr();
            }
            break;
        }
    }
    Hr = !1;
    n && oe && Qr();
}

const Kr = t => {
    if (t.Nt >= 2) {
        return;
    }
    Vr++;
    const n = performance.now();
    t.Wt = n - t.Vt;
    t.Nt = 2;
    const e = Or.createElement("link");
    e.href = "" + new URL("undefined" + t.Dt, Or.baseURI);
    e.rel = Lr;
    e.as = "script";
    e.onload = e.onerror = () => {
        Vr--;
        const s = performance.now();
        t.Qt = s - n;
        t.Nt = 4;
        e.remove();
        Qr();
    };
    Or.head.appendChild(e);
};

const Zr = (t, n) => {
    const e = zr(t);
    e && ((t, n) => {
        Yr.unshift({
            Xt: t,
            Ut: n,
            Yt: void 0
        });
    })(e, n);
};

oe && document.addEventListener("qsymbol", t => {
    const {symbol: n, href: e} = t.detail;
    if (e) {
        const t = n.slice(n.lastIndexOf("_") + 1);
        (t => {
            if (!t?.length) {
                return;
            }
            if (Array.isArray(t)) {
                for (let n = t.length - 1; n >= 0; n--) {
                    const e = t[n];
                    Zr(e, 0);
                }
            } else {
                Zr(t, 0);
            }
            oe ? Xr() : sh();
        })(t);
    }
});

const ti = t => {
    for (const n in t) {
        if (Object.prototype.hasOwnProperty.call(t, n)) {
            return !1;
        }
    }
    return !0;
};

const ni = ",";

const ei = "2.0.0-beta.34-dev+b4e2356";

const ri = () => ({
    isServer: se,
    importSymbol(t, n, e) {
        if (se) {
            const t = nh(e);
            const n = globalThis.__qwik_reg_symbols?.get(t);
            if (n) {
                return n;
            }
            throw Te(6, [ e ]);
        }
        if (!n) {
            throw Te(14, [ e ]);
        }
        if (!t) {
            throw Te(13, [ n, e ]);
        }
        const s = "" + ii(t.ownerDocument, t, n);
        const o = new URL(s);
        o.hash = "";
        const r = o.href;
        return import(r).then(t => t[e]);
    },
    raf: t => new Promise(n => {
        requestAnimationFrame(() => {
            n(t());
        });
    }),
    chunkForSymbol(t, n) {
        return [ t, n ?? "_" ];
    }
});

const ii = (t, n, e) => {
    const s = t.baseURI;
    const o = new URL(n.getAttribute(Xe) ?? s, s);
    return new URL(e, o);
};

let si = /*#__PURE__ */ ri();

const oi = t => si = t;

const li = () => si;

const ui = () => {
    if (fe) {
        return si.isServer;
    }
    return !1;
};

const ci = t => t.nodeType === 1;

const fi = Symbol();

class ai {
    [fi]=void 0;
}

const hi = t => t === "foreignObject";

const di = t => t === "svg" || hi(t);

const pi = t => t === "math";

function i(t, n, e, s = !1) {
    const o = t.ownerDocument.createElementNS(e, n);
    for (let n = 0; n < t.attributes.length; n++) {
        const e = t.attributes[n];
        e.name !== yr && o.setAttribute(e.name, e.value);
    }
    if (s) {
        for (let n = 0; n < t.childNodes.length; n++) {
            const r = t.childNodes[n];
            const c = r.nodeType;
            c === 3 ? o.appendChild(r.cloneNode()) : c === 1 && o.appendChild(i(r, r.localName, e, s));
        }
    }
    return o;
}

const $i = {
    elementNamespace: tr,
    elementNamespaceFlag: 0
};

function s(t, n) {
    const e = !t || !!hl(t) && (t => {
        const n = t.flags;
        return (n & 1536) === 0;
    })(t);
    const s = !e && hi(hl(t));
    let o = tr;
    let r = 0;
    const i = typeof n === "string" || No(n);
    if (i && function c(t) {
        if (typeof t === "string") {
            return di(t);
        }
        if (No(t)) {
            return di(hl(t)) || (t.flags & 512) !== 0;
        }
        return !1;
    }(n)) {
        o = nr;
        r = 512;
    } else if (i && function l(t) {
        if (typeof t === "string") {
            return pi(t);
        }
        if (No(t)) {
            return pi(hl(t)) || (t.flags & 1024) !== 0;
        }
        return !1;
    }(n)) {
        o = er;
        r = 1024;
    } else if (t && !s && !e) {
        const n = (t.flags & 512) !== 0;
        const e = (t.flags & 1024) !== 0;
        o = n ? nr : e ? er : tr;
        r = t.flags & 1536;
    }
    $i.elementNamespace = o;
    $i.elementNamespaceFlag = r;
    return $i;
}

class mi {
    flags;
    parent;
    previousSibling;
    nextSibling;
    props;
    [fi]=void 0;
    slotParent=null;
    dirty=0;
    dirtyChildren=null;
    nextDirtyChildIndex=0;
    constructor(t, n, e, s, o) {
        this.flags = t;
        this.parent = n;
        this.previousSibling = e;
        this.nextSibling = s;
        this.props = o;
    }
    toString() {
        return Object.prototype.toString.call(this);
    }
}

class yi extends mi {
    key;
    firstChild;
    lastChild;
    constructor(t, n, e, s, o, r, i, c) {
        super(n, e, s, o, r);
        this.key = t;
        this.firstChild = i;
        this.lastChild = c;
    }
}

class wi extends yi {
    node;
    elementName;
    constructor(t, n, e, s, o, r, i, c, l, u) {
        super(t, n, e, s, o, r, i, c);
        this.node = l;
        this.elementName = u;
    }
}

class bi extends mi {
    node;
    text;
    constructor(t, n, e, s, o, r, i) {
        super(t, n, e, s, o);
        this.node = r;
        this.text = i;
    }
}

const vi = [];

const gi = [];

function o(t, n) {
    const e = h(n).priority;
    let s = vi.length;
    for (let t = 0; t < vi.length; t++) {
        const n = h(vi[t]).priority;
        if (e < n) {
            s = t;
            break;
        }
    }
    vi.splice(s, 0, n);
    t.o++;
    t.l ||= new Promise(n => t.u = n);
}

function l() {
    for (let t = 0; t < vi.length; t++) {
        const n = vi[t];
        let e = !1;
        for (let t = 0; t < gi.length; t++) {
            const s = gi[t];
            if (Nl(n, s)) {
                e = !0;
                break;
            }
        }
        if (!e) {
            return n;
        }
    }
    return null;
}

function u(t, n) {
    gi.push(t);
    f(t, n, !0);
    n.o++;
}

function c(t, n) {
    const e = gi.indexOf(t);
    if (e !== -1) {
        const t = gi.length - 1;
        e !== t && (gi[e] = gi[t]);
        gi.pop();
        n.o--;
    }
    o(n, t);
}

function f(t, n, e) {
    e || (t.flags &= -257);
    const s = vi.indexOf(t);
    if (s !== -1) {
        vi.splice(s, 1);
        n.o--;
    }
}

const Si = new WeakMap;

const _i = ":nodeProps";

const ki = ":nodeDiff";

const Ei = ":errorData";

const xi = ":signal";

function a(t, n, e) {
    n.position = e;
    e && nn(e) && function s(t, n, e) {
        f(e, t);
        const s = h(e);
        if (s === n) {
            return;
        }
        const o = s.afterFlushTasks;
        if (o && o.length > 0) {
            const t = n.afterFlushTasks;
            t ? t.push(...o) : n.afterFlushTasks = o;
        }
        const r = s.extraPromises;
        if (r && r.length > 0) {
            const t = n.extraPromises;
            t ? t.push(...r) : n.extraPromises = r;
        }
        const i = s.journal;
        if (i && i.length > 0) {
            const t = n.journal;
            t ? t.push(...i) : n.journal = i;
        }
        const c = s.boundaries;
        if (__EXPERIMENTAL__.suspense && c && c.length > 0) {
            const t = n.boundaries ||= [];
            for (let n = 0; n < c.length; n++) {
                const e = c[n];
                t.includes(e) || t.push(e);
            }
        }
    }(t, n, e);
}

function h(t) {
    return Si.get(t) ?? null;
}

const Ri = Symbol();

class Ti {
    consumer;
    property;
    backRef;
    data;
    constructor(t, n, e = null, s = null) {
        this.consumer = t;
        this.property = n;
        this.backRef = e;
        this.data = s;
    }
}

const qi = Symbol();

const Pi = Symbol();

const Mi = Symbol();

function d(t, n, e) {
    t[fi] || (se && function s(t) {
        return "__brand__" in t && t.__brand__ === "SsrNode";
    }(t) ? t.setProp(We, new Map) : t[fi] = new Map);
    const o = t[fi];
    let r = o.get(n);
    if (!r) {
        r = new Ti(t, n);
        o.set(n, r);
    }
    e && (r.data = e);
    return r;
}

const Ai = (t, n) => (e, s) => {
    const o = ee();
    o.Ot = d(t, ":");
    o.$ = n || void 0;
    return Zn(o, () => {
        if (Re(e)) {
            return e();
        }
        if (s) {
            return e[s];
        }
        if (Jl(e)) {
            return e.value;
        }
        if (ke(e) && uu(e)) {
            Sn(iu(e), Mi, ru(e), o.Ot);
            return e;
        }
        throw Te(2);
    });
};

class Ci {
    Gt;
    ut=void 0;
    $=null;
    Kt=null;
    constructor(t, n) {
        this.$ = t || Cc()?.$ || null;
        this.Gt = n;
    }
    trigger() {
        Kl(this.$, this, this.ut);
    }
    force() {
        Kl(this.$, this, this.ut);
    }
    get untrackedValue() {
        return this.Gt;
    }
    set untrackedValue(t) {
        this.Gt = t;
    }
    get value() {
        const t = this.untrackedValue;
        const n = Cc();
        if (!n) {
            return t;
        }
        this.$ === null && (this.$ = n.$);
        const e = n.Ot;
        if (e) {
            Hl(this.ut ||= new Set, e);
            Yl(e, this);
            (import.meta.env.TEST ? !qc(this.$) : se) && Gl(e, this.$);
        }
        return t;
    }
    set value(t) {
        if (t !== this.Gt) {
            this.Gt = t;
            Kl(this.$, this, this.ut);
        }
    }
    valueOf() {
        if (ce) {
            throw Te(28);
        }
    }
    toString() {
        return this.constructor.name;
    }
    toJSON() {
        return {
            value: this.Gt
        };
    }
}

class Ni extends Ci {
    Zt;
    h;
    [fi]=void 0;
    constructor(t, n, e = 17) {
        super(t || Cc()?.$, Ri);
        this.Zt = n;
        this.h = e;
    }
    invalidate() {
        this.h |= 1;
        const t = ee();
        t.$ = this.$ || void 0;
        const e = n(te.bind(this, t, this.p));
        e && e.catch(t => {
            this.$ ? this.$.handleError(t, null) : console.error("Error during computation", t);
        });
    }
    get untrackedValue() {
        this.p();
        return this.Gt;
    }
    set untrackedValue(t) {
        this.Gt = t;
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        const t = this.Zt;
        Bl(t);
        const n = Cc();
        const e = n?.Ot;
        if (n) {
            const t = d(this, ".");
            $n(this.$, t);
            n.Ot = t;
        }
        try {
            const e = t.getFn(n)();
            if (gr(e)) {
                throw Te(29, [ t.dev ? t.dev.file : "", t.st ]);
            }
            this.h &= -2;
            super.value = e;
        } finally {
            n && (n.Ot = e);
        }
    }
}

class Ii {
    tn;
    nn=null;
    en=!1;
    rn=!0;
    constructor(t, n, e) {
        this.tn = t;
        if (n !== void 0) {
            this.info = n;
            this.sn = e;
        }
    }
    get track() {
        return this.ln ||= Ai(this.tn, this.tn.$);
    }
    get abortSignal() {
        return (this.un ||= new AbortController).signal;
    }
    cache() {}
    get previous() {
        const t = this.tn.Gt;
        if (t !== Ri) {
            return t;
        }
    }
    cleanup(t) {
        typeof t === "function" && (this.cn ||= []).push(t);
    }
}

class ji extends Ni {
    fn=!1;
    an=void 0;
    hn=null;
    [fi]=void 0;
    constructor(t, n, e = 17, s) {
        super(t, n, e);
        if (!s) {
            return;
        }
        const o = s.initial;
        if (o !== void 0) {
            const t = typeof o === "function" ? o() : o;
            this.Gt = t;
        }
        const r = s.concurrency;
        if (r !== void 0 && r >= 0 && r !== 1) {
            this.dn = r;
            this.pn = [];
        }
        const i = s.timeout;
        i && (this.$n = i);
        s.eagerCleanup && (this.h |= 32);
        s.clientOnly && (this.h |= 64);
        s.allowStale === !1 && (this.h |= 128);
        const c = s.expires ?? (s.interval ? Math.abs(s.interval) : void 0);
        c && (this.expires = c);
        (s.poll === !1 || s.interval !== void 0 && s.interval < 0) && (this.h |= 256);
    }
    get untrackedValue() {
        this.p();
        if (this.hn?.nn) {
            if (this.Gt === Ri || (import.meta.env.TEST ? ui() : se)) {
                throw this.hn?.nn;
            }
            return this.Gt;
        }
        if (this.an) {
            throw this.an;
        }
        if ((import.meta.env.TEST ? ui() : se) && this.h & 64 && this.Gt === Ri) {
            throw Te(35);
        }
        return this.Gt;
    }
    set untrackedValue(t) {
        this.Gt = t;
    }
    get value() {
        return super.value;
    }
    set value(t) {
        this.h &= -2;
        this.untrackedLoading = !1;
        this.untrackedError = void 0;
        this.mn = void 0;
        if (this.pn) {
            for (let t = 0; t < this.pn.length; t++) {
                this.pn[t].rn = !1;
            }
        } else {
            this.hn && (this.hn.rn = !1);
        }
        this.yn();
        super.value = t;
        this.wn();
    }
    get loading() {
        const t = this.untrackedLoading;
        const n = Cc();
        if (n && (this.$ ||= n.$ || null)) {
            const t = n.Ot;
            if (t) {
                Hl(this.dt ||= new Set, t);
                Yl(t, this);
                Gl(t, this.$);
            }
        }
        return t;
    }
    set untrackedLoading(t) {
        if (t !== this.fn) {
            this.fn = t;
            Kl(this.$, this, this.dt);
        }
    }
    get untrackedLoading() {
        this.p();
        if ((import.meta.env.TEST ? ui() : se) && this.hn?.nn) {
            throw this.hn?.nn;
        }
        return this.fn;
    }
    get error() {
        const t = this.untrackedError;
        const n = Cc();
        if (n && (this.$ ||= n.$ || null)) {
            const t = n.Ot;
            if (t) {
                Hl(this.$t ||= new Set, t);
                Yl(t, this);
                Gl(t, this.$);
            }
        }
        return t;
    }
    set untrackedError(t) {
        if (t !== this.an) {
            this.an = t;
            Kl(this.$, this, this.$t);
        }
    }
    get untrackedError() {
        return this.an;
    }
    get expires() {
        return this.xt || 0;
    }
    set expires(t) {
        this.yn();
        this.xt = t;
        this.xt && this.bn() && this.wn();
    }
    get poll() {
        return !(this.h & 256);
    }
    set poll(t) {
        t ? this.h &= -257 : this.h |= 256;
        if (this.xt && this.bn()) {
            this.yn();
            this.wn();
        }
    }
    get interval() {
        const t = this.xt || 0;
        return this.h & 256 ? -t : t;
    }
    set interval(t) {
        t < 0 ? this.h |= 256 : this.h &= -257;
        this.expires = Math.abs(t);
    }
    async invalidate(t) {
        if (arguments.length > 0) {
            this.mn = t;
            this.sn = this.sn === void 0 ? 1 : this.sn + 1;
        }
        this.vn(!0, this.h & 128);
    }
    vn(t, n) {
        this.h |= 1;
        this.yn();
        n && (this.Gt = Ri);
        t && (this.ut?.size || this.dt?.size || this.$t?.size) && Promise.resolve().then(() => this.p());
    }
    abort(t) {
        this.hn && this.gn(this.hn, t);
    }
    yt() {
        if (!(this.h & 32) || this.bn()) {
            return;
        }
        if (!(import.meta.env.TEST ? !ui() : oe)) {
            return;
        }
        setTimeout(() => {
            this.bn() || this.abort();
        });
    }
    async promise() {
        this.p();
        for (;this.hn?.nn; ) {
            await (this.hn?.nn);
        }
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        if ((import.meta.env.TEST ? ui() : se) && this.h & 64) {
            this.fn = !0;
            this.$?.serializationCtx.Rt.add(this);
            return;
        }
        this.yn();
        this.h &= -2;
        const t = this.hn;
        t && this.gn(t);
        const n = this.dn === 0 ? Infinity : this.dn ?? 1;
        if (this.pn ? this.pn.length >= n : t?.nn) {
            this.h |= 1;
            return;
        }
        const e = this.sn;
        const s = new Ii(this, this.mn, e);
        this.hn = s;
        this.pn && this.pn.push(s);
        s.nn = this.Sn(s);
    }
    async Sn(t) {
        let e = this.Zt.resolved;
        if (!e) {
            this.untrackedLoading = !0;
            e = await this.Zt.resolve();
            if (t.un?.signal.aborted) {
                t.nn = null;
                return;
            }
        }
        try {
            this.$n && (this._n = setTimeout(() => {
                const n = Error(`timeout ${this.$n}ms`);
                this.kn(t, n);
                t.un?.abort(n);
            }, this.$n));
            const s = n(e.bind(null, t));
            let o;
            if (gr(s)) {
                this.untrackedLoading = !0;
                o = await s;
            } else {
                o = s;
            }
            t.nn = null;
            if (t.rn) {
                const n = this.pn;
                if (n) {
                    let e = !1;
                    for (let s = n.length - 1; s >= 0; s--) {
                        n[s] === t ? e = !0 : e && (n[s].rn = !1);
                    }
                }
                this.untrackedError = void 0;
                super.value = o;
            }
        } catch (n) {
            t.nn = null;
            this.kn(t, n);
        }
        if ((() => t === this.hn)()) {
            clearTimeout(this._n);
            t.sn === this.sn && (this.mn = void 0);
            if (this.h & 1) {
                this.p();
            } else {
                this.untrackedLoading = !1;
                this.wn();
            }
        }
    }
    kn(t, n) {
        if (t !== this.hn || !t.rn) {
            return;
        }
        t.rn = !1;
        if (n instanceof Error && n.name === "AbortError") {
            return;
        }
        this.untrackedError = n;
        this.untrackedValue = Ri;
    }
    async En() {
        this.yn();
        clearTimeout(this._n);
        const t = this.hn;
        t && this.gn(t);
        this.pn ? await Promise.all(this.pn.map(t => t.nn)) : await (t?.nn);
    }
    yn() {
        if (this.xn !== void 0) {
            clearTimeout(this.xn);
            this.xn = void 0;
        }
    }
    wn() {
        if ((import.meta.env.TEST ? ui() : se) || !this.xt) {
            return;
        }
        this.yn();
        const t = !(this.h & 256);
        const n = this.h & 128 && !t;
        this.xn = setTimeout(() => this.vn(t, n), this.xt);
        this.xn?.unref?.();
    }
    bn() {
        return !!(this.ut?.size || this.dt?.size || this.$t?.size);
    }
    gn(t, n) {
        if (t.en) {
            return;
        }
        t.en = !0;
        t.un?.abort(n);
        t.nn = _r(t.nn, () => this.Rn(t));
    }
    Rn(t) {
        const n = t.cn;
        const e = t => {
            const n = this.$?.handleError;
            n ? n(t, null) : console.error("Error in async signal cleanup", t);
        };
        const s = () => {
            t.nn = null;
            n && (n.length = 0);
            const e = this.pn;
            if (e) {
                const n = e.indexOf(t);
                n !== -1 && e.splice(n, 1);
            }
            this.p();
        };
        let o;
        if (n) {
            for (let t = 0; t < n.length; t++) {
                try {
                    const s = n[t]();
                    gr(s) && (o = (o ? o.then(() => s) : s).catch(e));
                } catch (t) {
                    e(t);
                }
            }
        }
        if (o) {
            return o.then(s);
        }
        s();
    }
}

const Oi = Symbol();

const Li = Symbol();

const Fi = Symbol();

const Di = Symbol();

const zi = Symbol();

const Ui = Symbol();

const Vi = [];

const Wi = {};

Object.freeze(Vi);

Object.freeze(Wi);

function p(t) {
    return new Proxy({}, new Qi(t));
}

class Qi {
    owner;
    ut=void 0;
    $=null;
    constructor(t) {
        this.owner = t;
    }
    get(t, n) {
        if (n === Oi) {
            return this.owner.constProps;
        }
        if (n === Li) {
            return this.owner.varProps;
        }
        if (n === Fi) {
            return this.owner;
        }
        if (n === Di) {
            return this;
        }
        let s;
        if (n === "children") {
            s = this.owner.children;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
            s = Ji(this.owner, n);
            n in this.owner.varProps && Xi(this, n);
        }
        return s instanceof ps && s.h & 4 ? s.value : s;
    }
    set(t, n, s) {
        if (n === Fi) {
            this.owner = s;
        } else if (n === "children") {
            this.owner.children = s;
        } else if (n === Oi) {
            this.owner.constProps = s;
        } else if (n === Li) {
            this.owner.varProps = s;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
            this.owner.constProps && n in this.owner.constProps && delete this.owner.constProps[n];
            this.owner.varProps === Wi ? this.owner.varProps = {} : n in this.owner.varProps || (this.owner.toSort = !0);
            if (this.owner.varProps[n] !== s) {
                this.owner.varProps[n] = s;
                Bi(this, n);
            }
        }
        return !0;
    }
    deleteProperty(t, n) {
        let e = delete this.owner.varProps[n];
        e && Bi(this, n);
        this.owner.constProps && (e = delete this.owner.constProps[n] || e);
        if (this.owner.children != null && n === "children") {
            this.owner.children = null;
            e = !0;
        }
        return e;
    }
    has(t, n) {
        if (n === "children") {
            return this.owner.children != null;
        }
        if (n === Oi || n === Li) {
            return !0;
        }
        const s = n in this.owner.varProps;
        if (typeof n === "string") {
            s && Xi(this, n);
            if (typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
        }
        return s || !!this.owner.constProps && n in this.owner.constProps;
    }
    getOwnPropertyDescriptor(t, n) {
        const e = n === "children" ? this.owner.children : this.owner.constProps && n in this.owner.constProps ? this.owner.constProps[n] : this.owner.varProps[n];
        return {
            configurable: !0,
            enumerable: !0,
            value: e
        };
    }
    ownKeys() {
        const t = Object.keys(this.owner.varProps);
        this.owner.children != null && t.push("children");
        if (this.owner.constProps) {
            for (const n in this.owner.constProps) {
                t.indexOf(n) === -1 && t.push(n);
            }
        }
        return t;
    }
}

const Xi = (t, n) => {
    const e = Cc();
    e && t.$ === null && e.$ && (t.$ = e.$);
    const s = e?.Ot;
    s && Sn(t.owner._proxy, n, t, s);
};

const Bi = (t, n) => {
    const e = function s(t, n) {
        return t?.get(n);
    }(t.ut, n);
    e && Kl(t.$, t, e);
    return !!e;
};

const Ji = (t, n) => t.constProps && n in t.constProps ? t.constProps[n] : t.varProps[n];

const Hi = (t, n) => Yi(t)?.[n] || Gi(t)?.[n] || null;

const Yi = t => {
    if (!t) {
        return null;
    }
    return Li in t ? "children" in t ? {
        ...t[Li],
        children: t.children
    } : t[Li] : t;
};

const Gi = t => {
    if (!t) {
        return null;
    }
    return Oi in t ? t[Oi] : null;
};

const Ki = t => t && Li in t;

const Zi = t => (n, ...e) => t.call(null, $f(n), ...e);

class ts extends Ni {
    constructor(t, n) {
        super(t, n, 17);
    }
    Tn=!1;
    p() {
        if (!(this.h & 1)) {
            return;
        }
        Bl(this.Zt);
        const t = Oc(this.Zt.resolved);
        const {deserialize: n, initial: e} = t;
        const s = t.update;
        const o = this.Gt === Ri ? e : this.Gt;
        const r = Fc(() => this.Tn ? s?.(o) || o : n(o), this, ".", this.$);
        this.Tn = !0;
        this.h &= -2;
        const i = this.Tn && r !== "undefined" || r !== this.Gt;
        if (i) {
            this.Gt = r;
            Kl(this.$, this, this.ut);
        }
    }
}

const ns = (t, n) => new Ni(n?.container || null, t, tu(n?.serializationStrategy || "always"));

const es = (t, n) => new ji(n?.container || null, t, tu(n?.serializationStrategy || "always"), n);

const rs = t => new ts(null, t);

const is = t => new Ci(null, t);

const ss = /*#__PURE__*/ Zi(ns);

const os = /*#__PURE__*/ Zi(es);

const ls = Zi(rs);

const us = t => t.value;

const cs = (t, n) => t[n];

const fs = t => {
    if (t.length === 1) {
        if (Jl(t[0])) {
            return t[0].Kt ||= new ps(null, us, t, null);
        }
        if (uu(t[0])) {
            return new ps(null, us, t, null);
        }
        return t[0].value;
    }
    return new ps(null, cs, t, null);
};

const as = (...t) => {
    const n = t[0];
    const e = t.length < 2 ? "value" : t[1];
    if (!ke(n)) {
        return n[e];
    }
    if (Jl(n)) {
        if (n instanceof ps && n.h & 4) {
            return n;
        }
        return fs(t);
    }
    if (Ki(n)) {
        const s = n[Oi];
        const o = n[Li];
        if (s && Object.prototype.hasOwnProperty.call(s, e)) {
            return s[e];
        }
        if (Object.prototype.hasOwnProperty.call(o, e)) {
            const n = o[e];
            return hs(n, t);
        }
    } else {
        const s = iu(n);
        if (s) {
            const n = s[e];
            return hs(n, t);
        }
    }
    return n[e];
};

const hs = (t, n) => Jl(t) ? t : fs(n);

const ds = (t, n) => {
    const e = as(t, n);
    if (e === zi) {
        return t[n];
    }
    return e;
};

class ps extends Ci {
    lt;
    ot;
    kt;
    h;
    m=void 0;
    [fi]=void 0;
    constructor(t, n, e, s, o = 5) {
        super(t, Ri);
        this.lt = e;
        this.ot = n;
        this.kt = s;
        this.h = o;
    }
    invalidate() {
        this.h |= 1;
        try {
            this.p();
        } catch (t) {
            if (this.$ && this.m) {
                this.$.setHostProp(this.m, xi, this);
                sn(this.$, this.m, 16);
            }
        }
        if (this.h & 2) {
            this.h &= -3;
            Kl(this.$, this, this.ut);
        }
    }
    get untrackedValue() {
        this.p();
        return this.Gt;
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        const t = Fc(() => this.ot(...this.lt), this, ".", this.$);
        this.h &= -3;
        const n = t !== this.Gt;
        if (n) {
            this.h |= 2;
            this.Gt = t;
        }
    }
    it() {
        return this.ot === us && Jl(this.lt[0]) ? this.lt[0] : this;
    }
    set value(t) {
        throw Te(31);
    }
    get value() {
        return super.value;
    }
}

class $s {
    data;
    constructor(t) {
        this.data = t;
    }
}

const ms = (t, n) => {
    if (typeof t === "string") {
        const e = Jn(n);
        nf(ef(e, t));
    }
    return null;
};

function $(t, n) {
    ms(this, n);
    const e = tf[0];
    e.value = n.type === "number" ? n.valueAsNumber : n.value;
}

function m(t, n) {
    ms(this, n);
    const e = tf[0];
    e.value = n.checked;
}

function y(t, n) {
    ms(this, n);
    if (tf) {
        for (let t = 0; t < tf.length; t++) {
            const n = tf[t];
            n instanceof ji && n.h & 64 && n.p();
        }
    }
}

const ys = Object.prototype.hasOwnProperty;

class ws {
    type;
    children;
    flags;
    toSort;
    key;
    varProps;
    constProps;
    dev;
    _proxy=null;
    constructor(t, n, e, s, o, r, i, c) {
        this.type = t;
        this.children = s;
        this.flags = o;
        this.toSort = !!i;
        this.key = r === null || r === void 0 ? null : typeof r === "string" ? r : "" + r;
        this.varProps = !n || ti(n) ? Wi : n;
        this.constProps = !e || ti(e) ? null : e;
        ce && c && (this.dev = {
            ...c,
            stack: Error().stack?.split("\n").slice(2).join("\n")
        });
        de(this);
    }
    get props() {
        return this._proxy ||= p(this);
    }
}

const bs = (t, n, e) => {
    let s = t[n];
    if (!s) {
        t[n] = e;
        return !0;
    }
    Array.isArray(s) ? s.push(e) : s = t[n] = [ s, e ];
};

const vs = t => {
    if (ce) {
        if (t instanceof ws) {
            return !0;
        }
        if (ke(t) && ys.call(t, "key") && ys.call(t, "props") && ys.call(t, "type")) {
            if (Ki(t)) {
                return !1;
            }
            ye('Duplicate implementations of "JSXNode" found');
            return !0;
        }
        return !1;
    }
    return t instanceof ws;
};

const gs = "bind:value";

const Ss = "bind:checked";

const _s = "passive:";

const ks = "preventdefault:";

const Es = Object.prototype.hasOwnProperty;

const xs = (t, n, e, s, o = !1) => {
    let r = t;
    let i = o;
    if (n.length > 0) {
        if (!i) {
            r = {
                ...r
            };
            i = !0;
        }
        for (let t = 0; t < n.length; t++) {
            const e = n[t];
            delete r[e];
        }
    }
    if (e.length > 0) {
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            if (s.has(Tr(n.slice(15)))) {
                if (!i) {
                    r = {
                        ...r
                    };
                    i = !0;
                }
                delete r[n];
            }
        }
    }
    return r;
};

const Rs = t => {
    if (t.startsWith("on") && t.endsWith("$")) {
        return Tr(t.slice(2, -1));
    }
    if (t.startsWith("window:on") && t.endsWith("$")) {
        return Tr(t.slice(9, -1));
    }
    if (t.startsWith("document:on") && t.endsWith("$")) {
        return Tr(t.slice(11, -1));
    }
    return null;
};

const Ts = (t, n, s, o, r = !1) => {
    let i = t;
    let c = r;
    for (let t = 0; t < n.length; t++) {
        const r = n[t];
        const l = Rs(r);
        const u = e(r, o.has(l));
        if (u) {
            if (!c) {
                i = {
                    ...i
                };
                c = !0;
            }
            const t = s.get(u);
            (t === void 0 || t < s.get(r)) && (i[u] = i[r]);
            delete i[r];
        }
    }
    return i;
};

const qs = (t, n, e, s, o, r, i) => new ws(t, n, e, s, o, r, !1, i);

const Ps = (t, n, e, s, o, r, i) => {
    let c = !1;
    let l = !1;
    let u = !1;
    let f = null;
    let a = null;
    if (typeof t === "string") {
        const t = new Set;
        const s = [];
        const o = [];
        const r = [];
        const h = [];
        const d = [];
        const p = [];
        const y = new Map;
        const w = new Map;
        if (e) {
            let n = 0;
            for (const o in e) {
                y.set(o, n++);
                if (o.startsWith(_s)) {
                    r.push(o);
                    t.add(Tr(o.slice(8)));
                } else {
                    o.startsWith(ks) ? d.push(o) : Rs(o) !== null ? s.push(o) : o === Ss ? a = e[o] : o === gs && (f = e[o]);
                }
            }
        }
        if (n) {
            let e = 0;
            for (const s in n) {
                w.set(s, e++);
                if (s.startsWith(_s)) {
                    h.push(s);
                    t.add(Tr(s.slice(8)));
                } else {
                    s.startsWith(ks) ? p.push(s) : Rs(s) !== null ? o.push(s) : s === Ss ? a = n[s] : s === gs && (f = n[s]);
                }
            }
        }
        if (e) {
            const n = e;
            e = xs(e, r, d, t, l);
            l = l || e !== n;
            e = Ts(e, s, y, t, l);
            l = l || e !== n;
        }
        if (n) {
            const e = n;
            n = xs(n, h, p, t, u);
            u = u || n !== e;
            n = Ts(n, o, w, t, u);
            u = u || n !== e;
            c = c || o.length > 0;
        }
        if (a || f) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n ||= {};
            if (a) {
                n && Es.call(n, Ss) && delete n[Ss];
                if (e && Es.call(e, Ss)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[Ss];
                }
                n.checked = a;
                const t = lf(null, "_chk", m, null, [ a ]);
                if (e && Es.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = bs(n, "q-e:input", t) || c;
                }
                c = bs(n, "q-e:input", t) || c;
            } else if (f) {
                n && Es.call(n, gs) && delete n[gs];
                if (e && Es.call(e, gs)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[gs];
                }
                n.value = f;
                const t = lf(null, "_val", $, null, [ f ]);
                if (e && Es.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = bs(n, "q-e:input", t) || c;
                }
                c = bs(n, "q-e:input", t) || c;
            }
        }
        if (n && Es.call(n, "className")) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n.class = n.className;
            n.className = void 0;
            c = !0;
            ce && me(`jsx${i ? ` ${i.fileName}${i?.lineNumber ? ":" + i.lineNumber : ""}` : ""}: \`className\` is deprecated. Use \`class\` instead.`);
        }
        if (e && Es.call(e, "className")) {
            if (!l) {
                e = {
                    ...e
                };
                l = !0;
            }
            e.class = e.className;
            e.className = void 0;
            ce && me(`jsx${i ? ` ${i.fileName}${i?.lineNumber ? ":" + i.lineNumber : ""}` : ""}: \`className\` is deprecated. Use \`class\` instead.`);
        }
    }
    if (n) {
        for (const t in n) {
            if (t === "children") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                s ||= n.children;
                delete n.children;
            } else if (t === "key") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                r ||= n.key;
                delete n.key;
            } else if (e && t in e) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            } else if (n[t] === null) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            }
        }
    }
    return new ws(t, n, e, s, o, r, c || !0, i);
};

const Ms = (t, n, e, s) => Is(t, n, s);

const As = (t, n, e, s, o) => Is(t, {
    ...e,
    ...n
}, o);

const Cs = (t, n, e, s, o, r) => Is(t, {
    ...e,
    ...n,
    children: s
}, r);

const Ns = t => t.children;

const Is = (t, n, e, s, o) => Ps(t, n, null, null, 0, e, o);

const js = Is;

const Os = Is;

function w(t, n, ...e) {
    const s = {
        children: arguments.length > 2 ? e.flat(100) : null
    };
    let o = null;
    for (const t in n) {
        t == "key" ? o = n[t] : s[t] = n[t];
    }
    return Ps(t, n, null, s.children, 0, o);
}

const Ls = t => t.children;

const Fs = (t, n) => new ws(Ns, null, null, t.children, 0, n);

const Ds = (t, n, e, s, o) => {
    const r = ne(t.It, e || n, t);
    if (e) {
        r.Ot = d(e, ":");
        r.$ = t;
    }
    let i;
    t.ensureProjectionResolved(n);
    let c = !1;
    s === null && (s = t.getHostProp(n, Ne));
    if (Pe(s)) {
        o = o || t.getHostProp(n, or) || Wi;
        "children" in o && delete o.children;
        i = s.getFn(r);
    } else if (gf(s)) {
        const t = s;
        i = () => te(r, t, [ o || Wi, null, 0 ]);
    } else {
        c = !0;
        const t = s;
        i = () => te(r, t, [ o || Wi ]);
    }
    const l = import.meta.env.TEST ? ui() : se;
    const u = (e = 0) => Sr(() => {
        if (!c) {
            t.setHostProp(n, ur, null);
            t.setHostProp(n, dr, null);
        }
        e > 0 && Co(n) && pn(t, n);
        return _r(i(o), t => _r(r.Lt, () => t));
    }, s => {
        if (l && !c) {
            const t = n;
            if (t.dirty & 4) {
                t.dirty &= -5;
                if (e < vr) {
                    return u(e + 1);
                }
            }
        }
        const o = t.getHostProp(n, hr);
        if (o) {
            return function r(t, n) {
                const e = S(t);
                let s = t;
                const o = "q-e:qvisible";
                return _r(e, t => {
                    const e = !t;
                    let r = null;
                    for (const i in n) {
                        if (Object.prototype.hasOwnProperty.call(n, i)) {
                            let c = t;
                            let l = i;
                            if (e) {
                                if (i !== o && !i.startsWith("q-d:") && !i.startsWith("q-w:")) {
                                    continue;
                                }
                                if (!r) {
                                    const [t, n] = _(s);
                                    s = n;
                                    r = t;
                                }
                                c = r;
                            }
                            if (c) {
                                c.type === "script" && i === o && (l = "q-d:qinit");
                                v(c, l, n[i]);
                            }
                        }
                    }
                    return s;
                });
            }(s, o);
        }
        return s;
    }, t => {
        if (gr(t) && e < vr) {
            return t.then(() => u(++e));
        }
        if (e >= vr) {
            throw Error("Max retry count of component execution reached");
        }
        throw t;
    });
    return u();
};

function v(t, n, e) {
    const s = t.constProps ||= {};
    const o = s[n];
    const r = e.qrls;
    o == null ? s[n] = r : Array.isArray(o) ? o.push(...r) : s[n] = [ o, ...r ];
    const i = t.varProps[n];
    if (i) {
        Array.isArray(o) ? o.push(...s[n]) : t.varProps[n] = [ o, ...r ];
        s[n] = void 0;
    }
    const c = e.capture;
    const l = e.preventdefault;
    const u = e.stoppropagation;
    if (!c && !l && !u) {
        return;
    }
    const [, f] = Pr(n);
    c && g(t, f, "capture");
    l && g(t, f, "preventdefault");
    u && g(t, f, "stoppropagation");
}

function g(t, n, e) {
    const s = `${e}:${n}`;
    const o = t.varProps;
    o === Wi && (t.varProps = {});
    t.varProps[s] = !0;
}

function S(t) {
    const n = [ t ];
    for (;n.length; ) {
        const t = n.shift();
        if (vs(t)) {
            if (typeof t.type === "string") {
                return t;
            }
            n.push(t.children);
        } else if (Ee(t)) {
            n.push(...t);
        } else {
            if (gr(t)) {
                return _r(t, t => S(t));
            }
            if (Jl(t)) {
                return S(t.untrackedValue);
            }
        }
    }
    return null;
}

function _(t) {
    if (vs(t)) {
        const n = k();
        if (t.type !== Ls && !gf(t.type)) {
            return [ n, qs(Ls, null, null, [ t, n ], 0, null) ];
        }
        t.children == null ? t.children = n : Ee(t.children) ? t.children.push(n) : t.children = [ t.children, n ];
        return [ n, t ];
    }
    if ((t => typeof t !== "object" && typeof t !== "function" || t === null || t === void 0)(t)) {
        const n = k();
        return [ n, qs(Ls, null, null, [ t, n ], 0, null) ];
    }
    if (Ee(t) && t.length > 0) {
        const [n, e] = _(t[0]);
        return [ n, t ];
    }
    return [ null, t ];
}

function k() {
    return new ws("script", null, {
        hidden: ""
    }, null, 0, null);
}

const zs = t => qs(Ns, null, {
    [Le]: ""
}, t.children, 0, t.name ?? "");

const Us = Symbol();

const Vs = () => null;

const Ws = () => null;

const Qs = t => t.children;

const Xs = (t, n) => Is(Fs, {
    children: Is(Bs, t)
}, n);

const Bs = () => null;

let Js = null;

let Hs = null;

function E(t, n, e, s) {
    if (e != null) {
        if (s) {
            const s = function o(t) {
                switch (t) {
                  case "xlink:href":
                  case "xlink:actuate":
                  case "xlink:arcrole":
                  case "xlink:role":
                  case "xlink:show":
                  case "xlink:title":
                  case "xlink:type":
                    return "http://www.w3.org/1999/xlink";

                  case "xml:base":
                  case "xml:lang":
                  case "xml:space":
                    return "http://www.w3.org/XML/1998/namespace";

                  default:
                    return null;
                }
            }(n);
            if (s) {
                ((t, n, e, s) => {
                    Hs || (Hs = t.setAttributeNS);
                    Hs.call(t, n, e, s);
                })(t, s, n, e);
                return;
            }
        }
        ((t, n, e) => {
            Js || (Js = t.setAttribute);
            Js.call(t, n, e);
        })(t, n, e);
    }
}

function x(t) {
    return !t.startsWith("q:") && !t.startsWith(":");
}

const Ys = (t, n = [], e = {}) => {
    let s = null;
    const o = t[Oi];
    if (o) {
        for (const t in o) {
            if (!n.includes(t)) {
                s ||= {};
                s[t] = o[t];
            }
        }
    }
    const r = e;
    const i = t[Li];
    for (const t in i) {
        n.includes(t) || (r[t] = i[t]);
    }
    return p(new ws(null, r, s, null, 0, null));
};

class Gs {
    target;
    constructor(t) {
        this.target = t;
    }
}

class Ks {
    target;
    constructor(t) {
        this.target = t;
    }
}

class Zs {
    target;
    text;
    constructor(t, n) {
        this.target = t;
        this.text = n;
    }
}

class to {
    target;
    parent;
    beforeTarget;
    constructor(t, n, e) {
        this.target = t;
        this.parent = n;
        this.beforeTarget = e;
    }
}

class no {
    target;
    attrName;
    attrValue;
    scopedStyleIdPrefix;
    isSvg;
    constructor(t, n, e, s, o) {
        this.target = t;
        this.attrName = n;
        this.attrValue = e;
        this.scopedStyleIdPrefix = s;
        this.isSvg = o;
    }
}

const eo = t => new Gs(t);

const ro = t => new Ks(t);

const io = (t, n) => new Zs(t, n);

const so = (t, n, e) => new to(t, n, e);

const oo = (t, n, e, s = null, o = !1) => new no(t, n, e, s, o);

const lo = () => {
    const t = Ic();
    const n = t.m;
    const e = n;
    let s = t.$.getHostProp(e, lr);
    if (s === null) {
        s = [];
        t.$.setHostProp(e, lr, s);
    }
    let o = t.$.getHostProp(e, ur);
    o === null && (o = 0);
    t.$.setHostProp(e, ur, o + 1);
    for (;s.length <= o; ) {
        s.push(void 0);
    }
    return {
        val: s[o],
        set: t => {
            ce && dc(t);
            return s[o] = t;
        },
        i: o,
        iCtx: t
    };
};

const uo = t => {
    const n = Re(t) && !gf(t) ? Zn(void 0, t) : t;
    return is(n);
};

const co = t => fo(uo, t);

const fo = (t, ...n) => {
    const {val: e, set: s} = lo();
    if (e != null) {
        return e;
    }
    t = Re(t) && !gf(t) ? Oc(t, ...n) : t;
    return s(t);
};

const ao = () => ({
    pending: is(0),
    version: is(0)
});

function R(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    const e = P(t.container, n);
    if (!e) {
        return;
    }
    const s = t.boundaries ||= [];
    if (!s.includes(e)) {
        s.push(e);
        e.pending.value++;
    }
}

function T(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return null;
    }
    return t.getHostProp(n, $r);
}

function q(t) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    zo(t, mr, null);
}

function P(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return null;
    }
    return function e(t) {
        if (!__EXPERIMENTAL__.suspense) {
            return null;
        }
        return Do(t, mr, null) || null;
    }(n) || T(t, n);
}

function M(t, n) {
    __EXPERIMENTAL__.suspense && zo(t, mr, n);
}

function A(t, n, e) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    M(n, e);
    const s = n.dirtyChildren;
    if (!s || s.length === 0) {
        return;
    }
    for (let n = 0; n < s.length; n++) {
        const o = s[n];
        A(t, o, T(t, o) || e);
    }
}

const ho = t => {
    if (t.En) {
        try {
            t.En();
        } catch (t) {
            ((t, ...n) => {
                we(!1, t, ...n);
            })(t);
        }
        t.En = null;
    }
};

function C(t, e, s, o) {
    if (!s.isConnected) {
        return;
    }
    o || (o = jc(e, s));
    const r = o.$;
    const i = o.m;
    Wo(r, i);
    let c = t;
    if (i.flags & 64) {
        let n;
        if (!(i.flags & 128)) {
            n = !0;
            i.flags |= 128;
        }
        const o = n ? r._ : null;
        const l = Do(i, cr, o);
        if (l !== null) {
            c = () => t(e, s, l);
        } else {
            const n = Do(i, fr, o);
            n !== null && (c = () => t(e, s, ...n));
        }
    }
    return n(() => {
        if (!(i.flags & 32)) {
            return te(o, c, [ e, s ]);
        }
    }, t => r.handleError(t, i));
}

function N(t, n) {
    if (!n.isConnected) {
        return;
    }
    const e = jc(t, n);
    typeof this === "string" && nf(ef(e.$, this));
    const s = tf[0];
    return C(s, t, n, e);
}

function I(t) {
    return t.k === t.R ? t.T : null;
}

function j(t) {
    return t.q || I(t);
}

function O(t, n) {
    const e = function s(t) {
        return t ? t.nextSibling : null;
    }(n);
    const o = I(t);
    return e === o ? null : e;
}

const po = Object.prototype.hasOwnProperty;

function L(t, n, e, s, o, r) {
    import.meta.env.TEST && o && zo(n, br, o);
    zo(n, e, r);
    on(t, oo(n.node, e, s, o, (n.flags & 512) !== 0));
}

function F(t, n, e, s) {
    return {
        $: t,
        M: n,
        N: e,
        j: s,
        O: [],
        L: [],
        D: [],
        k: null,
        q: null,
        U: null,
        T: null,
        R: null,
        W: null,
        X: null,
        B: null,
        J: null,
        H: null,
        Y: 0,
        G: 0,
        K: !0,
        Z: !1,
        tt: {
            nt: new $s({
                j: s,
                et: !0
            }),
            rt: new $s({
                j: s,
                et: !1
            })
        }
    };
}

function D(t, n, e, s, o) {
    const r = t ?? F(n, e, s, o);
    (function i(t, n, e, s, o) {
        t.$ = n;
        t.M = e;
        t.N = s;
        t.j = o;
        t.tt.nt.data.j = o;
        t.tt.rt.data.j = o;
        t.L.length = 0;
        t.D.length = 0;
    })(r, n, e, s, o);
    return r;
}

const $o = (t, n, e, s, o, r, i) => z(D(i, t, n, o, r), e, s);

const mo = (t, n, e, s, o, r, i, c, l = !1, u) => z(D(u, t, n, i, c), e, s, o, r, l);

function z(t, n, e, s = $l(e), o = null, r = !1) {
    U(t, n, e, s, o, r);
    const i = K(t);
    if (gr(i)) {
        return i.finally(() => {
            Z(t);
        });
    }
    Z(t);
}

function U(t, n, e, s = $l(e), o = null, r = !1) {
    const i = t.Z;
    t.Z = r || i;
    t.k = e;
    t.U = null;
    t.q = s;
    t.T = o;
    t.R = e;
    B(t, n, !0);
    try {
        if (t.k.flags & 32) {
            return;
        }
        for (;t.O.length; ) {
            for (;t.Y < t.G; ) {
                if (typeof t.H === "string") {
                    wt(t, t.H);
                } else if (typeof t.H === "number") {
                    wt(t, t.H + "");
                } else if (t.H && typeof t.H === "object") {
                    if (vs(t.H)) {
                        const n = t.H.type;
                        if (typeof n === "string") {
                            et(t);
                            ft(t, t.H, n);
                            const e = t.H.constProps && po.call(t.H.constProps, wr) || po.call(t.H.varProps, wr);
                            e ? t.U || tt(t, !1) : Q(t, t.H.children, !0);
                        } else if (typeof n === "function") {
                            if (n === Ls) {
                                et(t);
                                pt(t, "F", t.H.key);
                                Q(t, t.H.children, !0);
                            } else if (n === zs) {
                                et(t);
                                Y(t) || Q(t, t.H.children, !0);
                            } else if (n === gt) {
                                H(t);
                                Q(t, t.H.children, !0, !1);
                            } else if (n === Ws) {
                                nt(t);
                            } else if (n === Vs) {
                                nt(t);
                            } else {
                                et(t);
                                $t(t, n);
                            }
                        }
                    } else if (Array.isArray(t.H)) {
                        Q(t, t.H, !1);
                    } else if (Jl(t.H)) {
                        pt(t, "S", null);
                        const n = t.H instanceof ps ? t.H.it() : t.H;
                        const e = t.q?.[fi]?.get(".")?.backRef;
                        let s = e?.has(n);
                        e && n instanceof ps && (s = Tt(e, n));
                        if (!s) {
                            const e = t.U || t.q;
                            Q(t, V(t, () => Dc(n, e, ".", t.$)), !0);
                        }
                    } else if (gr(t.H)) {
                        pt(t, "A", null);
                        t.L.push(t.H, t.U || t.q);
                    }
                } else {
                    t.H === Us || wt(t, "");
                }
                W(t);
            }
            nt(t);
            G(t);
            X(t);
        }
    } finally {
        t.Z = i;
    }
}

function V(t, e) {
    try {
        return e();
    } catch (s) {
        if (gr(s)) {
            const o = s.then(() => n(e));
            t.L.push(o, t.U || t.q);
            return null;
        }
        throw s;
    }
}

function W(t) {
    if (!t.K) {
        t.K = !0;
        return;
    }
    t.Y++;
    if (t.Y < t.G) {
        t.H = t.J[t.Y];
    } else if (t.O.length > 0 && t.O[t.O.length - 1] === !1) {
        return X(t);
    }
    t.U !== null ? t.U = null : t.q = O(t, t.q);
}

function Q(t, n, e, s = !0) {
    if (s && (n == null || e && Ee(n) && n.length === 0)) {
        tt(t);
        return;
    }
    B(t, n, e);
    if (e) {
        const n = t.Z || !!t.U || !$l(t.q);
        t.Z = n;
        t.B = null;
        t.W = null;
        t.X = null;
        t.k = t.U || t.q;
        t.q = $l(t.k);
        t.U = null;
    }
    t.K = !1;
}

function X(t) {
    const n = t.O.pop();
    if (n) {
        t.Z = t.O.pop();
        t.B = t.O.pop();
        t.W = t.O.pop();
        t.X = t.O.pop();
        t.U = t.O.pop();
        t.q = t.O.pop();
        t.k = t.O.pop();
    }
    t.H = t.O.pop();
    t.G = t.O.pop();
    t.Y = t.O.pop();
    t.J = t.O.pop();
    W(t);
}

function B(t, n, e) {
    t.O.push(t.J, t.Y, t.G, t.H);
    e && t.O.push(t.k, t.q, t.U, t.X, t.W, t.B, t.Z);
    t.O.push(e);
    if (Array.isArray(n)) {
        t.Y = 0;
        t.G = n.length;
        t.J = n;
        t.H = t.G > 0 ? n[0] : null;
    } else if (n === void 0) {
        t.Y = 0;
        t.H = null;
        t.J = null;
        t.G = 0;
    } else {
        t.Y = 0;
        t.H = n;
        t.J = null;
        t.G = 1;
    }
}

function J(t) {
    if (t.U) {
        return j(t);
    }
    return O(t, t.q) || I(t);
}

function H(t) {
    const n = t.H;
    const e = n.key;
    t.q = Do(t.k, e, n => Jo(t.$.rootVNode, n));
    t.q = t.q && t.q.flags & 32 ? null : t.q;
    if (t.q == null) {
        t.U = Ao();
        zo(t.U, Oe, e);
        t.U.slotParent = t.k;
        zo(t.k, e, t.U);
    }
}

function Y(t) {
    const n = t.H;
    const e = Ul(t.k);
    const s = function o(t, n) {
        const e = t.H;
        const s = e.constProps;
        if (s && typeof s == "object" && po.call(s, "name")) {
            const e = s.name;
            if (n && e instanceof ps) {
                return Dc(e, n, ":", t.$);
            }
        }
        return Ji(e, "name") || "";
    }(t, e);
    const r = Ji(n, $r) || null;
    const i = e ? Do(e, s, null) : null;
    if (i == null) {
        t.U = Ao();
        zo(t.U, Oe, s);
        zo(t.U, $r, r);
        A(t.$, t.U, r);
        e && zo(e, s, t.U);
        ll(t.M, t.k, t.U, J(t));
        return !1;
    }
    if (i === t.q) {} else {
        const n = i.parent;
        t.U = i;
        zo(t.U, Oe, s);
        zo(t.U, $r, r);
        A(t.$, t.U, r);
        e && zo(e, s, t.U);
        ol(t.M, t.U);
        ll(t.M, t.k, t.U, J(t));
        n && No(n) && !n.firstChild && hl(n) === Ze && fl(t.M, n.parent, n, !0);
    }
    return !0;
}

function G(t) {
    const n = t.B;
    if (n) {
        for (const e of n.values()) {
            if (e.flags & 32) {
                continue;
            }
            kt(t.$, t.M, e, t.N);
            fl(t.M, t.k, e, !0);
        }
        n.clear();
        t.B = null;
    }
    t.q = null;
}

function K(t) {
    for (;t.L.length; ) {
        const n = t.L.shift();
        const e = t.L.shift();
        if (gr(n)) {
            return n.then(n => {
                U(t, n, e);
                return K(t);
            }).catch(n => {
                t.$.handleError(n, e);
                return K(t);
            });
        }
        U(t, n, e);
    }
    if (t.D.length) {
        const n = t.D.splice(0);
        return Promise.all(n).then(() => K(t));
    }
}

function Z(t) {
    t.M = null;
    t.N = null;
}

function tt(t, n = !0) {
    const e = t.q && $l(t.q);
    if (e !== null) {
        let s = e;
        for (;s; ) {
            kt(t.$, t.M, s, t.N);
            s = s.nextSibling;
        }
        al(t.M, t.q, e, n);
    }
}

function nt(t) {
    const n = I(t);
    if (t.q !== null && t.q !== n) {
        for (;t.q && t.q !== n; ) {
            const n = t.q;
            t.q = O(t, t.q);
            if (t.k === n.parent) {
                kt(t.$, t.M, n, t.N);
                fl(t.M, t.k, n, !0);
            }
        }
    }
}

function et(t) {
    if (t.q !== null && Oo(t.q)) {
        const n = t.q;
        t.q = O(t, t.q);
        fl(t.M, t.k, n, !0);
    }
}

function rt(t, n, e) {
    if (Jl(t)) {
        t.value = n;
        return !0;
    }
    if (typeof t === "function") {
        t(n);
        return !0;
    }
    if (t == null) {
        return !0;
    }
    throw Te(15, [ e ]);
}

function it(t, e, s, o, r) {
    return n(() => Dc(o, e, s, t, r));
}

function st(t, n, e, s, o) {
    const i = t.j;
    const c = s.then(t => E(n, e, r(e, t, i), o));
    t.D.push(c);
}

function ot(t, n) {
    if (n) {
        t.innerHTML = n + "";
        t.setAttribute(Ge, "html");
    }
}

function lt(t, n) {
    if (n && typeof n !== "string") {
        return !0;
    }
    t.value = function e(t) {
        let n = "";
        const e = t.length;
        let s = 0;
        let o = s;
        for (;s < e; s++) {
            const e = t.charCodeAt(s);
            if (e === 60) {
                n += t.substring(o, s) + "&lt;";
            } else if (e === 62) {
                n += t.substring(o, s) + "&gt;";
            } else if (e === 38) {
                n += t.substring(o, s) + "&amp;";
            } else if (e === 34) {
                n += t.substring(o, s) + "&quot;";
            } else {
                if (e !== 39) {
                    continue;
                }
                n += t.substring(o, s) + "&#39;";
            }
            o = s + 1;
        }
        return o === 0 ? t : n + t.substring(o);
    }(n || "");
    return !0;
}

function ut(t, n, e, o) {
    const i = function c(t, n) {
        const e = cl(t.k, !0);
        const o = s(e, n);
        const r = import.meta.env.TEST ? t.$.document : document;
        const i = o.elementNamespaceFlag === 0 ? r.createElement(n) : r.createElementNS(o.elementNamespace, n);
        t.U = qo(i, n);
        t.U.flags |= o.elementNamespaceFlag;
        return i;
    }(t, e);
    const l = t.U;
    const u = (l.flags & 512) !== 0;
    const {constProps: f} = n;
    if (f) {
        for (const n in f) {
            let s = f[n];
            if (Rr(n)) {
                ct(n, s, i, l, t);
                continue;
            }
            if (n === "ref" && rt(s, i, o)) {
                continue;
            }
            Jl(s) && (s = it(t.$, t.U, n, s, t.tt.nt));
            if (gr(s)) {
                st(t, i, n, s, u);
                continue;
            }
            if (n === wr) {
                ot(i, s);
                continue;
            }
            if (e === "textarea" && n === "value" && lt(i, s)) {
                continue;
            }
            E(i, n, r(n, s, t.j), u);
        }
    }
    const a = n.key;
    a && (t.U.key = a);
    if (t.j) {
        const e = po.call(n.varProps, "class") || n.constProps && po.call(n.constProps, "class");
        e || i.setAttribute("class", t.j);
    }
    nl(t.M, t.k, t.U, j(t));
}

function ct(t, n, e, s, o) {
    const r = t.slice(2);
    if (Array.isArray(n)) {
        const t = n;
        const s = [];
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            if (Array.isArray(e)) {
                for (let t = 0; t < e.length; t++) {
                    const n = e[t];
                    n && s.push(C.bind(null, n));
                }
            } else {
                e && s.push(C.bind(null, e));
            }
        }
        s.length > 0 && ((e._qDispatch ||= {})[r] = s.length === 1 ? s[0] : s);
    } else {
        n && ((e._qDispatch ||= {})[r] = C.bind(null, n));
    }
    t.charAt(2) !== "e" && Uo(o.M, s, t, "");
    (function i(t, n) {
        const e = import.meta.env.TEST ? t.$.document.defaultView : window;
        e && (e._qwikEv ||= []).push(n);
    })(o, r);
}

function ft(t, n, e) {
    if (t.Z) {
        ut(t, n, e, null);
    } else {
        const s = t.q && No(t.q);
        const o = s && e === hl(t.q);
        const r = n.key;
        const i = s && t.q.key;
        if (o && r === i) {
            ht(t, e, r);
        } else {
            const s = at(e, r);
            dt(t, e, r, s, t.k) && ut(t, n, e, null);
        }
    }
    const s = n.varProps;
    const o = t.U || t.q;
    s && function r(t, n, e, s) {
        t.Z || Wo(t.$, n);
        const o = n.props;
        for (const r in e) {
            const i = e[r];
            if (o && po.call(o, r)) {
                const e = o[r];
                if (i !== e) {
                    if (i instanceof ps && e instanceof ps && Rt(i, e)) {
                        continue;
                    }
                    yo(t, n, r, i, s);
                }
            } else {
                i != null && yo(t, n, r, i, s);
            }
        }
        if (o) {
            for (const r in o) {
                po.call(e, r) || r.charAt(0) === ":" || Rr(r) || yo(t, n, r, null, s);
            }
        }
    }(t, o, s, null);
}

const yo = (t, n, e, s, o) => {
    if (Rr(e)) {
        ct(e, s, n.node, n, t);
        return;
    }
    if (e === cr || e === fr) {
        zo(n, e, s);
        n.flags |= 192;
        return;
    }
    const r = s;
    if (e === "ref") {
        const t = n.node;
        if (rt(s, t, o)) {
            return;
        }
    }
    const i = n[fi]?.get(e);
    if (Jl(s)) {
        const o = s instanceof ps ? s.it() : s;
        if (i?.backRef?.has(o)) {
            return;
        }
        i && $n(t.$, i);
        const r = n;
        s = it(t.$, r, e, o, t.tt.rt);
    } else {
        i && $n(t.$, i);
    }
    if (gr(s)) {
        const o = n;
        const i = s.then(n => {
            L(t.M, o, e, n, t.j, r);
        });
        t.D.push(i);
        return;
    }
    L(t.M, n, e, s, t.j, r);
};

function at(t, n) {
    if (n == null) {
        return null;
    }
    return t ? t + ":" + n : n;
}

function ht(t, n, e) {
    const s = at(n, e);
    if (s && t.B?.has(s)) {
        t.B.delete(s);
        return !0;
    }
    return !1;
}

function dt(t, n, e, s, o, r) {
    t.U = function i(t, n, e) {
        let s = null;
        if (t.W === null) {
            const o = t.q;
            if (o) {
                const s = No(o) ? hl(o) : null;
                const r = bt(o) || vt(o, t.$._);
                if (r === e && s === n) {
                    return o;
                }
            }
            t.W = new Map;
            t.X = [];
            const r = I(t);
            let i = t.q;
            for (;i && i !== r; ) {
                const o = No(i) ? hl(i) : null;
                const r = bt(i) || vt(i, t.$._);
                s === null && r == e && o == n ? s = i : r === null ? t.X.push(o, i) : t.W.set(at(o, r), i);
                i = i.nextSibling;
            }
        } else if (e === null) {
            for (let e = 0; e < t.X.length; e += 2) {
                if (t.X[e] === n) {
                    s = t.X[e + 1];
                    t.X.splice(e, 2);
                    break;
                }
            }
        } else {
            const o = at(n, e);
            const r = t.W.get(o);
            if (r) {
                s = r;
                t.W.delete(o);
            }
        }
        (function o(t, n) {
            if (!n) {
                if (t.q) {
                    const n = No(t.q) ? hl(t.q) : null;
                    const e = bt(t.q) || vt(t.q, t.$._);
                    if (e != null) {
                        const s = at(n, e);
                        t.B ||= new Map;
                        t.B.set(s, t.q);
                        t.W?.delete(s);
                    }
                }
                return;
            }
            const e = I(t);
            let s = t.q;
            for (;s && s !== n && s !== e; ) {
                const n = No(s) ? hl(s) : null;
                const e = bt(s) || vt(s, t.$._);
                if (e != null) {
                    const o = at(n, e);
                    t.B ||= new Map;
                    t.B.set(o, s);
                    t.W?.delete(o);
                }
                s = s.nextSibling;
            }
        })(t, s);
        return s;
    }(t, n, e);
    if (t.U) {
        s || ll(t.M, o, t.U, j(t));
        t.q = t.U;
        t.U = null;
        return !1;
    }
    if (s != null) {
        const n = t.B?.get(s) || null;
        if (n) {
            t.B.delete(s);
            if (r && t.q) {
                const n = bt(t.q) || vt(t.q, t.$._);
                if (n != null) {
                    const e = No(t.q) ? hl(t.q) : null;
                    const s = at(e, n);
                    if (s != null) {
                        t.B ||= new Map;
                        t.B.set(s, t.q);
                    }
                }
            }
            n !== t.q && ll(t.M, o, n, j(t));
            t.q = n;
            t.U = null;
            return !1;
        }
    }
    return !0;
}

function pt(t, n, e) {
    const s = n === "F";
    const o = bt(t.q);
    const r = t.q && Lo(t.q);
    const i = r && o === e && (!s || !!e);
    if (i) {
        ht(t, null, o);
        return;
    }
    if (e === null || t.Z) {
        el(t.M, t.k, t.U = Ao(), J(t));
        t.U.key = e;
        return;
    }
    if (dt(t, null, e, at(null, e), t.k, !0)) {
        el(t.M, t.k, t.U = Ao(), J(t));
        t.U.key = e;
    }
}

function $t(t, n) {
    const e = n[vf];
    let s = t.U || t.q;
    const o = t.H;
    if (e) {
        const n = o.props;
        let r = !1;
        const [i] = e;
        const c = i.st;
        const l = vt(s, t.$._);
        const u = o.key || c;
        const f = bt(s) || l;
        const a = u === f;
        const h = c === l;
        if (a) {
            if (h) {
                ht(t, null, u);
            } else {
                mt(t, s, i, n);
                s = t.U;
                r = !0;
            }
        } else {
            if (dt(t, null, u, u, t.k)) {
                mt(t, s, i, n);
                r = !0;
            }
            s = t.U || t.q;
        }
        if (s) {
            const e = Do(s, or, t.$._);
            if (!r) {
                const c = function l(t, n, e, s) {
                    let o = !1;
                    if (e) {
                        const t = St(n[Oi], e[Oi], e[Di], s, !1);
                        o ||= t;
                        const r = St(n[Li], e[Li], e[Di], s, !0);
                        o ||= r;
                        e[Fi] = n[Fi];
                    } else if (n) {
                        zo(t, or, n);
                        e = n;
                    }
                    return o;
                }(s, n, e, t.$);
                if (c && o.key == null) {
                    mt(t, s, i, n);
                    s = t.U;
                    r = !0;
                }
                r ||= c;
            }
            if (r) {
                zo(s, Ne, i);
                s.flags &= -33;
                sn(t.$, s, 4, t.N);
            }
        }
        (function d(t, n, e) {
            const s = Array.isArray(n) ? n : [ n ];
            const o = t => new ws(gt, null, null, [], 0, t);
            const r = [];
            if (e) {
                const t = e.props;
                if (t) {
                    for (const n in t) {
                        if (x(n)) {
                            const t = n;
                            ve(r, t, o(t), 0);
                        }
                    }
                }
            }
            if (r.length === 0 && n == null) {
                return;
            }
            for (let t = 0; t < s.length; t++) {
                const n = s[t];
                const e = (vs(n) && Ji(n, Oe) || "") + "";
                const i = be(r, e, 0);
                let c;
                i >= 0 ? c = r[i + 1] : r.splice(~i, 0, e, c = o(e));
                const l = n === !1;
                l || c.children.push(n);
            }
            for (let t = r.length - 2; t >= 0; t -= 2) {
                r.splice(t, 1);
            }
            Q(t, r, !0);
        })(t, o.children, s);
    } else {
        const e = o.key;
        const r = bt(s);
        const i = e === r;
        const c = vt(s, t.$._);
        const l = c == null;
        if (s && !l || !s) {
            yt(t);
            s = t.U;
        } else if (i) {
            ht(t, null, e);
        } else {
            dt(t, null, e, e, t.k) && yt(t);
            s = t.U || t.q;
        }
        if (s) {
            let e = s;
            for (;e && (!Lo(e) || Do(e, Ne, null) === null); ) {
                e = e.parent || Ul(e);
            }
            const r = Ds(t.$, s, e || t.$.rootVNode, n, o.props);
            t.L.push(r, s);
        }
    }
}

function mt(t, n, e, s) {
    n && pn(t.$, n);
    el(t.M, t.k, t.U = Ao(), J(t));
    const o = t.H;
    zo(t.U, Ne, e);
    zo(t.U, or, s);
    t.U.key = o.key;
}

function yt(t) {
    el(t.M, t.k, t.U = Ao(), J(t));
    const n = t.H;
    zo(t.U, or, n.props);
    n.key && (t.U.key = n.key);
}

function wt(t, n) {
    if (t.q !== null) {
        const e = Dl(t.q);
        if (e === 3) {
            if (n !== dl(t.q)) {
                pl(t.M, t.q, n);
                return;
            }
            return;
        }
    }
    nl(t.M, t.k, t.U = Mo((import.meta.env.TEST ? t.$.document : document).createTextNode(n), n), j(t));
}

function bt(t) {
    if (t == null || Oo(t)) {
        return null;
    }
    return t.key;
}

function vt(t, n) {
    if (t == null || Oo(t)) {
        return null;
    }
    const e = Do(t, Ne, n);
    return e ? e.st : null;
}

function gt() {}

function St(t, n, e, s, o = !0) {
    if (_t(t) && _t(n)) {
        return !1;
    }
    e.$ = s;
    let r = !1;
    if (t) {
        for (const s in t) {
            if (s === "children" || s === We) {
                continue;
            }
            if (!n || t[s] !== n[s]) {
                if (!o) {
                    return !0;
                }
                {
                    n && (n[s] = t[s]);
                    const o = Bi(e, s);
                    o || (r = !0);
                }
            }
        }
    }
    if (n) {
        for (const s in n) {
            if (s === "children" || s === We) {
                continue;
            }
            if ((!t || !po.call(t, s)) && o) {
                delete n[s];
                const t = Bi(e, s);
                t || (r = !0);
            }
        }
    }
    return r;
}

function _t(t) {
    if (!t) {
        return !0;
    }
    return ti(t);
}

function kt(t, n, e, s = null) {
    let o = e;
    if (Oo(e)) {
        xt(o);
        return;
    }
    let r = null;
    for (;;) {
        const i = o.flags;
        if (i & 3) {
            pn(t, o);
            xt(o);
            const r = i & 2 && Do(o, Ne, null) !== null;
            if (r) {
                const e = t.getHostProp(o, lr);
                if (e) {
                    for (let n = 0; n < e.length; n++) {
                        const r = e[n];
                        if (ke(r)) {
                            const n = Xl(r);
                            if (n && r.h & 1) {
                                r.h |= 16;
                                sn(t, o, 64, s);
                                continue;
                            }
                            (r instanceof Ci || uu(r)) && pn(t, r);
                            (n || r instanceof ji) && ho(r);
                        }
                    }
                }
                const r = o.props;
                if (r) {
                    const e = Object.keys(r);
                    for (let o = 0; o < e.length; o++) {
                        const i = e[o];
                        if (x(i)) {
                            const e = r[i];
                            if (e) {
                                r[i] = null;
                                const o = typeof e === "string" ? Jo(t.rootVNode, e) : e;
                                let c = $l(o);
                                for (;c; ) {
                                    kt(t, n, c, s);
                                    c = c.nextSibling;
                                }
                                Et(n, o);
                            }
                        }
                    }
                }
            }
            const c = Fo(o);
            if (c) {
                if (o === e) {
                    const t = $l(o);
                    if (t) {
                        cn(t, () => {});
                        return;
                    }
                }
            } else {
                const t = $l(o);
                if (t) {
                    o = t;
                    continue;
                }
            }
        } else {
            i & 4 && xt(o);
        }
        if (o === e) {
            return;
        }
        const c = o.nextSibling;
        if (c) {
            o = c;
            continue;
        }
        r = o.parent;
        for (;r; ) {
            if (r === e) {
                return;
            }
            const t = r.nextSibling;
            if (t) {
                o = t;
                break;
            }
            r = r.parent;
        }
        if (r == null) {
            return;
        }
    }
}

function Et(t, n) {
    const e = n.parent;
    if (e) {
        const s = e.flags;
        s & 1 && hl(e) === Ze && fl(t, e, n, !0);
    }
}

function xt(t) {
    t.flags |= 32;
}

function Rt(t, n) {
    if (t === n) {
        return !0;
    }
    return n.ot === t.ot && function e(t, n) {
        if (t === n) {
            return !0;
        }
        if (!t || !n || t.length !== n.length) {
            return !1;
        }
        for (let e = 0; e < t.length; e++) {
            if (t[e] !== n[e]) {
                return !1;
            }
        }
        return !0;
    }(n.lt, t.lt);
}

function Tt(t, n) {
    if (!(n instanceof ps)) {
        return !1;
    }
    for (let e = 0; e < t.length; e++) {
        const s = t[e];
        if (s instanceof ps && Rt(s, n)) {
            return !0;
        }
    }
    return !1;
}

function qt(t, n, e, s) {
    const o = s(t, n);
    o.key = e;
    return o;
}

function Pt(t, n, e, s, o, r) {
    const i = Array(r - o + 1);
    for (let c = o; c <= r; c++) {
        const r = n[c] ?? (n[c] = e(t[c], c));
        i[c - o] = qt(t[c], c, r, s);
    }
    return i;
}

function Mt(t, n, e) {
    let s = n ? n.previousSibling : t.lastChild;
    for (let t = 1; t < e && s; t++) {
        s = s.previousSibling;
    }
    return s;
}

function At(t, n, e, s, o, r, i) {
    const c = t;
    const l = o.length;
    const u = $l(e);
    const f = F(c, n, s, null);
    const a = Array(l);
    if (u === null) {
        if (l > 0) {
            return mo(c, n, Pt(o, a, r, i, 0, l - 1), e, null, null, s, null, !0, f);
        }
        return;
    }
    if (l === 0) {
        al(n, e, u, !0);
        return;
    }
    let h = 0;
    let d = l - 1;
    let p = u;
    for (;p && h <= d && p.key === (a[h] ??= r(o[h], h)); ) {
        p = p.nextSibling;
        h++;
    }
    if (p === null) {
        if (h > d) {
            return;
        }
        return mo(c, n, Pt(o, a, r, i, h, d), e, null, null, s, null, !0, f);
    }
    if (h > d) {
        al(n, e, p, !0);
        return;
    }
    const $ = p.previousSibling;
    let m = e.lastChild;
    for (;m !== $ && d >= h && m.key === (a[d] ??= r(o[d], d)); ) {
        m = m.previousSibling;
        d--;
    }
    const y = m ? m.nextSibling : p;
    if (h > d) {
        let t = p;
        for (;t && t !== y; ) {
            const s = t.nextSibling;
            fl(n, e, t, !0);
            t = s;
        }
        return;
    }
    if (m === $) {
        const t = y;
        return mo(c, n, Pt(o, a, r, i, h, d), e, t, t, s, null, !0, f);
    }
    for (let t = h; t <= d; t++) {
        a[t] ??= r(o[t], t);
    }
    const w = d - h + 1;
    const b = new Map;
    for (let t = h; t <= d; t++) {
        b.set(a[t], t - h);
    }
    const v = function g(t, n = null) {
        const e = [];
        let s = t;
        for (;s; ) {
            e.push(s);
            if (s === n) {
                break;
            }
            s = s.nextSibling;
        }
        return e;
    }(p, m);
    const S = [];
    const k = new Map;
    for (let t = 0; t < v.length; t++) {
        const s = v[t];
        const o = s.key;
        if (b.has(o)) {
            k.set(o, S.length);
            S.push(s);
        } else {
            fl(n, e, s, !0);
        }
    }
    const _ = new Int32Array(w);
    _.fill(-1);
    const E = [];
    const x = [];
    for (let t = 0; t < w; t++) {
        const n = k.get(a[h + t]);
        if (n !== void 0) {
            _[t] = n;
            x.push(t);
            E.push(n);
        }
    }
    const R = new Uint8Array(w);
    const T = function q(t) {
        const n = t.length;
        if (n === 0) {
            return [];
        }
        const e = [];
        const s = Array(n).fill(-1);
        for (let o = 0; o < n; o++) {
            const n = t[o];
            let r = 0;
            let i = e.length;
            for (;r < i; ) {
                const s = r + i >> 1;
                t[e[s]] < n ? r = s + 1 : i = s;
            }
            r > 0 && (s[o] = e[r - 1]);
            r === e.length ? e.push(o) : e[r] = o;
        }
        const o = [];
        let r = e[e.length - 1];
        for (;r !== -1; ) {
            o.push(r);
            r = s[r];
        }
        o.reverse();
        return o;
    }(E);
    for (let t = 0; t < T.length; t++) {
        R[x[T[t]]] = 1;
    }
    let P = d;
    let M = y;
    const A = () => {
        for (;P >= h; ) {
            const t = P - h;
            if (R[t] === 1) {
                M = S[_[t]];
                P--;
                continue;
            }
            const r = _[t];
            if (r !== -1) {
                const t = S[r];
                const s = M === null ? e.lastChild === t : t.nextSibling === M;
                s || ll(n, e, t, M);
                M = t;
                P--;
                continue;
            }
            let l = P;
            for (;l > h; ) {
                const t = l - 1 - h;
                if (R[t] === 1 || _[t] !== -1) {
                    break;
                }
                l--;
            }
            const u = P - l + 1;
            const d = mo(c, n, Pt(o, a, null, i, l, P), e, M, M, s, null, !0, f);
            return _r(d, () => {
                const t = Mt(e, M, u);
                M = t;
                P = l - 1;
                return A();
            });
        }
    };
    return A();
}

function Ct(t, n, e) {
    t.dirty &= -2;
    const s = n.getHostProp(t, lr);
    if (!s || s.length === 0) {
        return;
    }
    let o;
    for (let r = 0; r < s.length; r++) {
        const i = s[r];
        if (i instanceof Ql) {
            const s = i;
            if (!(s.h & 4)) {
                continue;
            }
            if (s.h & 1) {
                (e.afterFlushTasks ||= []).push(s);
            } else {
                const r = !!(s.h & 8);
                const i = Wl(s, n, t);
                gr(i) && (r ? o = o ? o.then(() => i) : i : (e.extraPromises ||= []).push(i));
            }
        }
    }
    return o;
}

function Nt(t, n) {
    const e = t.props ||= {};
    e[ki] = n;
}

function It(t, n) {
    const e = t.props ||= {};
    e[Ei] = n;
}

function jt(t, n) {
    t.dirty &= -257;
    const e = function s(t) {
        const n = t.props;
        return n?.[Ei] ?? null;
    }(t);
    if (!e) {
        return;
    }
    It(t, null);
    const o = t;
    const r = o.parent;
    const i = o.nextSibling;
    const c = Zo(n, document, o, e);
    const l = No(o) && r || o;
    const u = l === o ? null : i;
    nl(n, l, c, u);
    t.dirty &= -33;
    t.dirtyChildren = null;
}

function Ot(t, n, e, s) {
    t.dirty &= -3;
    const o = t;
    let r = function i(t) {
        const n = t.props;
        return n?.[ki];
    }(t);
    if (!r) {
        return;
    }
    Nt(t, null);
    Jl(r) && (r = r.value);
    return $o(n, e, r, o, s, null);
}

function Lt(t, e, s, o) {
    t.dirty &= -5;
    const r = t;
    const i = e.getHostProp(r, Ne);
    if (!i) {
        return;
    }
    const c = e.getHostProp(r, or) || null;
    const l = Sr(() => Ds(e, r, r, i, c), t => {
        const i = e.getHostProp(r, Ue);
        return n(() => $o(e, s, t, r, o, xr(i)));
    }, t => {
        e.handleError(t, r);
    });
    if (gr(l)) {
        return l;
    }
    return;
}

function Ft(t, n, e, s, o, r = null) {
    n.push(oo(t.node, e, s, r, (t.flags & 512) !== 0));
    o || (t.props && s == null ? delete t.props[e] : (t.props ||= {})[e] = s);
}

function Dt(t, n) {
    t.dirty &= -9;
    if (!(t.flags & 1)) {
        return;
    }
    const e = function s(t) {
        const n = t.props ||= {};
        return n[_i] ?? null;
    }(t);
    if (!e || e.size === 0) {
        return;
    }
    const o = t;
    for (const [t, s] of e.entries()) {
        let e = s.value;
        Jl(e) && (e = e.value);
        const r = s.isConst;
        Ft(o, n, t, e, r, s.scopedStyleIdPrefix);
    }
    (function r(t) {
        const n = t.props ||= {};
        delete n[_i];
    })(t);
}

function zt(t, n) {
    t.dirty &= -65;
    const e = n.getHostProp(t, lr);
    if (!e || e.length === 0) {
        return;
    }
    for (let t = 0; t < e.length; t++) {
        const n = e[t];
        if (n instanceof Ql && n.h & 16) {
            n.h &= -17;
            const t = n;
            ho(t);
        }
    }
}

function Ut(t, e) {
    t.dirty &= -17;
    const s = e.getHostProp(t, xi);
    if (!s) {
        return;
    }
    const o = s.ut;
    const r = ee();
    r.$ = e;
    return _r(n(() => Zn.call(s, r, s.p)), () => {
        if (s.h & 2) {
            s.h &= -3;
            return Kl(e, s, o);
        }
    });
}

function Vt(t, n, e, s) {
    t.dirty &= -129;
    const o = t;
    const r = n.getHostProp(o, or) || null;
    if (!r) {
        return;
    }
    let i = Hi(r, "items");
    Jl(i) && (i = Oc(i));
    const c = Hi(r, "key$");
    const l = Hi(r, "item$");
    const u = c.resolved;
    const f = l.resolved;
    if (u !== void 0 && f !== void 0) {
        return At(n, e, o, s, i, u, f);
    }
    return _r(c.resolve(), t => _r(l.resolve(), r => At(n, e, o, s, i, t, r)));
}

let wo = null;

const bo = (t, n, e) => {
    wo || (wo = t.insertBefore);
    wo.call(t, n, e);
};

function Wt(t) {
    let n = null;
    let e = null;
    let s = null;
    const o = new Set;
    const i = () => {
        if (s) {
            if (s.length === 1) {
                bo(n, s[0], e);
            } else {
                const t = n.ownerDocument || n;
                const o = t.createDocumentFragment();
                for (let t = 0; t < s.length; t++) {
                    o.appendChild(s[t]);
                }
                bo(n, o, e);
            }
            s = null;
            n = null;
            e = null;
            o.clear();
        }
    };
    for (let c = 0; c < t.length; c++) {
        const l = t[c];
        if (l instanceof to) {
            if (n === l.parent && e === l.beforeTarget) {
                s || (s = []);
                s.push(l.target);
                o.add(l.target);
                continue;
            }
            if (!s) {
                n = l.parent;
                e = l.beforeTarget;
                s = [ l.target ];
                o.add(l.target);
                continue;
            }
            if (n === l.parent) {
                i();
                n = l.parent;
                e = l.beforeTarget;
                s = [ l.target ];
                o.add(l.target);
                continue;
            }
            if (o.has(l.target) || e && l.target === e || n && l.target === n) {
                i();
                n = l.parent;
                e = l.beforeTarget;
                s = [ l.target ];
                o.add(l.target);
                continue;
            }
            bo(l.parent, l.target, l.beforeTarget);
            continue;
        }
        if (l instanceof Gs) {
            (o.has(l.target) || e && l.target === e || n && l.target === n) && i();
            l.target.remove();
            continue;
        }
        if (l instanceof Ks) {
            (o.has(l.target) || e && l.target === e || n && l.target === n) && i();
            const t = l.target;
            t.textContent = "";
            continue;
        }
        if (l instanceof Zs) {
            l.target.nodeValue = l.text;
        } else if (l instanceof no) {
            const t = l.target;
            const e = l.attrName;
            const s = l.attrValue;
            const o = s != null ? r(e, s, l.scopedStyleIdPrefix) : null;
            const c = o == null || o === !1;
            if (vo(t, e)) {
                t[e] = go(o);
            } else if (e === wr) {
                n === t && i();
                t.innerHTML = o;
                t.setAttribute(Ge, "html");
            } else {
                c ? t.removeAttribute(e) : e === "value" && e in t ? t.value = o : E(t, e, o, l.isSvg);
            }
        }
    }
    i();
}

const vo = (t, n) => {
    const e = n == "allowfullscreen" || n == "async" || n == "autofocus" || n == "autoplay" || n == "checked" || n == "controls" || n == "default" || n == "defer" || n == "disabled" || n == "formnovalidate" || n == "inert" || n == "ismap" || n == "itemscope" || n == "loop" || n == "multiple" || n == "muted" || n == "nomodule" || n == "novalidate" || n == "open" || n == "playsinline" || n == "readonly" || n == "required" || n == "reversed" || n == "selected";
    return e && n in t;
};

const go = t => {
    if (t === "false") {
        return !1;
    }
    return !!t;
};

const So = (t => () => queueMicrotask(t))(Bt);

const ko = jr(Bt);

let Eo = !1;

function Qt() {
    if (!Eo) {
        Eo = !0;
        So();
    }
}

function Xt() {
    if (!Eo) {
        Eo = !0;
        ko();
    }
}

function Bt() {
    Eo = !1;
    const t = performance.now();
    const n = t + 15;
    let e = null;
    for (;e = l(); ) {
        if (Jt(e, n)) {
            Xt();
            return;
        }
    }
}

function Jt(t, n) {
    const e = import.meta.env.TEST ? ui() : se;
    const s = h(t);
    const o = s.promise;
    if (o) {
        return;
    }
    const r = s.container;
    if (!t.dirty) {
        Ht(r, t, s, e);
        return;
    }
    const i = s.journal ||= [];
    let l = null;
    for (;l = s.position; ) {
        if (s.promise) {
            return;
        }
        if (!(l.dirty & 511)) {
            __EXPERIMENTAL__.suspense && q(l);
            a(r, s, Kt(l, t, r));
            continue;
        }
        if (l.flags & 32) {
            if (l.dirty & 64) {
                zt(l, r);
            } else if (l.dirty & 32) {
                const n = Gt(r, s, l, t);
                if (n !== null) {
                    l = n;
                    continue;
                }
            }
            l.dirty &= -512;
            a(r, s, Kt(l, t, r));
            continue;
        }
        let e;
        try {
            if (l.dirty & 1) {
                e = Ct(l, r, s);
            } else if (l.dirty & 2) {
                e = Ot(l, r, i, t);
            } else if (l.dirty & 4) {
                e = Lt(l, r, i, t);
            } else if (l.dirty & 128) {
                e = Vt(l, r, i, t);
            } else if (l.dirty & 8) {
                Dt(l, i);
            } else if (l.dirty & 16) {
                e = Ut(l, r);
            } else if (l.dirty & 32) {
                const n = Gt(r, s, l, t);
                if (n !== null) {
                    l = n;
                    continue;
                }
            } else {
                l.dirty & 256 && jt(l, i);
            }
        } catch (t) {
            r.handleError(t, l);
        }
        if (e && gr(e)) {
            R(s, l);
            s.promise = e;
            u(t, r);
            const n = l;
            e.catch(t => {
                r.handleError(t, n);
            }).finally(() => {
                s.promise = null;
                c(t, r);
                Qt();
            });
            return;
        }
        if (performance.now() >= n) {
            return !0;
        }
    }
    Ht(r, t, s, e);
}

function Ht(t, n, e, s) {
    if (!(n.dirty & 511)) {
        f(n, t);
        s || function o(t, n) {
            const e = h(t);
            const s = e.journal;
            if (s && s.length > 0) {
                Wt(s);
                e.journal = null;
            }
            (function o(t, n) {
                const e = n.afterFlushTasks;
                if (!e || e.length === 0) {
                    n.afterFlushTasks = null;
                    return;
                }
                let s;
                for (let n = 0; n < e.length; n++) {
                    const o = e[n];
                    const r = Wl(o, t, o.ct);
                    gr(r) && (s = s ? s.then(() => r) : r);
                }
                s && (n.extraPromises ||= []).push(s);
                n.afterFlushTasks = null;
            })(n, e);
        }(n, t);
        (function r(t) {
            if (!__EXPERIMENTAL__.suspense) {
                return;
            }
            const n = t.boundaries;
            if (!n) {
                return;
            }
            t.boundaries = null;
            for (let t = 0; t < n.length; t++) {
                const e = n[t];
                e.pending.value = Math.max(0, e.pending.value - 1);
                e.version.value++;
            }
        })(e);
        if (e.extraPromises) {
            Promise.all(e.extraPromises).then(() => {
                Yt(t);
            });
            return;
        }
        Yt(t);
    }
}

function Yt(t) {
    t.ft();
}

function Gt(t, n, e, s) {
    const o = e.dirtyChildren;
    if (!o || o.length === 0) {
        e.dirty &= -33;
        q(e);
        return null;
    }
    (function r(t, n) {
        let e = 0;
        for (let s = 0; s < t.length; s++) {
            const o = t[s];
            if (o.parent === n) {
                if (e !== s) {
                    const n = t[e];
                    t[e] = o;
                    t[s] = n;
                }
                e++;
            }
        }
    })(o, e);
    e.nextDirtyChildIndex = 0;
    const i = Kt(o[0], s, t);
    a(t, n, i);
    return i;
}

function Kt(t, n, e) {
    if (t === n) {
        if (n.dirty & 511) {
            return n;
        }
        return null;
    }
    let s = null;
    t.slotParent && t.slotParent.dirty & 32 ? s = t.slotParent : t.parent && t.parent.dirty & 32 && (s = t.parent);
    if (!s) {
        if (n.dirty & 511) {
            return n;
        }
        return null;
    }
    const o = s.dirtyChildren;
    let r = s.nextDirtyChildIndex;
    const i = o.length;
    let c = i;
    for (;c-- > 0; ) {
        const t = o[r];
        if (t.dirty & 511) {
            if (e && Zt(e, t)) {
                r++;
                r === i && (r = 0);
                continue;
            }
            s.nextDirtyChildIndex = (r + 1) % i;
            return t;
        }
        r++;
        r === i && (r = 0);
    }
    s.dirty &= -33;
    s.dirtyChildren = null;
    s.nextDirtyChildIndex = 0;
    __EXPERIMENTAL__.suspense && q(s);
    return Kt(s, n, e);
}

function Zt(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return !1;
    }
    if (!n.props || !($r in n.props) || !t.getHostProp(n, $r)) {
        return !1;
    }
    nn(n) || tn(t, n, 0);
    return !0;
}

function tn(t, n, e) {
    const s = {
        afterFlushTasks: null,
        extraPromises: null,
        journal: null,
        container: t,
        position: n,
        priority: e,
        promise: null,
        boundaries: null
    };
    (function r(t, n) {
        Si.set(t, n);
    })(n, s);
    const i = n;
    i.flags |= 256;
    o(t, i);
    Qt();
    return i;
}

function nn(t) {
    return (t.flags & 256) !== 0;
}

function en(t, n) {
    if (!(n.flags & 1)) {
        n.dirty & 8 && function e(t, n) {
            n.dirty &= -9;
            const e = n.getProp(_i);
            if (!e || e.size === 0) {
                return;
            }
            for (const [s, o] of e.entries()) {
                let e = o.value;
                Jl(e) && (e = e.value);
                const i = r(s, e, o.scopedStyleIdPrefix);
                t.addBackpatchEntry(n.id, s, i);
            }
        }(t, n);
        n.dirty & 16 && Ut(n, t);
        if (n.dirty & 511) {
            const t = `A chore was scheduled on a host element that has already been streamed to the client.\n        This can lead to inconsistencies between Server-Side Rendering (SSR) and Client-Side Rendering (CSR).\n        \n        Problematic chore:\n          - Host: ${"" + n}\n          - Nearest element location: ${n.currentFile}\n        \n        This is often caused by modifying a signal in an already rendered component during SSR.`;
            ye(t);
        }
        n.dirty &= -512;
        return;
    }
    let e = null;
    if (n.dirty & 1) {
        const s = function o(t, n) {
            n.dirty &= -2;
            const e = n.getProp(lr);
            if (!e || e.length === 0) {
                return null;
            }
            let s = null;
            for (let o = 0; o < e.length; o++) {
                const r = e[o];
                if (r instanceof Ql) {
                    const e = r;
                    if (!(e.h & 4)) {
                        continue;
                    }
                    const o = Wl(e, t, n);
                    s = s ? s.then(() => o) : o;
                }
            }
            return s;
        }(t, n);
        gr(s) && (e = s);
    }
    if (n.dirty & 128) {
        const s = async function o(t, n) {
            n.dirty &= -129;
            const e = n;
            const s = t.getHostProp(e, or) || null;
            if (!s) {
                return;
            }
            let o = Hi(s, "items");
            Jl(o) && (o = Oc(o));
            const r = await Hi(s, "key$").resolve();
            const i = await Hi(s, "item$").resolve();
            const c = [];
            for (let t = 0; t < o.length; t++) {
                const n = o[t];
                const e = i(n, t);
                const s = r(n, t);
                e.key = s;
                c.push(e);
            }
            await t.renderJSX(c, {
                currentStyleScoped: null,
                parentComponentFrame: t.getComponentFrame(0)
            });
        }(t, n);
        e = e ? e.then(() => s) : s;
    }
    n.dirty &= -508;
    if (e) {
        return e;
    }
}

const xo = [];

function rn(t) {
    for (let n = 0; n < xo.length; n++) {
        const e = xo[n];
        const s = xo[n + 1] || t;
        s.dirty |= 32;
        s.dirtyChildren ||= [];
        s.dirtyChildren.includes(e) || s.dirtyChildren.push(e);
    }
}

function sn(t, n, e, s = null) {
    const o = n.dirty;
    n.dirty |= e;
    if (function r() {
        return import.meta.env.TEST ? ui() : se;
    }()) {
        const e = en(t, n);
        gr(e) && (t.l = t.l ? t.l.then(() => e) : e);
        return;
    }
    const i = e & 511;
    if ((i ? o & 511 : o) || n === s) {
        return;
    }
    const c = n.slotParent || n.parent;
    if (s && i && c && !c.dirty) {
        (function e(t, n, s) {
            xo.push(n);
            let o = T(t, n);
            let r = n.slotParent || n.parent;
            for (;r; ) {
                const e = r.dirty & 511;
                const i = nn(r);
                __EXPERIMENTAL__.suspense && (o ||= T(t, r) || (e ? P(t, r) : null));
                if (r === s || e) {
                    M(n, o);
                    rn(r);
                    if (i) {
                        const t = h(r);
                        t.position !== r && (t.position = n);
                    }
                    xo.length = 0;
                    return;
                }
                if (i) {
                    const t = h(r);
                    t.position !== r && (t.position = n);
                }
                xo.push(r);
                r = r.slotParent || r.parent;
            }
            xo.length = 0;
            ((t, ...n) => {
                const e = we(!1, t, ...n);
                debugger;
                throw e;
            })("Cursor root not found in current path!");
        })(t, n, s);
        return;
    }
    if (c && c.dirty & 511) {
        M(n, T(t, n) || P(t, c));
        i && (c.dirty |= 32);
        c.dirtyChildren ||= [];
        c.dirtyChildren.includes(n) || c.dirtyChildren.push(n);
        if (i && n.dirtyChildren) {
            const t = function e(t) {
                for (;t; ) {
                    if (nn(t)) {
                        return t;
                    }
                    t = t.parent || t.slotParent;
                }
                return null;
            }(n);
            if (t) {
                const e = h(t);
                let s = e.position;
                if (s) {
                    for (;s !== t; ) {
                        s = s.slotParent || s.parent;
                        if (s === n) {
                            e.position = n;
                            break;
                        }
                    }
                }
            }
        }
    } else {
        nn(n) ? M(n, T(t, n)) : function l(t, n) {
            xo.push(n);
            let e = __EXPERIMENTAL__.suspense ? T(t, n) : null;
            let s = n.slotParent || n.parent;
            for (;s; ) {
                const o = nn(s);
                __EXPERIMENTAL__.suspense && (e ||= T(t, s) || (o ? P(t, s) : null));
                if (o) {
                    M(n, e);
                    rn(s);
                    xo.length = 0;
                    return !0;
                }
                xo.push(s);
                s = s.slotParent || s.parent;
            }
            M(n, e);
            xo.length = 0;
            return !1;
        }(t, n) || tn(t, n, 0);
    }
}

function on(t, n) {
    t.push(n);
}

const Ro = (t, n) => {
    let e;
    for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
        t = Object.getPrototypeOf(t);
    }
    return e || function() {
        return this[n];
    };
};

const To = t => {
    let n = null;
    return e => {
        n || (n = Ro(e, t));
        return n.call(e);
    };
};

const qo = (t, n, e = null) => {
    const s = new wi(e, -4087, null, null, null, null, null, null, t, n);
    t.vNode = s;
    return s;
};

const Po = t => {
    const n = new wi(null, -4095, null, null, null, null, void 0, void 0, t, void 0);
    t.vNode = n;
    return n;
};

const Mo = (t, n) => {
    const e = new bi(-4084, null, null, null, null, t, n);
    return e;
};

const Ao = () => {
    const t = new yi(null, -4094, null, null, null, null, null, null);
    return t;
};

const Co = t => t instanceof mi;

const No = t => (t.flags & 1) === 1;

const Io = t => {
    const n = t.flags;
    return (n & 5) !== 0;
};

const jo = t => {
    const n = t.flags;
    return (n & 1) === 1 && t.firstChild !== void 0 && t.lastChild !== void 0;
};

const Oo = t => (t.flags & 4) === 4;

const Lo = t => (t.flags & 2) === 2;

const Fo = t => {
    const n = t.flags;
    return (n & 2) === 2 && Do(t, Oe, null) !== null;
};

const oh = t => t;

const Do = (t, n, e) => {
    if (No(t) || Lo(t)) {
        const s = t.props?.[n] ?? null;
        if (typeof s === "string" && e) {
            const o = e(s);
            t.props[n] = o;
            return o;
        }
        return s;
    }
    return null;
};

const zo = (t, n, e) => {
    if (e == null && t.props) {
        delete t.props[n];
    } else {
        t.props ||= {};
        t.props[n] = e;
    }
};

const Uo = (t, n, e, s, o = null) => {
    if (No(n)) {
        import.meta.env.TEST && o && zo(n, br, o);
        zo(n, e, s);
        on(t, oo(n.node, e, s, o, (n.flags & 512) !== 0));
    }
};

const Vo = t => {
    if (t.key) {
        return;
    }
    const n = vl(t.node, yr);
    n && (t.key = n);
};

const Wo = (t, n) => {
    if ((n.flags & 15) === 1) {
        const e = n;
        e.flags ^= 8;
        const s = e.node;
        const o = s.attributes;
        let r = !1;
        for (let n = 0; n < o.length; n++) {
            const i = o[n];
            const c = i.name;
            if (Rr(c)) {
                ln(i, c, t, s);
                continue;
            }
            if (r) {} else if (c !== yr && c) {
                if (c.startsWith(Ge)) {
                    const t = i.value;
                    t === "html" ? zo(e, "dangerouslySetInnerHTML", s.innerHTML) : t === "text" && "value" in s && zo(e, "value", s.value);
                } else {
                    const t = i.value;
                    zo(e, c, t);
                }
            } else {
                const t = i.value;
                t && (e.key = t);
                r = !0;
            }
        }
        Do(e, cr, null) === null && Do(e, fr, null) === null || (n.flags |= 64);
    }
};

const Qo = t => {
    if (t.bt === "_run") {
        const n = t.getCaptured()?.[0];
        if (Pe(n)) {
            return n;
        }
    }
    return t;
};

function ln(t, n, e, s) {
    const o = t.value;
    const r = n.slice(2);
    const i = o.split("|");
    const c = [];
    for (let t = 0; t < i.length; t++) {
        const n = Qo(Rn(i[t], e));
        c.push(C.bind(null, n));
    }
    (s._qDispatch ||= {})[r] = c.length === 1 ? c[0] : c;
}

function un(t, n, e) {
    let s = $l(n);
    for (;s; ) {
        if (Oo(s)) {
            Bo(t, s);
            e(s, n);
        } else {
            No(s) ? e(s, n) : un(t, s, e);
        }
        s = s.nextSibling;
    }
}

function cn(t, n) {
    let e = t;
    if (Oo(t)) {
        n?.(t, null);
        return;
    }
    let s = null;
    for (;;) {
        if (n?.(e, s)) {
            return;
        }
        const o = $l(e);
        if (o) {
            e = o;
            continue;
        }
        if (e === t) {
            return;
        }
        const r = e.nextSibling;
        if (r) {
            e = r;
            continue;
        }
        s = e.parent;
        for (;s; ) {
            if (s === t) {
                return;
            }
            const n = s.nextSibling;
            if (n) {
                e = n;
                break;
            }
            s = s.parent;
        }
        if (s == null) {
            return;
        }
    }
}

const Xo = (t, n, e) => {
    let s = t;
    for (;e && s && Lo(s); ) {
        const t = n ? s.firstChild : s.lastChild;
        if (!t) {
            break;
        }
        if (t.flags & 5) {
            return t;
        }
        s = t;
    }
    for (;s; ) {
        let t = n ? s.nextSibling : s.previousSibling;
        if (t && t.flags & 5) {
            return t;
        }
        if (!t) {
            let e = s.parent;
            if (e && !Lo(e)) {
                return null;
            }
            for (;e && !(t = n ? e.nextSibling : e.previousSibling); ) {
                e = e.parent;
                if (e && !Lo(e)) {
                    return null;
                }
            }
            if (!t) {
                return null;
            }
            if (Oo(t) && e && No(e)) {
                return null;
            }
        }
        for (;t; ) {
            s = t;
            if (s.flags & 5 && jl(s)) {
                return s;
            }
            t = n ? s.firstChild : s.lastChild;
        }
    }
    return null;
};

const Bo = (t, n) => {
    const e = (t => t)(n);
    const s = e.flags;
    if ((s & 8) === 0) {
        const s = ul(n, !0);
        const o = e.node;
        const r = Pl(s);
        let i = Xo(n, !1, !0);
        const c = Xo(n, !0, !0);
        const l = o || (c && No(c) ? c.node : c?.node) || null;
        let u = l;
        for (;i && Oo(i); ) {
            if ((i.flags & 8) === 0) {
                const n = r.createTextNode(i.text);
                on(t, so(n, s, u));
                u = n;
                i.node = n;
                i.flags |= 8;
            }
            i = Xo(i, !1, !0);
        }
        i = n;
        for (;i && Oo(i); ) {
            const n = Xo(i, !0, !0);
            const e = !n || !Oo(n);
            if ((i.flags & 8) === 0) {
                if (e && o) {
                    on(t, io(o, i.text));
                } else {
                    const n = r.createTextNode(i.text);
                    on(t, so(n, s, l));
                    i.node = n;
                }
                i.flags |= 8;
            }
            i = n;
        }
    }
};

const Jo = (t, n) => {
    let e = t;
    const s = t.node;
    const {qVNodeRefs: o} = s;
    let r = -1;
    let i;
    if (typeof n === "string") {
        r = parseInt(n);
        i = o.get(r);
    } else {
        i = n;
        const t = i.vNode;
        if (t) {
            return t;
        }
    }
    if (Co(i)) {
        e = i;
    } else {
        let t = i;
        const n = [ i ];
        for (;t && t !== s && !t.vNode; ) {
            t = t.parentElement;
            n.push(t);
        }
        t.vNode && (e = t.vNode);
        for (let t = n.length - 2; t >= 0; t--) {
            e = Go(e, n[t]);
        }
        if (r != -1) {
            i.vNode = e;
            o.set(r, e);
        }
    }
    if (typeof n === "string") {
        const t = n.length;
        let s = Ko(n, t);
        let o = 0;
        for (;s < t; ) {
            const t = n.charCodeAt(s);
            o *= 26;
            if (t >= 97) {
                o += t - 97;
            } else {
                o += t - 65;
                e = Ho(e, o);
                o = 0;
            }
            s++;
        }
    }
    return e;
};

const Ho = (t, n) => {
    let e = $l(t);
    for (;e.flags >>> 12 !== n; ) {
        e = e.nextSibling;
    }
    return e;
};

const Yo = [];

const Go = (t, n) => {
    let e = $l(t);
    for (;e && (!(e instanceof wi) || e.node !== n); ) {
        if (Lo(e)) {
            const t = e.nextSibling;
            const n = $l(e);
            if (n) {
                t && Yo.push(t);
                e = n;
            } else {
                e = t || (Yo.length ? Yo.pop() : null);
            }
        } else {
            const t = e.nextSibling;
            e = t || t || Yo.pop();
        }
    }
    for (;Yo.length; ) {
        Yo.pop();
    }
    return e;
};

const Ko = (t, n) => {
    let e = 0;
    for (;e < n; ) {
        if (!(t.charCodeAt(e) <= 57)) {
            return e;
        }
        e++;
    }
    return n;
};

const Zo = (t, n, e, s) => {
    const o = n.createElement("errored-host");
    s && s instanceof Error && (o.props = {
        error: s
    });
    o.setAttribute("q:key", "_error_");
    const r = qo(o, "errored-host");
    if (Io(e)) {
        ll(t, r, e, null);
    } else {
        const n = [];
        un(t, e, t => {
            n.push(t);
        });
        for (let e = 0; e < n.length; e++) {
            ll(t, r, n[e], null);
        }
    }
    return r;
};

const tl = Wt;

const nl = (t, n, e, s) => {
    const o = No(n);
    o && ml(n);
    const r = e.parent;
    if (e === s) {
        if (r) {
            return;
        }
        s = null;
    }
    sl(t, r, n, e);
    const i = e.node;
    const c = n.flags & 32;
    const l = o ? n.node : ul(n, !1);
    l && !c && on(t, so(i, l, rl(t, n, s)?.node ?? null));
    il(n, e, s);
    c && (e.flags |= 32);
};

const el = (t, n, e, o) => {
    const r = No(n);
    r && ml(n);
    const c = e.parent;
    if (e === o) {
        if (c) {
            return;
        }
        o = null;
    }
    sl(t, c, n, e);
    const l = n.flags & 32;
    const u = !r && n.flags & 2048 ? n.props?.[Ie] : null;
    const f = u ? null : r ? n : cl(n, !1);
    const a = u || f?.node;
    const h = rl(t, n, o);
    const d = h?.node ?? null;
    const p = Fo(e);
    if (p && f && (f.flags & 1536) !== 0) {
        const r = cl(n, !1);
        const c = rl(t, n, o)?.node ?? null;
        const {elementNamespace: l, elementNamespaceFlag: u} = s(r, e);
        un(t, e, n => {
            if (Oo(n)) {
                on(t, so(n.node, a, c));
            } else {
                if ((n.flags & 1536) !== u) {
                    const t = function e(t, n, o, r) {
                        let c = t;
                        let l = null;
                        let u = null;
                        let f = null;
                        for (;c; ) {
                            let e = null;
                            let a = null;
                            if (No(c)) {
                                e = c.node;
                                const t = hl(c);
                                const l = c.parent;
                                const h = u == null ? n : l && cl(l, !0);
                                if (h) {
                                    const t = s(h, hl(c));
                                    o = t.elementNamespace;
                                    r = t.elementNamespaceFlag;
                                }
                                const d = $l(c);
                                a = i(e, t, o, !d);
                                e.remove();
                                u == null && (u = a);
                                f && f.appendChild(a);
                                c.node = a;
                                c.flags &= -1537;
                                c.flags |= r;
                                if (d) {
                                    c = d;
                                    f = a;
                                    continue;
                                }
                                if (wl(e)) {
                                    const t = Hn(e);
                                    if (t) {
                                        const n = $l(t.rootVNode);
                                        if (n) {
                                            c = n;
                                            f = a;
                                            continue;
                                        }
                                    }
                                }
                            }
                            if (c === t) {
                                return u;
                            }
                            const h = c.nextSibling;
                            if (h) {
                                c = h;
                                continue;
                            }
                            l = c.parent;
                            for (;l; ) {
                                if (l === t) {
                                    return u;
                                }
                                const n = l.nextSibling;
                                if (n) {
                                    c = n;
                                    return u;
                                }
                                l = l.parent;
                            }
                            if (l == null) {
                                return u;
                            }
                        }
                        return u;
                    }(n, r, l, u);
                    t && (n.node = t);
                }
                on(t, so(n.node, a, c));
            }
        });
    } else {
        a && !l && un(t, e, n => {
            on(t, so(n.node, a, d));
        });
    }
    il(n, e, o);
    l && (e.flags |= 32);
};

const rl = (t, n, e) => {
    let s = null;
    e == null ? Lo(n) && (s = Xo(n, !0, !1)) : s = Lo(e) ? Xo(e, !0, !0) : e;
    s && Oo(s) && Bo(t, s);
    return s;
};

const il = (t, n, e) => {
    const s = e ? e.previousSibling : t.lastChild;
    e ? e.previousSibling = n : t.lastChild = n;
    s ? s.nextSibling = n : t.firstChild = n;
    n.previousSibling = s;
    n.nextSibling = e;
    n.parent = t;
};

const sl = (t, n, e, s) => {
    n && (s.previousSibling || s.nextSibling || n !== e) && fl(t, n, s, !1);
};

const ol = (t, n) => {
    let e = n;
    for (;e && Lo(e); ) {
        e = e.lastChild;
    }
    e && Oo(e) && (e.flags & 8) === 0 && Bo(t, e);
};

const ll = (t, n, e, s) => {
    Io(e) ? nl(t, n, e, s) : el(t, n, e, s);
};

const ul = (t, n) => {
    for (;t && !No(t); ) {
        if (t.flags & 2048) {
            return t.props?.[Ie];
        }
        t = t.parent || (n ? t.slotParent : null);
    }
    return t ? t.node : null;
};

const cl = (t, n) => {
    for (;t && !No(t); ) {
        t = t.parent || (n ? t.slotParent : null);
    }
    return t;
};

const fl = (t, n, e, s) => {
    Oo(e) && Bo(t, e);
    if (s) {
        const s = Do(n, wr, null) !== null;
        if (s) {
            return;
        }
        Io(e) ? on(t, eo(e.node)) : un(t, e, n => {
            on(t, eo(n.node));
        });
    }
    const o = e.previousSibling;
    const r = e.nextSibling;
    o ? o.nextSibling = r : n.firstChild = r;
    r ? r.previousSibling = o : n.lastChild = o;
    e.previousSibling = null;
    e.nextSibling = null;
};

const al = (t, n, e, s = !0) => {
    const o = ul(n, !0);
    if (o && s) {
        if (Io(n)) {
            on(t, ro(n.node));
        } else {
            const e = cl(n, !1);
            e && e.firstChild === n && e.lastChild === n ? on(t, ro(o)) : un(t, n, n => {
                on(t, eo(n.node));
            });
        }
    }
    const r = e.previousSibling;
    r ? r.nextSibling = null : n.firstChild = null;
    n.lastChild = r;
};

const hl = t => {
    const n = oh(t);
    let e = n.elementName;
    if (e === void 0) {
        const t = n.node;
        const s = ql(t).toLowerCase();
        e = n.elementName = s;
        n.flags |= (t => {
            const n = Tl(t);
            switch (n) {
              case nr:
                return 512;

              case er:
                return 1024;

              default:
                return 0;
            }
        })(t);
    }
    return e;
};

const dl = t => {
    let n = t.text;
    n === void 0 && (n = t.text = t.node.nodeValue);
    return n;
};

const pl = (t, n, e) => {
    Bo(t, n);
    n.text = e;
    on(t, io(n.node, e));
};

const $l = t => {
    if (Oo(t)) {
        return null;
    }
    let n = t.firstChild;
    n === void 0 && (n = ml(t));
    return n;
};

const ml = n => {
    const e = oh(n);
    let s = e.firstChild;
    if (s === void 0) {
        const n = e.node;
        s = e.parent && wl(n) ? e.firstChild = e.lastChild = null : (n => {
            const e = n.node;
            const s = Rl(e);
            const o = Pl(e)?.qVNodeData?.get(e);
            const r = ((n, e, s, o) => {
                Vo(n);
                if (o) {
                    if (o.charCodeAt(0) === Ce && o.charCodeAt(1) === Ce) {
                        const t = (t => {
                            const n = t.indexOf("||", 2);
                            const e = t.substring(2, n);
                            const s = t.substring(n + 2);
                            return {
                                elementVNodeData: e,
                                virtualVNodeData: s
                            };
                        })(o);
                        const e = t.elementVNodeData;
                        o = t.virtualVNodeData;
                        const r = Ml(n, s, e);
                        if (!o) {
                            return r;
                        }
                    }
                    return function r(n, e, s, o) {
                        let r = 0;
                        let i = null;
                        let c = null;
                        let l = null;
                        const u = t => {
                            t.flags = t.flags & 4095 | r << 12;
                            r++;
                            c && (c.nextSibling = t);
                            t.previousSibling = c;
                            t.parent = n;
                            i || (n.firstChild = i = t);
                            c = t;
                        };
                        let f = 0;
                        let a = null;
                        let h = null;
                        const d = t => {
                            const n = zl(t);
                            return !n || n && dn(t);
                        };
                        let p = null;
                        Al(e, ($, m, y, w, b) => {
                            if (Ol($())) {
                                for (;d(o); ) {
                                    o = kl(o);
                                    if (!o) {
                                        throw Te(27, [ e, $(), b ]);
                                    }
                                }
                                a = null;
                                l = null;
                                let t = 0;
                                for (;Ol($()); ) {
                                    t *= 10;
                                    t += y() - 48;
                                }
                                for (;t--; ) {
                                    const n = Po(o);
                                    Vo(n);
                                    u(n);
                                    o = kl(o);
                                    for (;zl(o) && dn(o); ) {
                                        o = kl(o);
                                        if (!o && t > 0) {
                                            throw Te(27, [ e, $(), b ]);
                                        }
                                    }
                                }
                            } else if ($() === 59) {
                                zo(n, Ue, m());
                            } else if ($() === 60) {
                                (p ||= []).push(n);
                                zo(n, Ne, m());
                            } else if ($() === 61) {
                                h || (h = Jn(s));
                                const t = m();
                                h.qn(parseInt(t), n);
                            } else if ($() === 62) {
                                zo(n, or, m());
                            } else if ($() === 64) {
                                const e = w(b + 1) === Ce;
                                let s;
                                if (e) {
                                    y();
                                    s = decodeURI(t(m()));
                                    y();
                                } else {
                                    s = m();
                                }
                                n.key = s;
                            } else if ($() === 91) {
                                zo(n, lr, m());
                            } else if ($() === 94) {
                                zo(n, ur, m());
                            } else if ($() === 96) {
                                h || (h = Jn(s));
                                an(n, m(), h);
                            } else if ($() === 63) {
                                h || (h = Jn(s));
                                n.slotParent = Jo(h.rootVNode, m());
                            } else if ($() === 93) {
                                zo(n, Ve, m());
                            } else if ($() === 123) {
                                y();
                                u(Ao());
                                Fl.push(n, i, c, l, r);
                                r = 0;
                                n = c;
                                i = c = null;
                            } else if ($() === Ce) {
                                const e = t(m());
                                const s = t(m());
                                zo(n, e, s);
                            } else if ($() === 125) {
                                y();
                                n.lastChild = c;
                                r = Fl.pop();
                                l = Fl.pop();
                                c = Fl.pop();
                                i = Fl.pop();
                                n = Fl.pop();
                            } else if ($() === 126) {
                                const e = t(m());
                                zo(n, Oe, e);
                            } else {
                                for (;zl(o) && dn(o); ) {
                                    o = kl(o);
                                }
                                const t = o && gl(o) === 3 ? o : null;
                                if (a === null) {
                                    a = t ? t.nodeValue : null;
                                    f = 0;
                                }
                                let n = 0;
                                for (;Ll($()); ) {
                                    n += y() - 97;
                                    n *= 26;
                                }
                                n += y() - 65;
                                const e = a === null ? "" : a.substring(f, f + n);
                                u(l = ((t, n, e) => {
                                    const s = new bi(-4092, null, t, null, null, n, e);
                                    return s;
                                })(l, t, e));
                                f += n;
                            }
                        });
                        if (p) {
                            h || (h = Jn(s));
                            for (let t = 0; t < p.length; t++) {
                                h.ensureProjectionResolved(p[t]);
                            }
                            p = null;
                        }
                        n.lastChild = c;
                        return i;
                    }(n, o, e, s);
                }
                return Ml(n, s);
            })(n, e, s, o);
            return r;
        })(e);
    }
    return s;
};

let yl = null;

const wl = t => {
    yl || (yl = t.hasAttribute);
    return yl.call(t, Ge);
};

let bl = null;

const vl = (t, n) => {
    bl || (bl = t.getAttribute);
    return bl.call(t, n);
};

const gl = To("nodeType");

const Sl = t => {
    const n = gl(t);
    return n === 3 || n === 1;
};

let _l = null;

const kl = t => {
    _l || (_l = Ro(t, "nextSibling"));
    xl || (xl = Ro(t, "firstChild"));
    for (;t; ) {
        t = _l.call(t);
        if (t !== null) {
            const n = gl(t);
            if (n === 3 || n === 1) {
                break;
            }
            if (n === 8) {
                const n = t.nodeValue;
                if (n?.startsWith(He)) {
                    return fn(t, Be, _l, xl);
                }
                if (t.nodeValue?.startsWith(Je)) {
                    return fn(t, [ Be, Ye ], _l, xl);
                }
                if (n?.startsWith(Ge)) {
                    for (;t && (t = _l.call(t)) && (gl(t) !== 8 || !t.nodeValue?.startsWith(Ke)); ) {}
                }
            }
        }
    }
    return t;
};

function fn(t, n, e, s) {
    const o = typeof n === "string";
    const r = n.length;
    for (;t; ) {
        const i = t.nodeValue;
        let c;
        if (o) {
            c = i?.startsWith(n);
        } else {
            for (let t = 0; t < r; t++) {
                if (i?.startsWith(n[t])) {
                    c = !0;
                    break;
                }
            }
        }
        if (c) {
            t = e.call(t) || null;
            return t;
        }
        let l = s.call(t);
        l || (l = e.call(t));
        for (;!l; ) {
            l = El(t);
            if (!l) {
                break;
            }
            t = l;
            l = e.call(l);
        }
        t = l;
    }
    return null;
}

const El = To("parentNode");

let xl = null;

const Rl = t => {
    xl || (xl = Ro(t, "firstChild"));
    t = t && xl.call(t);
    if (t && gl(t) === 8 && t.nodeValue?.startsWith(He)) {
        _l || (_l = Ro(t, "nextSibling"));
        return fn(t, Be, _l, xl);
    }
    for (;t && !Sl(t); ) {
        t = kl(t);
    }
    return t;
};

const Tl = To("namespaceURI");

const ql = To("nodeName");

const Pl = To("ownerDocument");

const Ml = (t, n, e) => {
    let s = null;
    const o = () => {
        for (;zl(r) && dn(r); ) {
            r = kl(r);
        }
    };
    let r = n;
    o();
    let i = null;
    for (;r; ) {
        const n = gl(r);
        let e = null;
        if (n === 3) {
            e = Mo(r, r.textContent ?? void 0);
        } else if (n === 1) {
            e = Po(r);
            Vo(e);
        }
        if (e) {
            e.parent = t;
            i && (i.nextSibling = e);
            e.previousSibling = i;
            i = e;
        }
        s || (t.firstChild = s = i);
        r = kl(r);
        o();
    }
    t.lastChild = i || null;
    t.firstChild = s;
    if (e) {
        let n = null;
        Al(e, (e, s) => {
            if (e() === 61) {
                n || (n = Jn(t.node));
                const e = s();
                n.qn(parseInt(e), t);
            } else if (e() === 96) {
                n || (n = Jn(t.node));
                an(t, s(), n);
            } else {
                s();
            }
        });
    }
    return s;
};

function an(t, n, e) {
    if (t[fi]) {
        const s = t[fi];
        ((t, n) => {
            for (const [e, s] of n) {
                t.set(e, s);
            }
        })(s, e._(n));
    } else {
        Object.defineProperty(t, fi, {
            get() {
                const s = e._(n);
                t[fi] = s;
                return s;
            },
            set(n) {
                Object.defineProperty(t, fi, {
                    value: n,
                    writable: !0,
                    enumerable: !0,
                    configurable: !0
                });
            },
            enumerable: !0,
            configurable: !0
        });
    }
}

const Al = (t, n) => {
    let e = 0;
    let s = 0;
    let o = 0;
    const r = n => n < t.length ? t.charCodeAt(n) : 0;
    const i = () => o !== 0 ? o : o = r(e);
    const c = () => {
        s = i();
        o = 0;
        e++;
        return s;
    };
    const l = () => {
        c();
        const n = e;
        for (;i() <= 58 && o !== 0 || o === 92 || o === 95 || o >= 65 && o <= 90 || o >= 97 && o <= 122; ) {
            c();
        }
        return t.substring(n, e);
    };
    for (;i() !== 0; ) {
        n(i, l, c, r, e);
    }
};

const Cl = (t, n) => {
    const e = n.flags;
    if ((e & 3) !== 0) {
        Wo(t, n);
        const e = [];
        const s = n.props;
        if (s) {
            for (const t in s) {
                t.startsWith(yr) || e.push(t);
            }
        }
        return e;
    }
    return [];
};

const Nl = (t, n) => {
    let e = Il(t);
    for (;e; ) {
        if (e === n) {
            return !0;
        }
        e = Il(e);
    }
    return !1;
};

const Il = t => t.parent || t.slotParent;

const jl = t => {
    if (t === null || Lo(t)) {
        return null;
    }
    return t.node;
};

function hn(t = 20, n = "", e = !1, s = !1, o = !0, r = null) {
    if (this && !r) {
        try {
            r = function t(n) {
                let e = n;
                for (;e; ) {
                    if (No(e)) {
                        const t = Yn(e.node);
                        if (!t) {
                            return null;
                        }
                        return Hn(t);
                    }
                    e = e.parent;
                }
                return null;
            }(this);
        } catch {}
    }
    let i = this;
    if (t === 0) {
        return "...";
    }
    if (i === null) {
        return "null";
    }
    if (i === void 0) {
        return "undefined";
    }
    const c = [];
    do {
        if (Oo(i)) {
            c.push(vn(dl(i)));
        } else if (Lo(i)) {
            const e = i.flags >>> 12;
            const s = [ "[" + e + "]" ];
            i.dirty && s.push(" dirty:" + i.dirty);
            if (r) {
                const t = Cl(r, i);
                for (let n = 0; n < t.length; n++) {
                    const e = t[n];
                    if (e !== Me && e !== br) {
                        const t = Do(i, e, null);
                        s.push(" " + e + "=" + vn(t));
                    }
                }
            }
            const l = (o ? "[34m" : "") + (Ae[Do(i, Me, null) || "V"] || Ae.V) + (o ? "[0m" : "");
            c.push("<" + l + s.join("") + ">");
            const u = $l(i);
            u && c.push("  " + hn.call(u, t - 1, n + "  ", !0, !0, o));
            c.push("</" + l + ">");
        } else if (No(i)) {
            const s = hl(i);
            const l = [];
            nn(i) && l.push(" cursor");
            i.dirty && l.push(" dirty:" + i.dirty);
            i.dirtyChildren && l.push(` dirtyChildren[${i.dirtyChildren.length}]`);
            const u = r ? Cl(r, i) : [];
            for (let t = 0; t < u.length; t++) {
                const n = u[t];
                const e = Do(i, n, null);
                l.push(" " + n + "=" + vn(e));
            }
            const f = jl(i);
            if (f) {
                const t = Pl(f).qVNodeData?.get(f);
                t && l.push(" q:vnodeData=" + vn(t));
            }
            const a = f.attributes;
            for (let t = 0; t < a.length; t++) {
                const n = a[t];
                u.indexOf(n.name) === -1 && l.push(" " + n.name + (n.value ? "=" + vn(n.value) : ""));
            }
            c.push("<" + s + l.join("") + ">");
            if (jo(i) || e) {
                const e = $l(i);
                e && c.push("  " + hn.call(e, t - 1, n + "  ", !0, !0, o));
            } else {
                c.push("  \x3c!-- not materialized --!>");
            }
            c.push("</" + s + ">");
        }
        i = s && i.nextSibling || null;
    } while (i);
    return c.join("\n" + n);
}

const Ol = t => 48 <= t && t <= 57;

const Ll = t => 97 <= t && t <= 122;

function dn(t) {
    return !t.hasAttribute(yr) || t.nodeName === "STYLE" && (t.hasAttribute(Ue) || t.hasAttribute(Fe));
}

const Fl = [];

const Dl = t => {
    const n = t.flags;
    if (n & 1) {
        return 1;
    }
    if (n & 2) {
        return 11;
    }
    if (n & 4) {
        return 3;
    }
    throw Te(26, [ n ]);
};

const zl = t => t && typeof t == "object" && gl(t) === 1;

const Ul = t => {
    let n = 1;
    for (;n--; ) {
        for (;t && (!Lo(t) || Do(t, Ne, null) === null); ) {
            const e = t.slotParent;
            const s = Lo(t) && e;
            s && n++;
            t = s || t.parent;
        }
        n > 0 && (t = t.parent);
    }
    return t;
};

function pn(t, n) {
    Co(n) && No(n) && ml(n);
    const e = n[fi];
    if (!e) {
        return;
    }
    for (const [, n] of e) {
        $n(t, n);
    }
    e.clear();
}

function $n(t, n) {
    const e = n.backRef;
    if (!e) {
        return;
    }
    for (const s of e) {
        if (s instanceof ji) {
            yn(s, n);
        } else if (s instanceof Ci) {
            mn(t, s, n);
        } else if (Ki(s)) {
            const t = s[Di];
            wn(t, n);
        } else if (t.ht.has(s)) {
            const e = t.ht.get(s);
            const o = ru(e);
            wn(o, n);
        }
    }
    e.clear();
}

function mn(t, n, e) {
    const s = n.ut;
    s && s.has(e) && s.delete(e);
    if (n instanceof ps && !s?.size) {
        n.m = void 0;
        pn(t, n);
    }
}

function yn(t, n) {
    const e = t.ut;
    e && e.has(n) && e.delete(n);
    const s = t.dt;
    s && s.has(n) && s.delete(n);
    const o = t.$t;
    o && o.has(n) && o.delete(n);
    t.yt();
}

function wn(t, n) {
    const e = t?.ut;
    if (e) {
        for (const [t, s] of e.entries()) {
            if (s.has(n)) {
                s.delete(n);
                s.size === 0 && e.delete(t);
            }
        }
    }
}

const Vl = (t, n) => {
    const {val: e, set: s, iCtx: o, i: r} = lo();
    if (e) {
        return;
    }
    s(1);
    const i = n?.deferUpdates === !1 ? 0 : 8;
    const c = new Ql(6 | i, r, o.m, t, void 0, null);
    s(c);
    const l = o.$;
    const {Lt: u} = o;
    const f = _r(u, () => Wl(c, l, o.m));
    gr(f) && (o.Lt = f);
};

const Wl = (t, n, e) => {
    const s = t.Pn;
    if (s) {
        return s;
    }
    t.h &= -5;
    const o = t => n.handleError(t, e);
    let r = null;
    const i = _r(((t, n) => {
        const e = t.Mn;
        if (e) {
            return e;
        }
        const s = t.En;
        if (!s) {
            return;
        }
        t.En = null;
        try {
            const e = s();
            if (gr(e)) {
                const s = Promise.resolve(e).then(() => {}, t => {
                    n(t);
                }).finally(() => {
                    t.Mn === s && (t.Mn = void 0);
                });
                t.Mn = s;
                return s;
            }
        } catch (t) {
            n(t);
        }
        return;
    })(t, o), () => {
        const s = ee(n.It, e, "qTask");
        s.$ = n;
        const i = t.wt.getFn(s, () => pn(n, t));
        const c = Ai(t, n);
        const [l] = ((t, n) => {
            let e = null;
            return [ s => {
                if (typeof s == "function") {
                    if (!e) {
                        e = [];
                        t.En = () => {
                            t.En = null;
                            let s = null;
                            for (let t = 0; t < e.length; t++) {
                                const o = e[t];
                                try {
                                    const t = o();
                                    gr(t) && (s ||= []).push(t.catch(n));
                                } catch (t) {
                                    n(t);
                                }
                            }
                            e = null;
                            if (s?.length) {
                                return Promise.all(s).then(() => {});
                            }
                        };
                    }
                    e.push(s);
                }
            }, e ?? [] ];
        })(t, o);
        const u = {
            track: c,
            cleanup: l
        };
        return Sr(() => i(u), l, s => {
            if (gr(s)) {
                return s.then(() => {
                    t.Pn === r && (t.Pn = null);
                    return Wl(t, n, e);
                });
            }
            o(s);
        });
    });
    if (gr(i)) {
        r = i.finally(() => {
            t.Pn === r && (t.Pn = null);
        });
        t.Pn = r;
        return r;
    }
    return i;
};

class Ql extends ai {
    h;
    Bt;
    ct;
    wt;
    Nt;
    En;
    Mn;
    Pn=null;
    constructor(t, n, e, s, o, r) {
        super();
        this.h = t;
        this.Bt = n;
        this.ct = e;
        this.wt = s;
        this.Nt = o;
        this.En = r;
    }
}

const Xl = t => t instanceof Ql;

function bn(t, n) {
    const e = Jn(n);
    typeof this === "string" && nf(ef(e, this));
    const s = tf[0];
    s.h |= 4;
    sn(e, s.ct, 1);
}

const Bl = t => {
    const n = t.resolved;
    if (!n) {
        throw t.resolve();
    }
};

const Jl = t => t instanceof Ci;

const Hl = (t, n) => {
    t.add(n);
};

const Yl = (t, n) => {
    (t.backRef ||= new Set).add(n);
};

const Gl = (t, n) => {
    if (n?.serializationCtx) {
        const e = t.consumer;
        const s = t.property;
        let o = null;
        Xl(e) ? o = e.wt : e instanceof Ni ? o = e.Zt : s === ":" && (o = n.getHostProp(e, Ne));
        o && n.serializationCtx.Mt.add(o);
    }
};

const Kl = (t, n, e) => {
    const s = import.meta.env.TEST ? !ui() : !se;
    if (e) {
        const o = e => {
            const o = e.consumer;
            const r = e.property;
            if (Xl(o)) {
                o.h |= 4;
                sn(t, o.ct, 1);
            } else if (o instanceof Ci) {
                o.invalidate();
            } else if (r === ":") {
                sn(t, o, 4);
            } else if (r === ".") {
                if (s) {
                    Nt(o, n);
                    sn(t, o, 2);
                }
            } else {
                const i = e.data;
                if (i instanceof $s) {
                    const e = i.data;
                    const c = {
                        isConst: e.et,
                        scopedStyleIdPrefix: e.j,
                        value: n
                    };
                    if (s) {
                        (function l(t, n, e) {
                            const s = t.props ||= {};
                            let o = s[_i];
                            if (!o) {
                                o = new Map;
                                s[_i] = o;
                            }
                            o.set(n, e);
                        })(o, r, c);
                    } else {
                        const t = o;
                        let n = t.getProp(_i);
                        if (!n) {
                            n = new Map;
                            t.setProp(_i, n);
                        }
                        n.set(r, c);
                    }
                    sn(t, o, 8);
                }
            }
        };
        const r = Array.from(e);
        for (let t = 0; t < r.length; t++) {
            o(r[t]);
        }
    }
};

const Zl = t => ke(t) && typeof t[vc] === "function";

const tu = t => {
    let n = 1;
    switch (t) {
      case "never":
        n |= 8;
        break;

      case "always":
        n |= 16;
        break;
    }
    return n;
};

const nu = [];

function vn(t) {
    try {
        if (t === null) {
            return "null";
        }
        if (t === void 0) {
            return "undefined";
        }
        if (typeof t === "string") {
            return '"' + t + '"';
        }
        if (typeof t === "number" || typeof t === "boolean") {
            return t + "";
        }
        if (Xl(t)) {
            return `Task(${vn(t.wt)})`;
        }
        if (Pe(t)) {
            return `Qrl(${t.bt})`;
        }
        if (typeof t === "object" || typeof t === "function") {
            if (nu.includes(t)) {
                return "*";
            }
            try {
                nu.push(t);
                if (Array.isArray(t)) {
                    return Co(t) ? "(" + (Do(t, Me, null) || "vnode") + ")" : t.map(vn);
                }
                if (Jl(t)) {
                    return t instanceof ps ? "WrappedSignal" : t instanceof Ni ? "ComputedSignal" : "Signal";
                }
                if (uu(t)) {
                    return "Store";
                }
                if (vs(t)) {
                    return eu(t);
                }
                if (Co(t)) {
                    return "(" + (Do(t, Me, null) || "vnode") + ")";
                }
            } finally {
                nu.pop();
            }
        }
    } catch (t) {
        console.error("ERROR in qwikDebugToString", t);
        return "*error*";
    }
    return t;
}

const eu = t => {
    if (vs(t)) {
        if (typeof t.type === "function") {
            const n = t.type[vf];
            if (n) {
                const [t] = n;
                return "Component(" + t.bt + ")";
            }
            return "Function(" + t.type.name + ")";
        }
        let n = "<" + t.type;
        if (t.props) {
            const e = Object.entries(t.props);
            for (let t = 0; t < e.length; t++) {
                const [s, o] = e[t];
                n += " " + s + "=" + vn(o);
            }
            const s = t.children;
            if (s != null) {
                n += ">";
                if (Array.isArray(s)) {
                    for (let t = 0; t < s.length; t++) {
                        const e = s[t];
                        n += eu(e);
                    }
                } else {
                    n += eu(s);
                }
                n += "</" + t.type + ">";
            } else {
                n += "/>";
            }
        }
        return n;
    }
    return t + "";
};

const ru = t => t[Pi];

const iu = t => t?.[qi] || null;

const su = (t, n) => {
    const e = ru(t);
    e && e.force(n);
};

const ou = (t, n) => {
    const e = ru(t);
    if (e) {
        return (e.ut?.get(n)?.size ?? 0) > 0;
    }
    return !1;
};

const lu = t => iu(t) || t;

const uu = t => qi in t;

function gn(t, n, e) {
    return new Proxy(n, new fu(e, t || null));
}

const cu = (t, n, e) => {
    if (_e(t) && e) {
        let s = e.ht.get(t);
        if (!s) {
            s = gn(e, t, n);
            e.ht.set(t, s);
        }
        return s;
    }
    return t;
};

class fu {
    h;
    $;
    ut=void 0;
    constructor(t, n) {
        this.h = t;
        this.$ = n;
    }
    toString() {
        return "[Store]";
    }
    force(t) {
        const n = iu(this);
        Kl(this.$, this, kn(n, t, this.ut));
    }
    get(t, n) {
        if (typeof n === "symbol") {
            if (n === qi) {
                return t;
            }
            if (n === Pi) {
                return this;
            }
            return t[n];
        }
        const e = Cc();
        const s = t[n];
        if (e) {
            if (this.$ === null) {
                if (!e.$) {
                    return s;
                }
                this.$ = e.$;
            }
            const o = e.Ot;
            o && Sn(t, Array.isArray(t) ? Mi : n, this, o);
        }
        if (n === "toString" && s === Object.prototype.toString) {
            return this.toString;
        }
        const o = this.h;
        if (o & 1 && ke(s) && !Object.isFrozen(s) && !uu(s) && !Object.isFrozen(t)) {
            return cu(s, this.h, this.$);
        }
        return s;
    }
    set(t, n, e) {
        if (typeof n === "symbol") {
            t[n] = e;
            return !0;
        }
        const s = this.h & 1 ? lu(e) : e;
        if (n in t) {
            const e = t[n];
            s !== e && _n(n, s, t, this);
        } else {
            _n(n, s, t, this);
        }
        return !0;
    }
    deleteProperty(t, n) {
        if (typeof n != "string" || !delete t[n]) {
            return !1;
        }
        Array.isArray(t) || Kl(this.$, this, kn(t, n, this.ut));
        return !0;
    }
    has(t, n) {
        if (n === qi) {
            return !0;
        }
        if (typeof n === "string") {
            const e = Cc();
            if (e) {
                const s = e.Ot;
                s && Sn(t, Array.isArray(t) ? Mi : n, this, s);
            }
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    ownKeys(t) {
        const n = Cc();
        const e = n?.Ot;
        e && Sn(t, Mi, this, e);
        return Reflect.ownKeys(t);
    }
    getOwnPropertyDescriptor(t, n) {
        const e = Reflect.getOwnPropertyDescriptor(t, n);
        if (Array.isArray(t) || typeof n === "symbol") {
            return e;
        }
        if (e && !e.configurable) {
            return e;
        }
        return {
            enumerable: !0,
            configurable: !0
        };
    }
}

function Sn(t, n, e, s) {
    const o = e.ut ||= new Map;
    let r = o.get(n);
    if (!r) {
        r = new Set;
        o.set(n, r);
    }
    Hl(r, s);
    Yl(s, t);
    (import.meta.env.TEST ? !qc(e.$) : se) && Gl(s, e.$);
}

function _n(t, n, e, s) {
    e[t] = n;
    const o = kn(e, t, s.ut);
    o && Kl(s.$, s, o);
}

function kn(t, n, e) {
    let s;
    if (e) {
        if (Array.isArray(t)) {
            for (const t of e.values()) {
                s ||= new Set;
                for (const n of t) {
                    s.add(n);
                }
            }
        } else {
            s = e.get(n);
        }
    }
    const o = e?.get(Mi);
    if (o) {
        s ||= new Set;
        for (const t of o) {
            s.add(t);
        }
    }
    return s;
}

const au = Symbol();

const hu = [ void 0, null, !0, !1, "", Vi, Wi, Ri, Mi, Ui, zs, Ls, NaN, Infinity, -Infinity, Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER - 1, Number.MIN_SAFE_INTEGER ];

const du = [ "undefined", "null", "true", "false", "''", "EMPTY_ARRAY", "EMPTY_OBJ", "NEEDS_COMPUTATION", "STORE_ALL_PROPS", "_UNINITIALIZED", "Slot", "Fragment", "NaN", "Infinity", "-Infinity", "MAX_SAFE_INTEGER", "MAX_SAFE_INTEGER-1", "MIN_SAFE_INTEGER" ];

const pu = [ "Plain", "RootRef", "ForwardRef", "Constant", "Array", "Object", "URL", "Date", "Regex", "QRL", "VNode", "RefVNode", "BigInt", "URLSearchParams", "ForwardRefs", "TemporalDuration", "TemporalInstant", "TemporalPlainDate", "TemporalPlainDateTime", "TemporalPlainMonthDay", "TemporalPlainTime", "TemporalPlainYearMonth", "TemporalZonedDateTime", "Error", "Promise", "Set", "Map", "Uint8Array", "Task", "Component", "Signal", "WrappedSignal", "ComputedSignal", "AsyncSignal", "SerializerSignal", "Store", "FormData", "JSXNode", "PropsProxy", "SubscriptionData", "EffectSubscription" ];

function En(t, n, e) {
    let s = n.bt;
    let o = n.vt;
    const r = li();
    if (r) {
        const t = r.chunkForSymbol(s, o);
        if (t) {
            o = t[1];
            s = t[0];
        }
    }
    const i = (t => Pe(t) && t.bt == qe)(n);
    if (i) {
        const e = n.resolved;
        o = "";
        s = t.gt(null, 0, e) + "";
    } else {
        o || (o = t.St(n.st));
        if (!o) {
            throw Te(14, [ n.bt ]);
        }
        o.startsWith("./") && (o = o.slice(2));
    }
    const c = n.getCaptured();
    let l = null;
    c && c.length > 0 && (l = c.map(n => "" + t._t(n)).join(" "));
    if (e) {
        return [ o, s, l ];
    }
    let u = `${o}#${s}`;
    l && (u += "#" + l);
    return u;
}

function xn(t, n, e, s) {
    return lf(t, n, null, null, e, s);
}

function Rn(t, n) {
    const [e, s, o] = t.split("#");
    return xn(e, s, o || null, n);
}

class $u {
    An;
    Cn=0;
    Et=[];
    Nn=0;
    In=new Set;
    jn=new Map;
    On;
    Ln=new Map;
    Ct;
    Fn=typeof Temporal !== "undefined";
    constructor(t) {
        this.An = t;
        this.Ct = t.Ct;
    }
    async serialize() {
        await this.outputRoots();
    }
    outputArray(t, n, e) {
        this.Ct.write("[");
        let s = !1;
        let o;
        if (n) {
            o = t.length;
        } else {
            o = t.length - 1;
            for (;o >= 0 && t[o] === void 0; ) {
                o--;
            }
            o++;
        }
        for (let n = 0; n < o; n++) {
            s ? this.Ct.write(ni) : s = !0;
            e(t[n], n);
        }
        this.Ct.write("]");
    }
    stringNeedsJsonEscape$(t) {
        for (let n = 0; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 32 || e === 34 || e === 92) {
                return !0;
            }
        }
        return !1;
    }
    maybeNumericObjectKey$(t) {
        if (t.length === 0 || t.length >= 8) {
            return t;
        }
        let n = 0;
        if (t.charCodeAt(0) === 45) {
            if (t.length === 1) {
                return t;
            }
            n = 1;
        }
        const e = t.charCodeAt(n);
        if (e < 49 || e > 57) {
            return t;
        }
        for (n++; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 48 || e > 57) {
                return t;
            }
        }
        return +t;
    }
    output(t, n, e) {
        if (typeof n === "number") {
            this.Ct.write(t + ni + n);
        } else if (typeof n === "string") {
            const e = this.stringNeedsJsonEscape$(n) ? JSON.stringify(n) : '"' + n + '"';
            this.Ct.write(t + ni);
            let s = -1;
            let o = 0;
            for (;(s = e.indexOf("</", o)) !== -1; ) {
                this.Ct.write(e.slice(o, s));
                this.Ct.write("<\\/");
                o = s + 2;
            }
            this.Ct.write(o === 0 ? e : e.slice(o));
        } else {
            this.Ct.write(t + ni);
            this.outputArray(n, !!e, (t, n) => {
                this.writeValue(t, n);
            });
        }
    }
    getSeenRefOrOutput(t, n, e) {
        let s = this.An.getSeenRef(t);
        const o = !e && this.jn.get(t);
        if (!s) {
            if (e) {
                return !0;
            }
            if (typeof o !== "number") {
                return this.An.Dn(t, this.On, n);
            }
            s = this.An._t(t, !0);
        }
        if (s.On) {
            if (this.On) {
                this.An.zn(s);
            } else {
                this.An.zn(s, n);
                t = this.An.Un[n];
            }
        }
        if (typeof o === "number") {
            this.Et[o] = s.Bt;
            this.jn.delete(t);
        }
        const r = t instanceof Su ? t.Vn : s.Bt;
        if (!this.On && r === n) {
            return s;
        }
        this.output(1, r);
    }
    writeValue(t, n) {
        if (yc(t)) {
            this.output(3, 0);
        } else {
            switch (typeof t) {
              case "undefined":
                this.output(3, 0);
                break;

              case "boolean":
                this.output(3, t ? 2 : 3);
                break;

              case "number":
                Number.isNaN(t) ? this.output(3, 12) : Number.isFinite(t) ? t === Number.MAX_SAFE_INTEGER ? this.output(3, 15) : t === Number.MAX_SAFE_INTEGER - 1 ? this.output(3, 16) : t === Number.MIN_SAFE_INTEGER ? this.output(3, 17) : this.output(0, t) : this.output(3, t < 0 ? 14 : 13);
                break;

              case "string":
                t.length === 0 ? this.output(3, 4) : (t.length < 4 || this.getSeenRefOrOutput(t, n)) && this.output(0, t);
                break;

              case "bigint":
                (t < 1e4 && t > -1e3 || this.getSeenRefOrOutput(t, n)) && this.output(12, "" + t);
                break;

              case "symbol":
                t === Ri ? this.output(3, 7) : t === Mi ? this.output(3, 8) : t === Ui ? this.output(3, 9) : t === au && this.output(3, 0);
                break;

              case "function":
                if (t === zs) {
                    this.output(3, 10);
                } else if (t === Ls) {
                    this.output(3, 11);
                } else if (Pe(t)) {
                    if (this.getSeenRefOrOutput(t, n)) {
                        const [n, e, s] = En(this.An, t, !0);
                        let o;
                        if (n !== "") {
                            o = `${this.An._t(n)}#${this.An._t(e)}${s ? "#" + s : ""}`;
                            const r = this.Ln.get(o);
                            if (r) {
                                const t = this.An._t(r);
                                this.output(1, t);
                                return;
                            }
                            this.Ln.set(o, t);
                        } else {
                            o = +e;
                        }
                        this.output(9, o);
                    }
                } else {
                    if (!gf(t)) {
                        throw Te(34, [ "" + t ]);
                    }
                    {
                        const [n] = t[vf];
                        this.An.Wn.add(n.bt);
                        this.output(29, [ n ]);
                    }
                }
                break;

              case "object":
                if (t === Vi) {
                    this.output(3, 5);
                } else if (t === Wi) {
                    this.output(3, 6);
                } else if (t === null) {
                    this.output(3, 1);
                } else if (t instanceof Su) {
                    this.output(1, t.Vn);
                } else {
                    const e = this.getSeenRefOrOutput(t, n);
                    if (e) {
                        const n = this.On;
                        this.On = e;
                        this.writeObjectValue(t);
                        this.On = n;
                    }
                }
                break;

              default:
                throw Te(20, [ typeof t ]);
            }
        }
    }
    writeObjectValue(t) {
        if (Ki(t)) {
            const n = t[Fi];
            this.output(38, [ vu(n), n.varProps, n.constProps, t[Di].ut ]);
        } else if (t instanceof $s) {
            this.output(39, [ t.data.j, t.data.et ]);
        } else if (t instanceof Ti) {
            this.output(40, [ t.consumer, t.property, t.data ]);
        } else if (uu(t)) {
            const n = ru(t);
            const e = iu(t);
            const s = n.h;
            const o = n.ut;
            const r = [];
            for (const t in e) {
                const n = e[t];
                const s = this.An.ht.get(n);
                s && r.push(s);
            }
            const i = [ e, s, o, ...r ];
            for (;i[i.length - 1] === void 0; ) {
                i.pop();
            }
            this.output(35, i);
        } else if (Zl(t)) {
            const n = t[vc](t);
            if (gr(n)) {
                const t = this.resolvePromise(n, (t, n) => new mu(34, t, n, void 0, void 0));
                this.output(2, t);
            } else {
                const t = this.On.Bt;
                this.On = this.On.On;
                this.writeValue(n, t);
            }
        } else if (function n(t) {
            const n = Object.getPrototypeOf(t);
            return n == null || n === Object.prototype || n === Array.prototype;
        }(t)) {
            if (Array.isArray(t)) {
                this.output(4, t);
            } else {
                const n = [];
                for (const e in t) {
                    if (Object.prototype.hasOwnProperty.call(t, e)) {
                        const s = t[e];
                        yc(s) || n.push(this.maybeNumericObjectKey$(e), s);
                    }
                }
                this.output(5, n.length ? n : 0);
            }
        } else if (this.An.Qn(t)) {
            t.Xn.vnodeData[0] |= 16;
            this.output(11, t.Xn.id);
        } else if (t instanceof Ci) {
            if (t instanceof ts) {
                const n = function e(t, n) {
                    if (n === Ri) {
                        return n;
                    }
                    return _r(t.Zt.resolved || t.Zt.resolve(), t => {
                        let e;
                        typeof t === "function" && (t = t());
                        t.serialize ? e = t.serialize(n) : typeof n === "object" && vc in n && (e = n[vc](n));
                        e === void 0 && (e = Ri);
                        return e;
                    });
                }(t, t.Gt);
                if (gr(n)) {
                    const e = this.resolvePromise(n, (n, e) => new mu(34, n, e, t.ut, t.Zt));
                    this.output(2, e);
                } else {
                    this.output(34, [ t.Zt, t.ut, n ]);
                }
                return;
            }
            if (t instanceof ps) {
                this.output(31, [ ...Tn(this.An, t), t.h, t.m, ...t.ut || [] ]);
            } else if (t instanceof Ni) {
                let n = t.Gt;
                const e = t.h & 16;
                const s = t.h & 8;
                const o = t.h & 1;
                const r = yc(t.Gt);
                const i = t instanceof ji;
                const c = i && t.xt !== 0 ? t.xt : void 0;
                const l = i && t.dn !== 1 ? t.dn : void 0;
                const u = i && t.$n !== 0 ? t.$n : void 0;
                const f = i && t.h & -25 || void 0;
                o || r ? n = Ri : e ? n = t.Gt : s && (n = Ri);
                const a = [ t.Zt, t.ut ];
                if (i) {
                    a.push(t.dt, t.$t, t.an);
                    a.push(f || void 0);
                }
                n === Ri && c === void 0 && l === void 0 && u === void 0 || a.push(n === void 0 ? au : n);
                if (i) {
                    a.push(c);
                    a.push(l);
                    a.push(u);
                }
                this.output(i ? 33 : 32, a);
            } else {
                const n = t.Gt;
                const e = [ n === void 0 ? au : n ];
                t.ut && e.push(...t.ut);
                this.output(30, e);
            }
        } else if (t instanceof URL) {
            this.output(6, t.href);
        } else if (t instanceof Date) {
            this.output(7, Number.isNaN(t.valueOf()) ? "" : t.valueOf());
        } else if (this.Fn && t instanceof Temporal.Duration) {
            this.output(15, t.toJSON());
        } else if (this.Fn && t instanceof Temporal.Instant) {
            this.output(16, t.toJSON());
        } else if (this.Fn && t instanceof Temporal.PlainDate) {
            this.output(17, t.toJSON());
        } else if (this.Fn && t instanceof Temporal.PlainDateTime) {
            this.output(18, t.toJSON());
        } else if (this.Fn && t instanceof Temporal.PlainMonthDay) {
            this.output(19, t.toJSON());
        } else if (this.Fn && t instanceof Temporal.PlainTime) {
            this.output(20, t.toJSON());
        } else if (this.Fn && t instanceof Temporal.PlainYearMonth) {
            this.output(21, t.toJSON());
        } else if (this.Fn && t instanceof Temporal.ZonedDateTime) {
            this.output(22, t.toJSON());
        } else if (t instanceof RegExp) {
            this.output(8, "" + t);
        } else if (t instanceof Error) {
            const n = [ t.message ];
            n.push(...Object.entries(t).flat());
            this.output(23, n);
        } else if (this.An.Bn(t)) {
            const n = this.An._t(t);
            this.An.Jn(t, "q:id", n + "");
            this.output(10, t.id);
            const e = t.vnodeData;
            if (e) {
                yu(e, t => this.An._t(t));
                e[0] |= 16;
            }
            if (t.children) {
                const n = t.children.length;
                for (let e = 0; e < n; e++) {
                    const n = t.children[e];
                    const s = n.vnodeData;
                    s && (s[0] |= 16);
                }
            }
        } else if (typeof FormData !== "undefined" && t instanceof FormData) {
            const n = [];
            for (const [e, s] of t.entries()) {
                typeof s === "string" && n.push(e, s);
            }
            this.output(36, n);
        } else if (t instanceof URLSearchParams) {
            this.output(13, "" + t);
        } else if (t instanceof Set) {
            this.output(25, [ ...t.values() ]);
        } else if (t instanceof Map) {
            const n = [];
            for (const [e, s] of t.entries()) {
                n.push(e, s);
            }
            this.output(26, n);
        } else if (vs(t)) {
            const n = [ t.type, t.key, t.varProps, t.constProps, t.children, t.toSort || void 0 ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(37, n);
        } else if (t instanceof Ql) {
            const n = [ t.wt, t.h, t.Bt, t.ct, t.Nt ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(28, n);
        } else if (gr(t)) {
            const n = this.resolvePromise(t, (t, n) => new mu(24, t, n));
            this.output(2, n);
        } else if (t instanceof mu) {
            if (t.Hn === 34) {
                if (t.wt) {
                    this.output(34, [ t.wt, t.ut, t.Yn ]);
                } else {
                    if (!t.Gn) {
                        console.error(t.Yn);
                        throw Te(33);
                    }
                    {
                        const n = this.On.Bt;
                        this.On = this.On.On;
                        this.writeValue(t.Yn, n);
                    }
                }
            } else {
                this.output(24, [ t.Gn, t.Yn ]);
            }
        } else if (t instanceof Uint8Array) {
            let n = "";
            const e = t.length;
            for (let s = 0; s < e; s++) {
                n += String.fromCharCode(t[s]);
            }
            const s = btoa(n).replace(/=+$/, "");
            this.output(27, s);
        } else if (t instanceof bu) {
            const n = t.Kn;
            if (this.getSeenRefOrOutput(n, this.On.Bt, !0)) {
                let t = this.jn.get(n);
                if (t === void 0) {
                    t = this.Nn++;
                    this.jn.set(n, t);
                    this.Et[t] = -1;
                }
                this.output(2, t);
            }
        } else {
            if (!Co(t)) {
                throw Te(20, [ typeof t ]);
            }
            this.output(3, 0);
        }
    }
    resolvePromise(t, n) {
        const e = this.Nn++;
        t.then(s => {
            this.In.delete(t);
            this.Et[e] = this.An._t(n(!0, s));
        }).catch(s => {
            this.In.delete(t);
            this.Et[e] = this.An._t(n(!1, s));
        });
        this.In.add(t);
        return e;
    }
    async outputRoots() {
        this.Ct.write("[");
        const {Un: t} = this.An;
        for (;this.Cn < t.length || this.In.size; ) {
            this.Cn !== 0 && this.Ct.write(ni);
            let n = !1;
            for (;this.Cn < t.length; this.Cn++) {
                n ? this.Ct.write(ni) : n = !0;
                this.writeValue(t[this.Cn], this.Cn);
            }
            if (this.In.size) {
                try {
                    await Promise.race(this.In);
                } catch {}
            }
        }
        if (this.Et.length) {
            let t = this.Et.length - 1;
            for (;t >= 0 && this.Et[t] === -1; ) {
                t--;
            }
            if (t >= 0) {
                this.Ct.write(ni);
                this.Ct.write(14 + ni);
                const n = t === this.Et.length - 1 ? this.Et : this.Et.slice(0, t + 1);
                this.outputArray(n, !0, t => {
                    this.Ct.write(t + "");
                });
            }
        }
        this.Ct.write("]");
    }
}

class mu {
    Hn;
    Gn;
    Yn;
    ut;
    wt;
    constructor(t, n, e, s, o) {
        this.Hn = t;
        this.Gn = n;
        this.Yn = e;
        this.ut = s;
        this.wt = o;
    }
}

const yu = (t, n) => {
    const e = t.length;
    for (let s = 0; s < e; s++) {
        const e = t[s];
        if (wu(e)) {
            for (const t in e) {
                const s = e[t];
                if (s == null || typeof s === "string" || t === or && ti(s)) {
                    continue;
                }
                n(s);
            }
        }
    }
};

const wu = t => typeof t === "object" && t !== null && !ti(t);

function Tn(t, n) {
    n.kt && n.kt[0] === "{" && (n.kt = `(${n.kt})`);
    const e = t.gt(n.kt, n.lt.length, n.ot);
    return [ e, n.lt ];
}

class bu {
    Kn;
    constructor(t) {
        this.Kn = t;
    }
}

const vu = t => new bu(t);

let gu = () => !1;

class Su {
    Vn;
    constructor(t) {
        this.Vn = t;
    }
}

class _u {
    NodeConstructor;
    DomRefConstructor;
    St;
    Jn;
    ht;
    Ct;
    Zn=new Map;
    te=new Map;
    ne=[];
    Un=[];
    Rt=new Set;
    Mt=new Set;
    Pt=new Set;
    Wn=new Set;
    ee;
    constructor(t, n, e, s, o, r) {
        this.NodeConstructor = t;
        this.DomRefConstructor = n;
        this.St = e;
        this.Jn = s;
        this.ht = o;
        this.Ct = r;
        this.ee = new $u(this);
    }
    async At() {
        return await this.ee.serialize();
    }
    getSeenRef(t) {
        return this.Zn.get(t);
    }
    Dn(t, n, e) {
        const s = {
            Bt: e,
            On: n
        };
        this.Zn.set(t, s);
        return s;
    }
    re(t) {
        const n = [];
        for (;t.On; ) {
            n.unshift(t.Bt);
            t = t.On;
        }
        n.unshift(t.Bt);
        return n.join(" ");
    }
    zn(t, n) {
        const e = this.re(t);
        n === void 0 && (n = this.Un.length);
        this.Un[n] = new Su(e);
        t.On = null;
        t.Bt = n;
    }
    _t(t, n = !1) {
        let e = this.Zn.get(t);
        let s;
        if (e) {
            e.On && this.zn(e);
            s = e.Bt;
        } else {
            s = this.Un.length;
            e = {
                Bt: s
            };
            this.Zn.set(t, e);
            this.Un.push(t);
        }
        return n ? e : s;
    }
    Bn(t) {
        return !!this.NodeConstructor && t instanceof this.NodeConstructor;
    }
    Qn(t) {
        return !!this.DomRefConstructor && t instanceof this.DomRefConstructor;
    }
    ie(t) {
        const n = this.Zn.get(t);
        return n && (n.On ? void 0 : n.Bt);
    }
    gt(t, n, e) {
        const s = t == null;
        s && (t = e.serialized || "" + e);
        let o = this.te.get(t);
        if (o === void 0) {
            o = this.ne.length;
            this.te.set(t, o);
            if (s) {
                this.ne.push(t);
            } else {
                let e = "(";
                for (let t = 0; t < n; t++) {
                    e += (t == 0 ? "p" : ",p") + t;
                }
                this.ne.push(e += ")=>" + t);
            }
        }
        return o;
    }
}

const ku = (t, n, e, s, o, r) => {
    if (!r) {
        const t = [];
        r = {
            write: n => {
                t.push(n);
            },
            toString: () => t.join("")
        };
    }
    gu = n ? t => t instanceof n : () => !1;
    return new _u(t, n, e, s, o, r);
};

const Eu = (t, n) => t[n];

const xu = (t, n = new WeakSet) => {
    const e = typeof Temporal !== "undefined";
    if (t == null || typeof t === "string" || typeof t === "number" || typeof t === "boolean" || typeof t === "bigint") {
        return !0;
    }
    if (typeof t === "object") {
        if (n.has(t)) {
            return !0;
        }
        n.add(t);
        const s = Object.getPrototypeOf(t);
        uu(t) && (t = iu(t));
        if (s == Object.prototype) {
            for (const e in t) {
                if (!xu(Oc(Eu, t, e), n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (s == Array.prototype) {
            for (let e = 0; e < t.length; e++) {
                if (!(e in t)) {
                    return !1;
                }
                if (!xu(t[e], n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (Xl(t)) {
            return !0;
        }
        if (Ki(t)) {
            return !0;
        }
        if (gr(t)) {
            return !0;
        }
        if (vs(t)) {
            return !0;
        }
        if (Zl(t)) {
            return !0;
        }
        if (t instanceof Error) {
            return !0;
        }
        if (t instanceof URL) {
            return !0;
        }
        if (t instanceof Date) {
            return !0;
        }
        if (e && t instanceof Temporal.Duration) {
            return !0;
        }
        if (e && t instanceof Temporal.Instant) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDate) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDateTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainMonthDay) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainYearMonth) {
            return !0;
        }
        if (e && t instanceof Temporal.ZonedDateTime) {
            return !0;
        }
        if (t instanceof RegExp) {
            return !0;
        }
        if (t instanceof URLSearchParams) {
            return !0;
        }
        if (t instanceof FormData) {
            return !0;
        }
        if (t instanceof Set) {
            return !0;
        }
        if (t instanceof Map) {
            return !0;
        }
        if (t instanceof Uint8Array) {
            return !0;
        }
        if (t instanceof $s) {
            return !0;
        }
        if (gu?.(t)) {
            return !0;
        }
    } else if (typeof t === "function") {
        if (Pe(t) || gf(t) || t === zs || t === Ls) {
            return !0;
        }
    } else if (t === Ui || t === Ri || t === Mi) {
        return !0;
    }
    return !1;
};

const Ru = (t, n) => {
    let e = Co(t) ? hn.call(t, 1, "", !0).replaceAll(/\n.*/gm, "") : typeof t === "function" ? t + "" : (t => {
        const n = new WeakSet;
        return JSON.stringify(t, (t, e) => {
            if (ke(e)) {
                if (n.has(e)) {
                    return `[Circular ${e.constructor.name}]`;
                }
                n.add(e);
            }
            return e;
        }, 2);
    })(t);
    e.length > 500 && (e = e.slice(0, 500) + '"...');
    e = e.replace(/\n/g, "\n" + n);
    return e.includes("\n") ? e = `\n${n}${e}` : e;
};

let Tu = !1;

const qu = (t, n = !1, e = "", s = 20) => {
    const o = n ? "[31m" : "";
    const r = n ? "[0m" : "";
    const i = e === "";
    const c = [];
    for (let i = 0; i < t.length; i++) {
        if (s && i > 2 * s) {
            c.push("...");
            break;
        }
        const l = t[i];
        let u = t[++i];
        if (l === 0) {
            const t = typeof u !== "number" && typeof u !== "string";
            t && (Tu = !0);
            const n = `{${ke(u) ? u.constructor.name : typeof u}}`;
            c.push(`${o}${n}${r} ${Ru(u, e + "  ")}`);
        } else {
            if (l === 3) {
                u = Mu(u);
            } else if (typeof u === "string") {
                u = JSON.stringify(u);
                u.length > 120 && (u = u.slice(0, 120) + '"...');
            } else {
                l === 14 ? u = `[\n${e}  ${u.join(`\n${e}  `)}\n${e}]` : Array.isArray(u) && (u = u.length ? `[\n${qu(u, n, e + "  ")}\n${e}]` : "[]");
            }
            c.push(`${o}${Pu(l)}${r} ${u}`);
        }
    }
    const l = c.map((t, n) => `${e}${i ? n + " " : ""}${t}`).join("\n");
    if (i) {
        const n = Tu ? "" : `(${JSON.stringify(t).length} chars)`;
        Tu = !1;
        return `\n${l}\n${n}`;
    }
    return l;
};

const Pu = t => pu[t] || `Unknown(${t})`;

const Mu = t => du[t] || `Unknown(${t})`;

function qn(t, n) {
    const e = (t, n) => t === 1 && typeof n === "string";
    const s = t => t === 14;
    const o = n => {
        const e = t[n + 1].split(" ");
        let s = t;
        let o = 1;
        let r = 0;
        let i = 0;
        let c = null;
        for (let n = 0; n < e.length; n++) {
            c = s;
            r = parseInt(e[n], 10) * 2;
            i = r + 1;
            o = s[r];
            s = s[i];
            if (o === 1) {
                const n = s;
                const e = n * 2;
                o = t[e];
                s = t[e + 1];
            }
        }
        if (c) {
            c[r] = 1;
            c[i] = n / 2;
        }
        t[n] = o;
        t[n + 1] = s;
    };
    for (let r = 0; r < t.length; r += 2) {
        e(t[r], t[r + 1]) ? o(r) : s(t[r]) && (n.Et = t[r + 1]);
    }
}

const Au = new WeakMap;

const Cu = new Map;

const Nu = (t, n, e) => {
    switch (n) {
      case 0:
        return e;

      case 1:
        return t._(e);

      case 2:
        if (!t.Et) {
            return Ui;
        }
        const s = t.Et[e];
        return s === -1 || s === void 0 ? Ui : t._(s);

      case 14:
        return e;

      case 3:
        return hu[e];

      case 4:
        return Array(e.length / 2);

      case 5:
        return {};

      case 9:
        {
            let n;
            if (typeof e === "string") {
                const [s, o, r] = e.split("#");
                const i = t._(s);
                const c = t._(o);
                n = xn(i, c, r || null, t);
            } else {
                n = xn("", e + "", null, t);
            }
            return n;
        }

      case 28:
        return new Ql(-1, -1, null, null, null, null);

      case 6:
        return new URL(e);

      case 7:
        return new Date(e);

      case 15:
        return Temporal.Duration.from(e);

      case 16:
        return Temporal.Instant.from(e);

      case 17:
        return Temporal.PlainDate.from(e);

      case 18:
        return Temporal.PlainDateTime.from(e);

      case 19:
        return Temporal.PlainMonthDay.from(e);

      case 20:
        return Temporal.PlainTime.from(e);

      case 21:
        return Temporal.PlainYearMonth.from(e);

      case 22:
        return Temporal.ZonedDateTime.from(e);

      case 8:
        const o = e.lastIndexOf("/");
        return RegExp(e.slice(1, o), e.slice(o + 1));

      case 23:
        return Error();

      case 29:
        return bf(null);

      case 30:
        return new Ci(t, 0);

      case 31:
        return new ps(t, null, null, null);

      case 32:
        return new Ni(t, null);

      case 33:
        return new ji(t, null, void 0, {});

      case 34:
        return new ts(t, null);

      case 35:
        {
            const n = e;
            const s = n[0];
            const o = n[1];
            const r = Nu(t, s, o);
            const i = cu(r, 0, t);
            uc(s) && Cu.set(r, {
                t: s,
                v: o
            });
            n[0] = 0;
            n[1] = r;
            return i;
        }

      case 13:
        return new URLSearchParams(e);

      case 36:
        return new FormData;

      case 37:
        return new ws(null, null, null, null, 0, null);

      case 12:
        return BigInt(e);

      case 25:
        return new Set;

      case 26:
        return new Map;

      case 24:
        let r;
        let i;
        const c = new Promise((t, n) => {
            r = t;
            i = n;
        });
        Au.set(c, [ r, i ]);
        c.catch(() => {});
        return c;

      case 27:
        const l = e.length;
        const u = l >>> 2;
        const f = l & 3;
        const a = u * 3 + (f ? f - 1 : 0);
        return new Uint8Array(a);

      case 38:
        return p(null);

      case 10:
        return Pn(t, e);

      case 11:
        const h = Pn(t, e);
        if (Co(h)) {
            ml(h);
            return jl(h);
        }
        throw Te(17, [ typeof h ]);

      case 39:
        return new $s({});

      case 40:
        return new Ti(null, null, null, null);

      default:
        throw Te(18, [ n ]);
    }
};

function Pn(t, n) {
    return n ? t.rootVNode ? Jo(t.rootVNode, n) : void 0 : t.element?.ownerDocument;
}

const Iu = (t, n, e) => {
    let s = null;
    let o = null;
    if (Re(t)) {
        o = t;
    } else {
        if (!xe(t)) {
            throw Te(7, [ t ]);
        }
        s = t;
    }
    return lf(s, n, null, o, e);
};

const ju = (t, n, e) => lf(null, n, t, null, e);

const Ou = (t, n) => lf(null, t, null, null, n);

const Lu = (t, n, e) => {
    const s = Ou(t, e);
    s.se(n);
    return s;
};

const Fu = (t, n, e, s) => {
    const o = Iu(t, n, s);
    o.se(e);
    return o;
};

const Du = (t, n, e, s) => {
    const o = ju(t, n, s);
    o.se(e);
    return o;
};

const zu = (t, n) => {
    typeof globalThis.__qwik_reg_symbols === "undefined" && (globalThis.__qwik_reg_symbols = new Map);
    globalThis.__qwik_reg_symbols.set(n, t);
    return t;
};

function Mn(t) {
    return t === null || typeof t === "string" || typeof t === "number" || typeof t === "boolean";
}

const Uu = (t, n, e) => new ps(null, t, n, e || null);

class Vu {
    oe;
    ht;
    It;
    _;
    Ft;
    le=0;
    ue=null;
    ce=null;
    l=null;
    u=null;
    o=0;
    constructor(t, n) {
        this.Ft = t;
        this.It = n;
        this.oe = ei;
        this.ht = new WeakMap;
        this._ = () => {
            throw Error("Not implemented");
        };
    }
    trackSignalValue(t, n, e, s) {
        return Dc(t, n, e, this, s);
    }
    serializationCtxFactory(t, n, e, s) {
        return ku(t, n, e, this.setHostProp.bind(this), this.ht, s);
    }
    ft() {
        if (this.o === 0) {
            this.u?.();
            this.l = null;
        }
    }
}

class Wu {}

function An(t, n, e) {
    return () => {
        t.currentStyleScoped = n;
        t.parentComponentFrame = e;
    };
}

async function Cn(t, e, s) {
    const o = [ e ];
    const r = t => o.push(t);
    await (async () => {
        for (;o.length; ) {
            try {
                const e = o.pop();
                if (e === Wu) {
                    const t = o.pop();
                    await n(() => o.push(t()));
                    continue;
                }
                if (typeof e === "function") {
                    e === Promise ? o.push(await o.pop()) : await e.apply(t);
                    continue;
                }
                Nn(t, r, e, s);
            } finally {
                const n = t.streamHandler.waitForPendingFlush();
                gr(n) && await n;
            }
        }
    })();
}

function Nn(t, n, e, s) {
    if (e == null) {
        t.textNode("");
    } else if (typeof e === "boolean") {
        t.textNode("");
    } else if (typeof e === "number") {
        t.textNode(e + "");
    } else if (typeof e === "string") {
        t.textNode(e);
    } else if (typeof e === "object") {
        if (Array.isArray(e)) {
            for (let t = e.length - 1; t >= 0; t--) {
                n(e[t]);
            }
        } else if (Jl(e)) {
            (function s(t, n) {
                const e = n instanceof ps ? n.it() : n;
                if (e instanceof ji) {
                    const n = e.xt;
                    if (n && !(e.h & 256)) {
                        t._t(e);
                        t.Rt.add(e);
                    }
                }
            })(t.serializationCtx, e);
            t.openFragment(Wi);
            const o = t.getOrCreateLastNode();
            const r = e instanceof ps ? e.it() : e;
            n(t.closeFragment);
            n(() => Dc(r, o, ".", t));
            n(Wu);
        } else if (gr(e)) {
            t.openFragment(Wi);
            n(t.closeFragment);
            n(e);
            n(Promise);
            n(() => t.streamHandler.flush());
        } else if (function o(t) {
            return !!t[Symbol.asyncIterator];
        }(e)) {
            n(async () => {
                for await (const n of e) {
                    await Cn(t, n, {
                        currentStyleScoped: s.currentStyleScoped,
                        parentComponentFrame: s.parentComponentFrame
                    });
                    await t.streamHandler.flush();
                }
            });
        } else {
            const o = e;
            const r = o.type;
            if (typeof r === "string") {
                (function e(t, n) {
                    const e = Ji(t, "class") != null;
                    if (!e && n) {
                        t.constProps || (t.constProps = {});
                        t.constProps.class = "";
                    }
                })(o, s.currentStyleScoped);
                let i = null;
                const c = t.openElement(r, o.key, o.varProps, o.constProps, s.currentStyleScoped, i, !!(o.flags & 4));
                c && t.htmlNode(c);
                n(t.closeElement);
                if (r === "head") {
                    t.emitQwikLoaderAtTopIfNeeded();
                    t.emitPreloaderPre();
                    n(t.additionalHeadNodes);
                } else if (r === "body") {
                    n(t.additionalBodyNodes);
                } else if (!t.isHtml && !t._didAddQwikLoader && !t.Tt) {
                    t.emitQwikLoaderAtTopIfNeeded();
                    t.emitPreloaderPre();
                    t._didAddQwikLoader = !0;
                }
                const l = o.children;
                l != null && n(l);
            } else if (Re(r)) {
                if (r === Ls) {
                    const e = o.key != null ? {
                        [sr]: o.key
                    } : {};
                    t.openFragment(e);
                    n(t.closeFragment);
                    const s = o.children;
                    s != null && n(s);
                } else if (r === zs) {
                    const e = s.parentComponentFrame;
                    if (e) {
                        const r = e.componentNode.id || "";
                        const i = {};
                        const c = Ji(o, $r);
                        c && (i[$r] = c);
                        i["q:sparent"] = r;
                        t.openProjection(i);
                        const l = e.componentNode;
                        const u = t.getOrCreateLastNode();
                        const f = function a(t, n, e) {
                            const s = n.constProps;
                            if (s && typeof s == "object" && "name" in s) {
                                const n = s.name;
                                if (n instanceof ps) {
                                    return Dc(n, t, ":", e);
                                }
                            }
                            return Ji(n, "name") || "";
                        }(l, o, t);
                        i[Oe] = f;
                        n(An(s, s.currentStyleScoped, s.parentComponentFrame));
                        n(t.closeProjection);
                        const h = o.children || null;
                        const d = e.consumeChildrenForSlot(u, f) || h;
                        h && d !== h && t.addUnclaimedProjection(e, "", h);
                        n(d);
                        n(An(s, e.projectionScopedStyle, e.projectionComponentFrame));
                    } else {
                        let n = Wi;
                        t.openFragment(n);
                        t.closeFragment();
                    }
                } else if (r === Ws) {
                    t.commentNode(Ji(o, "data") || "");
                } else if (r === Xs) {
                    t.streamHandler.flush();
                    const e = o.children;
                    let r;
                    r = Re(e) ? e({
                        async write(n) {
                            await Cn(t, n, {
                                currentStyleScoped: s.currentStyleScoped,
                                parentComponentFrame: s.parentComponentFrame
                            });
                            await t.streamHandler.flush();
                        }
                    }) : e;
                    n(r);
                    gr(r) && n(Promise);
                } else if (r === Vs) {
                    t.htmlNode(Ji(o, "data"));
                } else if (r === Qs) {
                    t.streamHandler.streamBlockStart();
                    n(() => t.streamHandler.streamBlockEnd());
                    n(o.children);
                } else if (gf(r)) {
                    const e = {};
                    t.openComponent(e);
                    const i = t.getOrCreateLastNode();
                    const c = t.getParentComponentFrame();
                    c.distributeChildrenIntoSlots(o.children, s.currentStyleScoped, s.parentComponentFrame);
                    const l = ((t, n, e) => {
                        const s = t.getOrCreateLastNode();
                        const [o] = e[vf];
                        const r = n.props;
                        r && r.children && delete r.children;
                        s.setProp(Ne, o);
                        s.setProp(or, r);
                        n.key !== null && s.setProp(sr, n.key);
                        return Ds(t, s, s, o, r);
                    })(t, o, r);
                    n(An(s, s.currentStyleScoped, s.parentComponentFrame));
                    n(t.closeComponent);
                    if (gr(l)) {
                        n(async () => {
                            const t = await l;
                            const e = xr(i.getProp(Ue));
                            n(t);
                            n(An(s, e, c));
                        });
                    } else {
                        n(l);
                        const t = xr(i.getProp(Ue));
                        n(An(s, t, c));
                    }
                } else {
                    const e = {
                        [sr]: o.key
                    };
                    t.openFragment(e);
                    n(t.closeFragment);
                    const s = t.getParentComponentFrame();
                    const i = ((t, n, e, s) => {
                        const o = t.getOrCreateLastNode();
                        return Ds(t, o, n, e, s.props);
                    })(t, s && s.componentNode, r, o);
                    n(i);
                    gr(i) && n(Promise);
                }
            }
        }
    }
}

const Qu = () => tf;

const Xu = async t => {
    const [n, e] = tf;
    const s = await n(t);
    s && typeof s === "object" ? e.r ? Object.assign(e.r, s) : e.r = gn(n.$, s, 1) : e.r = s;
    return {
        r: e.r
    };
};

const Bu = (t, n) => {
    const {val: e, set: s, iCtx: o} = lo();
    if (e) {
        return e;
    }
    const r = lf(null, "_rsc", Xu, null, [ t, {} ], o.$);
    const i = es(r, {
        timeout: n?.timeout,
        container: o.$,
        concurrency: 0
    });
    i.p();
    const c = {
        __brand: "resource",
        signal: i,
        get value() {
            return i.promise().then(() => i.error ? Promise.reject(i.error) : i.value.r);
        },
        get loading() {
            return i.loading;
        }
    };
    s(c);
    return c;
};

const Ju = ({value: t, onResolved: n, onPending: e, onRejected: s}) => {
    if (gr(t)) {
        return t.then(n, s);
    }
    const o = Hu(t);
    const r = o ? t.signal : t;
    if (e && r.loading) {
        return e();
    }
    if (s && r.error) {
        return s(r.error);
    }
    const i = o ? r.value?.r : r.value;
    return gr(i) ? i.then(n, s) : n(i);
};

const Hu = t => t && t.__brand === "resource";

function In(t, n, e, s) {
    let o = null;
    const r = e;
    const i = t => {
        o = (o == null ? "" : o + "|") + t;
    };
    const c = n => {
        n.bt.startsWith("_") || !n.qt?.length && !s || (n = lf(null, "_run", N, null, [ n ]));
        return En(t, n);
    };
    if (Array.isArray(r)) {
        for (let e = 0; e < r.length; e++) {
            const o = r[e];
            if (Pe(o)) {
                i(c(o));
                jn(t, n, o);
            } else if (o != null) {
                const e = In(t, n, o, s);
                e && i(e);
            }
        }
    } else if (Pe(r)) {
        o = c(r);
        jn(t, n, r);
    }
    return o;
}

function jn(t, n, e) {
    const s = Pr(n);
    if (s) {
        const [n, o] = s;
        const r = ((t, n) => t + ":" + n)(n, o);
        t.Pt.add(r);
        t.Mt.add(e);
    }
}

const Yu = (t, n, e) => {
    Zu(e?.passive ? "q-ep:" : "q-e:", t, n, e);
};

const Gu = (t, n, e) => {
    Zu(e?.passive ? "q-dp:" : "q-d:", t, n, e);
};

const Ku = (t, n, e) => {
    Zu(e?.passive ? "q-wp:" : "q-w:", t, n, e);
};

const Zu = (t, n, e, s) => {
    const {isAdded: o, addEvent: r} = tc();
    if (o) {
        return;
    }
    if (e) {
        if (Array.isArray(n)) {
            for (let o = 0; o < n.length; o++) {
                const i = n[o];
                r(t + qr(i), e, s);
            }
        } else {
            r(t + qr(n), e, s);
        }
    }
};

const tc = () => {
    const t = Ic();
    const n = t.m;
    const e = n;
    let s = t.$.getHostProp(e, hr);
    if (s === null) {
        s = {};
        t.$.setHostProp(e, hr, s);
    }
    let o = t.$.getHostProp(e, dr);
    o === null && (o = 0);
    t.$.setHostProp(e, dr, o + 1);
    let r = t.$.getHostProp(e, pr);
    if (r === null) {
        r = [];
        t.$.setHostProp(e, pr, r);
    }
    for (;r.length <= o; ) {
        r.push(!1);
    }
    return {
        isAdded: r[o],
        addEvent: (t, n, e) => {
            r[o] = !0;
            let i = s[t];
            i || (s[t] = i = {
                qrls: [],
                capture: !1,
                preventdefault: !1,
                stoppropagation: !1
            });
            i.qrls.push(n);
            e?.capture && (i.capture = !0);
            e?.preventdefault && (i.preventdefault = !0);
            e?.stoppropagation && (i.stoppropagation = !0);
        }
    };
};

const nc = function(t, n) {
    if (!t.detail.files.some(t => n.getAttribute("data-qwik-inspector")?.startsWith(t))) {
        return;
    }
    if (typeof this === "string") {
        const t = Jn(n);
        nf(ef(t, this));
    }
    const e = tf[0];
    const s = Jn(n);
    sn(s, e, 4);
    const o = n.ownerDocument;
    o.__hmrDone = o.__hmrT;
};

let ec;

function On() {
    const t = Cc();
    if (!t) {
        return;
    }
    ec ||= ju(nc, "_hmr");
    const n = t.m;
    const e = ec.w([ n ]);
    Gu("qHmr", e);
}

function Ln(t, n, e, s, o) {
    const r = Ao();
    zo(r, Oe, o);
    r.parent = n;
    zo(n, o, r);
    zo(r, Ne, e);
    zo(r, or, s);
    r.dirty = 4;
    tn(t, r, 1);
    return r;
}

function Fn(t, n) {
    zo(t, Ie, n);
    t.flags |= 2048;
}

function Dn(t, n, e) {
    zo(n, or, e);
    sn(t, n, 4);
}

function zn(t, n, e, s) {
    zo(n, s, null);
    const o = [];
    kt(t, o, e);
    tl(o);
    if (e.flags & 2048) {
        const t = Do(e, Ie, null);
        t && t.replaceChildren();
        zo(e, Ie, null);
        e.flags &= -2049;
    }
}

let rc = Promise.resolve();

const ic = new Set([ "constructor", "prototype", "toString", "valueOf", "toJSON", "then" ]);

const sc = (t, n) => {
    if (typeof t === "number") {
        return !0;
    }
    return typeof t === "string" && t !== "__proto__" && (typeof n !== "function" || !ic.has(t));
};

const oc = (t, n, e, s) => {
    if (e === 0) {
        return;
    }
    e !== 4 && Array.isArray(s) && (s = lc(t, s));
    switch (e) {
      case 4:
        lc(t, s, n);
        break;

      case 5:
        if (s === 0) {
            break;
        }
        for (let t = 0; t < s.length; t += 2) {
            const e = s[t];
            const o = s[t + 1];
            if (!sc(e, o)) {
                continue;
            }
            n[e] = o;
        }
        break;

      case 28:
        const o = n;
        const r = s;
        o.wt = r[0];
        o.h = r[1];
        o.Bt = r[2];
        o.ct = r[3];
        o.Nt = r[4];
        break;

      case 29:
        n[vf][0] = s[0];
        break;

      case 35:
        {
            const e = lu(n);
            const o = Cu.get(e);
            if (o) {
                Cu.delete(e);
                oc(t, e, o.t, o.v);
            }
            const [, r, i] = s;
            const c = ru(n);
            c.h = r;
            c.ut = i;
            Wn(c.ut, e);
            break;
        }

      case 30:
        {
            const t = n;
            const e = s;
            t.Gt = e[0];
            t.ut = new Set(e.slice(1));
            Vn(t.ut, t);
            break;
        }

      case 31:
        {
            const e = n;
            const o = s;
            e.ot = t.getSyncFn(o[0]);
            e.lt = o[1];
            e.Gt = Ri;
            e.h = o[2];
            e.h |= 1;
            e.m = o[3];
            e.ut = new Set(o.slice(4));
            (function r(t) {
                if (t.m !== null && Co(t.m)) {
                    const n = t.m;
                    const e = t.ut;
                    let s = !1;
                    if (e) {
                        for (const o of e) {
                            const e = o.property;
                            if (xe(e)) {
                                const o = Do(n, e, null);
                                if (o !== null) {
                                    t.Gt = o;
                                    s = !0;
                                    break;
                                }
                            }
                        }
                    }
                    if (!s) {
                        const e = $l(n);
                        e && n.firstChild === n.lastChild && Oo(e) && (t.Gt = dl(e));
                    }
                }
            })(e);
            Vn(e.ut, e);
            break;
        }

      case 33:
        {
            const t = n;
            const e = s;
            t.Zt = e[0];
            e[1] && (t.ut = new Set(e[1]));
            e[2] && (t.dt = new Set(e[2]));
            e[3] && (t.$t = new Set(e[3]));
            e[4] && (t.an = e[4]);
            t.h = e[5] ?? 0;
            t.h & 64 && (t.fn = !0);
            const o = e.length > 6;
            o && (t.Gt = e[6]);
            t.Gt === Ri && (t.h |= 1);
            const r = e[7] ?? 0;
            t.expires = Math.abs(r);
            r < 0 && (t.h |= 256);
            if (e[8] !== void 0 && e[8] !== 1) {
                t.dn = e[8] ?? 1;
                t.pn = [];
            }
            t.$n = e[9] ?? 0;
            Vn(t.ut, t);
            Vn(t.dt, t);
            Vn(t.$t, t);
            break;
        }

      case 34:
      case 32:
        {
            const o = n;
            const r = s;
            o.Zt = r[0];
            const i = o.Zt.resolve(t).catch(() => {});
            rc = rc.finally(() => i);
            r[1] && (o.ut = new Set(r[1]));
            const c = r.length > 2;
            c && (o.Gt = r[2]);
            e !== 34 && o.Gt !== Ri && (o.h &= -2);
            Vn(o.ut, o);
            break;
        }

      case 23:
        {
            const t = s;
            n.message = t[0];
            for (let e = 1; e < t.length; e += 2) {
                n[t[e]] = t[e + 1];
            }
            break;
        }

      case 36:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.append(e[n++], e[n]);
            }
            break;
        }

      case 37:
        {
            const t = n;
            const [e, o, r, i, c, l] = s;
            t.type = e;
            t.key = o;
            t.varProps = r;
            t.constProps = i || null;
            t.children = c;
            t.toSort = !!l;
            break;
        }

      case 25:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.add(e[n]);
            }
            break;
        }

      case 26:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.set(e[n++], e[n]);
            }
            break;
        }

      case 24:
        {
            const t = n;
            const [e, o] = s;
            const [r, i] = Au.get(t);
            e ? r(o) : i(o);
            break;
        }

      case 27:
        const i = n;
        const c = atob(s);
        let l = 0;
        for (let t = 0; t < c.length; t++) {
            const n = c[t];
            i[l++] = n.charCodeAt(0);
        }
        break;

      case 38:
        const u = n;
        const f = s;
        let a = f[0];
        if (a === Ui) {
            a = new ws(Ls, f[1], f[2], null, 0, null);
            a._proxy = u;
        }
        u[Fi] = a;
        const h = u[Di];
        h.ut = f[3];
        Wn(h.ut, u);
        break;

      case 39:
        {
            const t = n;
            t.data.j = s[0];
            t.data.et = s[1];
            break;
        }

      case 40:
        {
            const t = n;
            const e = s;
            t.consumer = e[0];
            t.property = e[1];
            t.data = e[2];
            (function o(t) {
                const n = import.meta.env.TEST ? ui() : se;
                const e = t.consumer;
                if (n && !e) {
                    return;
                }
                e[fi] ||= new Map;
                e[fi].set(t.property, t);
            })(t);
            break;
        }

      default:
        throw Te(16, [ e ]);
    }
};

const lc = (t, n, e = Array(n.length / 2)) => {
    for (let s = 0; s < n.length; s += 2) {
        e[s / 2] = Un(t, n[s], n[s + 1]);
    }
    return e;
};

function Un(t, n, e) {
    if (n === 0) {
        return e;
    }
    const s = Nu(t, n, e);
    uc(n) && oc(t, s, n, e);
    return s;
}

function Vn(t, n) {
    if (t) {
        for (const e of t) {
            e.backRef ||= new Set;
            e.backRef.add(n);
        }
    }
}

function Wn(t, n) {
    if (t) {
        for (const [, e] of t) {
            Vn(e, n);
        }
    }
}

const uc = t => t >= 23 || t === 4 || t === 5;

const cc = new WeakMap;

const fc = Symbol();

const ac = (t, n) => {
    if (!Array.isArray(n) || Co(n) || (t => ke(t) && fc in t)(n)) {
        return n;
    }
    let e = cc.get(n);
    if (!e) {
        const s = Array(n.length / 2).fill(void 0);
        e = new Proxy(s, new hc(t, n));
        cc.set(n, e);
    }
    return e;
};

class hc {
    $;
    fe;
    ae;
    constructor(t, n) {
        this.$ = t;
        this.fe = n;
        this.ae = this.fe.length / 2;
    }
    get(t, n, e) {
        if (n === fc) {
            return t;
        }
        const s = typeof n === "number" ? n : typeof n === "string" ? parseInt(n, 10) : NaN;
        if (Number.isNaN(s) || s < 0 || s >= this.ae) {
            return Reflect.get(t, n, e);
        }
        const o = s * 2;
        const r = this.fe[o];
        const i = this.fe[o + 1];
        if (r === 0) {
            return i;
        }
        const c = this.$;
        const l = Nu(c, r, i);
        Reflect.set(t, n, l);
        this.fe[o] = 0;
        this.fe[o + 1] = l;
        uc(r) && oc(c, l, r, i);
        return l;
    }
    has(t, n) {
        if (n === fc) {
            return !0;
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    set(t, n, e, s) {
        if (n === fc) {
            return !1;
        }
        const o = Reflect.set(t, n, e, s);
        const r = typeof n === "number" ? n : parseInt(n, 10);
        if (Number.isNaN(r) || r < 0 || r >= this.fe.length / 2) {
            return o;
        }
        const i = r * 2;
        this.fe[i] = 0;
        this.fe[i + 1] = e;
        return !0;
    }
}

async function Qn(t) {
    const n = ku(null, null, () => "", () => {}, new WeakMap);
    n._t(t);
    await n.At();
    return "" + n.Ct;
}

function Xn(t) {
    if (t == null) {
        throw Error("No state data to deserialize");
    }
    const n = JSON.parse(t);
    if (!Array.isArray(n) || n.length < 2 || typeof n[0] !== "number") {
        throw Error("Invalid state data");
    }
    const e = function s(t) {
        let n;
        const e = {
            _: t => Bn(t, n),
            getSyncFn: () => () => {},
            ht: new WeakMap,
            element: null,
            Et: null
        };
        qn(t, e);
        n = ac(e, t);
        e.Nt = n;
        return e;
    }(n);
    return Un(e, n[0], n[1]);
}

function Bn(t, n) {
    if (typeof t === "string") {
        t = parseInt(t, 10);
        return n[t];
    }
    return n[t];
}

const dc = (t, n) => {
    const e = new WeakSet;
    return Oc(pc, t, e, "_", n);
};

const pc = (t, n, e, s) => {
    const o = lu(t);
    if (o == null) {
        return t;
    }
    if (mc(o)) {
        if (typeof o === "object") {
            if (n.has(o)) {
                return t;
            }
            n.add(o);
        }
        if (Jl(o)) {
            return t;
        }
        if (xu(o)) {
            return t;
        }
        if (o.__brand || o.__brand__) {
            return t;
        }
        const r = typeof o;
        switch (r) {
          case "object":
            if (gr(o)) {
                return t;
            }
            if ((t => t && typeof t.nodeType === "number")(o)) {
                return t;
            }
            if (Ee(o)) {
                let s = 0;
                for (let t = 0; t < o.length; t++) {
                    if (!(t in o)) {
                        throw Te(3, [ o ]);
                    }
                    const r = o[t];
                    if (t !== s) {
                        throw Te(3, [ o ]);
                    }
                    pc(r, n, e + "[" + t + "]");
                    s = t + 1;
                }
                return t;
            }
            if (o instanceof mi) {
                return t;
            }
            if (_e(o)) {
                for (const [t, s] of Object.entries(o)) {
                    pc(s, n, e + "." + t);
                }
                return t;
            }
            break;
        }
        let i;
        i = s || "Value cannot be serialized";
        e !== "_" && (i += ` in ${e},`);
        if (r === "object") {
            i += ` because it's an instance of "${t?.constructor.name}". You might need to use 'noSerialize()' or use an object literal instead. Check out https://qwik.dev/docs/advanced/dollar/`;
        } else if (r === "function") {
            const n = t.name;
            i += ` because it's a function named "${n}". You might need to convert it to a QRL using $(fn):\n\nconst ${n} = $(${t + ""});\n\nPlease check out https://qwik.dev/docs/advanced/qrl/ for more information.`;
        }
        throw Te(3, [ i ]);
    }
    return t;
};

const $c = /*#__PURE__*/ new WeakSet;

const mc = t => {
    if (ke(t) || Re(t)) {
        return !$c.has(t) && !(bc in t);
    }
    return !0;
};

const yc = t => !!t && (ke(t) || typeof t === "function") && ($c.has(t) || bc in t);

const wc = t => {
    (ke(t) && t !== null || typeof t === "function") && $c.add(t);
    return t;
};

const bc = Symbol();

const vc = Symbol();

const gc = t => /*#__PURE__*/ Object.freeze({
    id: qr(t)
});

const Sc = (t, n) => {
    const {val: e, set: s, iCtx: o} = lo();
    if (e !== void 0) {
        return;
    }
    ce && kc(t);
    ce && dc(n);
    o.$.setContext(o.m, t, n);
    s(1);
};

const _c = (t, n) => {
    const {val: e, set: s, iCtx: o} = lo();
    if (e !== void 0) {
        return e;
    }
    ce && kc(t);
    const r = o.$.resolveContext(o.m, t);
    if (typeof n === "function") {
        return s(Zn(void 0, n, r));
    }
    if (r !== void 0) {
        return s(r);
    }
    if (n !== void 0) {
        return s(n);
    }
    throw Te(8, [ t.id ]);
};

const kc = t => {
    if (!ke(t) || typeof t.id !== "string" || t.id.length === 0) {
        throw Te(11, [ t ]);
    }
};

const Ec = t => {
    const n = Nc();
    const e = n.m;
    if (!e) {
        return;
    }
    return n.$?.resolveContext(e, t);
};

const xc = /*#__PURE__*/ gc("qk-error");

const Rc = t => 33 <= t && t <= 46;

const Tc = (t, n, e) => {
    let s = 0;
    for (;n < e; ) {
        const e = t.charCodeAt(n);
        if (e === 92) {
            n += 2;
        } else {
            if (s === 0 && Rc(e)) {
                break;
            }
            e === 123 ? s++ : e === 125 && s--;
            n++;
        }
    }
    return n;
};

function Jn(t) {
    const n = Yn(t);
    if (!n) {
        throw Te(24);
    }
    return Hn(n);
}

function Hn(t) {
    const n = t;
    return n.qContainer ||= new Pc(n);
}

function Yn(t) {
    return t.closest("[q\\:container]:not([q\\:container=html]):not([q\\:container=text])");
}

const qc = t => t instanceof Pc;

class Pc extends Vu {
    element;
    qContainer;
    qManifestHash;
    rootVNode;
    document;
    ht=new WeakMap;
    he;
    ue;
    Et=null;
    vNodeLocate=t => Jo(this.rootVNode, t);
    de;
    pe;
    $e=null;
    constructor(t) {
        super({}, t.getAttribute("q:locale"));
        this.qContainer = t.getAttribute(Ge);
        if (!this.qContainer) {
            throw Te(25);
        }
        this.document = t.ownerDocument;
        this.element = t;
        this.ce = t.getAttribute(Xe);
        this.ue = t.getAttribute("q:instance");
        this.qManifestHash = t.getAttribute("q:manifest-hash");
        this.rootVNode = Po(this.element);
        this.de = [];
        this.pe = [];
        const n = this.element.ownerDocument;
        n.qVNodeData || function e(t) {
            const n = "q:container";
            const e = "/" + n;
            const s = "q:ignore";
            const o = "/" + s;
            const r = "q:container-island";
            const i = "/" + r;
            const c = t;
            const l = c.qVNodeData || (c.qVNodeData = new WeakMap);
            const u = t.body;
            const f = u.getAttribute;
            const a = u.hasAttribute;
            const h = ((t, n) => {
                let e;
                for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
                    t = Object.getPrototypeOf(t);
                }
                return e || function() {
                    return this[n];
                };
            })(u, "nodeType");
            const d = t => {
                const n = t.querySelectorAll('script[type="qwik/vnode"]');
                for (let t = 0; t < n.length; t++) {
                    const e = n[t];
                    const s = e.closest("[q\\:container]");
                    s.qVnodeData = e.textContent;
                    s.qVNodeRefs = new Map;
                }
                const e = t.querySelectorAll("[q\\:shadowroot]");
                for (let t = 0; t < e.length; t++) {
                    const n = e[t];
                    const s = n.shadowRoot;
                    s && d(s);
                }
            };
            d(t);
            const p = t => {
                const c = h.call(t);
                if (c === 1) {
                    const e = f.call(t, n);
                    if (e === null) {
                        if (a.call(t, "q:shadowroot")) {
                            return 6;
                        }
                        const n = a.call(t, ":");
                        return n ? 2 : 0;
                    }
                    return 3;
                }
                if (c === 8) {
                    const c = t.nodeValue || "";
                    if (c.startsWith(r)) {
                        return 65;
                    }
                    if (c.startsWith(s)) {
                        return 16;
                    }
                    if (c.startsWith(n)) {
                        return 9;
                    }
                    if (c.startsWith(i)) {
                        return 64;
                    }
                    if (c.startsWith(o)) {
                        return 32;
                    }
                    if (c.startsWith(e)) {
                        return 8;
                    }
                }
                return 0;
            };
            const $ = t => {
                for (;t && (t = t.nextSibling) && p(t) === 0; ) {}
                return t;
            };
            const m = (n, e, s, o, r, i) => {
                const c = r.length;
                let u = 0;
                let f = -1;
                let a = 0;
                let h = 0;
                let d = 0;
                let y = -1;
                let w = null;
                const b = () => {
                    let t = 0;
                    for (;Rc(d = r.charCodeAt(a)); ) {
                        t += 1 << d - 33;
                        a++;
                        if (a >= c) {
                            break;
                        }
                    }
                    return t;
                };
                do {
                    if (s === o) {
                        return;
                    }
                    w = null;
                    const v = s == e ? 2 : p(s);
                    if (v === 3) {
                        const t = s;
                        let e = s;
                        for (;e && !(w = $(e)); ) {
                            e = e.parentNode;
                        }
                        m(n, t, s, w, t.qVnodeData || "", t.qVNodeRefs);
                    } else if (v === 16) {
                        let t = s;
                        do {
                            t = n.nextNode();
                            if (!t) {
                                throw Error(`Island inside \x3c!--${s?.nodeValue}--\x3e not found!`);
                            }
                        } while (p(t) !== 65);
                        w = null;
                    } else if (v === 64) {
                        w = s;
                        let t;
                        do {
                            w = n.nextNode();
                            if (!w) {
                                throw Error("Ignore block not closed!");
                            }
                            t = p(w);
                        } while (t !== 32 && t !== 65);
                        w = null;
                    } else if (v === 9) {
                        w = s;
                        do {
                            w = $(w);
                            if (!w) {
                                throw Error(`\x3c!--${s?.nodeValue}--\x3e not closed!`);
                            }
                        } while (p(w) !== 8);
                        m(n, s, s, w, "", null);
                    } else if (v === 6) {
                        w = $(s);
                        const n = s;
                        const e = n?.shadowRoot;
                        e && m(t.createTreeWalker(e, 129), null, e, null, "", null);
                    }
                    if ((v & 2) === 2) {
                        if (f < u) {
                            f === -1 && (f = 0);
                            a = h;
                            if (a < c) {
                                f += b();
                                const t = d === 126;
                                if (t) {
                                    y = f;
                                    a++;
                                    d = a < c ? r.charCodeAt(h) : 33;
                                }
                                h = Tc(r, a, c);
                            } else {
                                f = Number.MAX_SAFE_INTEGER;
                            }
                        }
                        if (u === f) {
                            y === u && i.set(u, s);
                            const t = r.substring(a, h);
                            l.set(s, t);
                        }
                        u++;
                    }
                } while (s = w || n.nextNode());
            };
            const y = t.createTreeWalker(t, 129);
            m(y, null, y.firstChild(), null, "", null);
        }(n);
        this.he = Qe(n, this.ue) || Vi;
        this.me();
        t.setAttribute(Ge, "resumed");
        t.qContainer = this;
        t.qDestroy = () => this.En();
        const s = t.querySelectorAll('script[type="qwik/state"]');
        if (s.length !== 0) {
            const t = s[s.length - 1];
            this.de = JSON.parse(t.textContent);
            qn(this.de, this);
            this.pe = ac(this, this.de);
        }
        this.ye();
        !ae && t.isConnected && t.dispatchEvent(new CustomEvent("qresume", {
            bubbles: !0
        }));
    }
    En() {
        this.vNodeLocate = () => null;
        this.de.length = 0;
        this.pe.length = 0;
        this._ = () => {};
        const t = this.element;
        t.qContainer = void 0;
        t.qVnodeData = void 0;
        t.qVNodeRefs = void 0;
        t.removeAttribute(Ge);
        t.ownerDocument.qVNodeData = void 0;
    }
    ye() {
        const t = this.element.ownerDocument;
        const n = t.head;
        const e = t.body.querySelectorAll(ze);
        const s = e.length;
        if (s) {
            const o = t.createDocumentFragment();
            for (let t = 0; t < s; t++) {
                o.appendChild(e[t]);
            }
            n.appendChild(o);
        }
    }
    qn(t, n) {
        this.pe[t] = n;
    }
    parseQRL(t) {
        const n = Rn(t, this);
        return n;
    }
    handleError(t, n) {
        if (ce && n) {
            if (typeof document !== "undefined") {
                It(n, t);
                sn(this, n, 256);
            }
            t && t instanceof Error && ("hostElement" in t || (t.hostElement = n + ""));
            if (!(t => {
                if (t && t instanceof Error && "plugin" in t) {
                    return !1;
                }
                return !0;
            })(t)) {
                throw t;
            }
        }
        const e = n && this.resolveContext(n, xc);
        if (!e) {
            throw t;
        }
        e.error = t;
    }
    setContext(t, n, e) {
        let s = this.getHostProp(t, Ve);
        s == null && this.setHostProp(t, Ve, s = []);
        ve(s, n.id, e, 0, !0);
    }
    resolveContext(t, n) {
        for (;t; ) {
            const e = this.getHostProp(t, Ve);
            if (e != null && Se(e, n.id, 0)) {
                return ge(e, n.id, 0);
            }
            t = this.getParentHost(t);
        }
        return;
    }
    getParentHost(t) {
        let n = t.parent;
        for (;n; ) {
            if (Lo(n)) {
                if (Do(n, Ne, null) !== null) {
                    return n;
                }
                n = n.parent || n.slotParent;
            } else {
                n = n.parent;
            }
        }
        return null;
    }
    setHostProp(t, n, e) {
        const s = t;
        zo(s, n, e);
    }
    getHostProp(t, n) {
        const e = t;
        let s = null;
        switch (n) {
          case lr:
          case or:
          case Ne:
          case Ve:
          case We:
          case $r:
            s = this._;
            break;

          case ur:
          case dr:
            s = parseInt;
            break;
        }
        return Do(e, n, s);
    }
    ensureProjectionResolved(t) {
        if ((t.flags & 16) === 0) {
            t.flags |= 16;
            const n = t.props;
            if (n) {
                const t = Object.keys(n);
                for (let e = 0; e < t.length; e++) {
                    const s = t[e];
                    if (x(s)) {
                        const t = n[s];
                        if (typeof t == "string") {
                            const e = this.vNodeLocate(t);
                            n[s] = e;
                        }
                    }
                }
            }
        }
    }
    _=t => Bn(t, this.pe);
    getSyncFn(t) {
        const n = this.he[t];
        return n;
    }
    we(t, n, e, s) {
        if (s) {
            const t = this.getHostProp(e, Ue);
            const s = new Set(function o(t) {
                return t?.split(" ") ?? null;
            }(t));
            s.add(n);
            this.setHostProp(e, Ue, function r(t) {
                return Array.from(t).join(" ");
            }(s));
        }
        if (this.$e == null) {
            this.$e = new Set;
            const t = this.document.querySelectorAll(De);
            for (let n = 0; n < t.length; n++) {
                const e = t[n];
                this.$e.add(e.getAttribute(Fe));
            }
        }
        if (!this.$e.has(n)) {
            this.$e.add(n);
            const e = this.document.createElement("style");
            e.setAttribute(Fe, n);
            e.textContent = t;
            this.document.head.appendChild(e);
        }
    }
    me() {
        const t = {};
        const n = this.element.attributes;
        if (n) {
            for (let e = 0; e < n.length; e++) {
                const s = n[e];
                if (s.name === yr) {
                    continue;
                }
                t[s.name] = s.value;
            }
        }
        this.Ft = {
            containerAttributes: t
        };
    }
}

let Mc;

let rh;

if (se) {
    const t = (() => {
        const t = globalThis.process;
        return t?.getBuiltinModule?.("node:async_hooks")?.AsyncLocalStorage;
    })();
    t && (rh = new t);
}

function Gn(t) {
    if (rh) {
        const t = rh.getStore();
        if (t) {
            return t;
        }
    }
    if (Mc === void 0) {
        const n = Cc();
        if (n && n.It) {
            return n.It;
        }
        if (t !== void 0) {
            return t;
        }
        throw Error("Reading `locale` outside of context.");
    }
    return Mc;
}

function Kn(t, n) {
    if (rh) {
        return rh.run(t, n);
    }
    const e = Mc;
    try {
        Mc = t;
        return n();
    } finally {
        Mc = e;
    }
}

let Ac;

const Cc = () => Ac;

const Nc = () => {
    const t = Cc();
    if (!t) {
        throw Te(9);
    }
    return t;
};

const Ic = () => {
    const t = Cc();
    if (!t || t.jt !== rr) {
        throw Te(10);
    }
    return t;
};

function Zn(t, n, ...e) {
    return te.call(this, t, n, e);
}

function te(t, n, e) {
    const s = Ac;
    try {
        Ac = t;
        return n.apply(this, e);
    } finally {
        Ac = s;
    }
}

const jc = (t, n) => {
    const e = Jn(n);
    const s = Jo(e.rootVNode, n);
    const o = e.It;
    o && function r(t) {
        if (rh) {
            rh.enterWith(t);
            return;
        }
        Mc = t;
    }(o);
    const i = ee(o, s, t);
    i.$ = e;
    return i;
};

function ne(t, n, e) {
    const s = {
        m: n,
        jt: rr,
        Ot: void 0,
        It: t,
        $: e,
        Lt: void 0
    };
    de(s);
    return s;
}

function ee(t, n, e) {
    const s = t || (e && ke(e) && "locale" in e ? e.locale : void 0);
    const o = {
        m: n,
        jt: e,
        Ot: void 0,
        It: s,
        $: void 0
    };
    de(o);
    return o;
}

const Oc = (t, ...n) => {
    if (typeof t === "function") {
        if (!Ac) {
            return t(...n);
        }
        {
            const e = Ac.Ot;
            try {
                Ac.Ot = void 0;
                return t(...n);
            } finally {
                Ac.Ot = e;
            }
        }
    }
    if (Jl(t)) {
        return t.untrackedValue;
    }
    return lu(t);
};

const Lc = /*#__PURE__*/ ne(void 0, void 0, void 0);

const Fc = (t, n, e, s, o) => {
    const r = Lc.Ot;
    const i = Lc.$;
    try {
        Lc.Ot = d(n, e, o);
        Lc.$ = s;
        return te(Lc, t);
    } finally {
        Lc.Ot = r;
        Lc.$ = i;
    }
};

const Dc = (t, n, e, s, o) => {
    t instanceof ps && t.m !== n && n && (t.m = n);
    return Fc(() => t.value, n, e, s, o);
};

const zc = () => Cc()?.m;

const Uc = () => {
    const t = Cc();
    if (t) {
        return t.jt;
    }
};

const Vc = () => {
    const t = Cc();
    if (t) {
        return t.$;
    }
};

const Wc = t => t;

const Qc = t => t.l || Promise.resolve();

let Xc = (t, n, e, s, o) => new Bc(t, n, e, s, o);

class Bc {
    vt;
    bt;
    be;
    ve;
    $;
    constructor(t, n, e, s, o) {
        this.vt = t;
        this.bt = n;
        this.be = e;
        this.ve = s;
        s && this.ge(s);
        !o || s || typeof t !== "string" || e || (this.$ = o);
        ce && (t => {
            t.dev = null;
            typeof document !== "undefined" && (t.qrls = new Set);
        })(this);
        oe && t && ie(t, .8);
    }
    get st() {
        return nh(this.bt);
    }
    ge(t) {
        this.ve = t;
        gr(t) && t.then(t => this.ve = t, t => {
            console.error(`qrl ${this.bt} failed to load`, t);
            this.ve = null;
        });
    }
    Se() {
        if (this.ve != null) {
            return this.ve;
        }
        if (this.vt === "") {
            const t = this.$.ue;
            const n = this.$.element?.ownerDocument || document;
            const e = Qe(n, t);
            return this.ve = e[+this.bt];
        }
        oe && this.vt && ie(this.vt, 1);
        const t = this.bt;
        const n = this.be ? this.be().then(n => n[t]) : li().importSymbol(this.$?.element, this.vt, t);
        this.ge(n);
        return this.ve;
    }
}

oe && import.meta.hot && (t => {
    if (!oe || !import.meta.hot) {
        return;
    }
    const n = new Map;
    (() => {
        Xc = (e, s, o, r, i) => {
            let c = n.get(s);
            if (!c) {
                c = new t(e, s, o, r, i);
                e !== "" && n.set(s, c);
            }
            return c;
        };
    })();
    const e = (t, n) => {
        const [e, s] = t.split("?", 2);
        if (!s) {
            return `${e}?t=${n}`;
        }
        const o = s.split("&").filter(t => !t.startsWith("t="));
        o.push("t=" + n);
        return `${e}?${o.join("&")}`;
    };
    document.addEventListener("qHmr", t => {
        const s = t.detail.files;
        const o = t.detail.t || document.__hmrT || Date.now();
        let r = !1;
        for (const t of n.values()) {
            const n = t.dev?.file || t.vt;
            if (!n || !s.some(t => n.startsWith(t))) {
                continue;
            }
            const i = t.vt;
            if (i) {
                t.vt = e(i, o);
                r = !0;
            }
            const c = t.be?.toString();
            if (c) {
                const n = c.replace(/import\((['"])(.+?)\1\)/, (t, n, s) => {
                    const r = e(s, o);
                    return `import(${n}${r}${n})`;
                });
                if (n !== c) {
                    try {
                        t.be = Function(`return (${n})`)();
                        r = !0;
                    } catch (n) {
                        console.error("Failed to update symbolFn for " + t.bt, n);
                    }
                } else {
                    console.warn(`Couldn't find import() in symbolFn for ${t.bt}, cannot update it for HMR`, c);
                }
            }
            if (r) {
                t.ve = void 0;
                document.__hmrDone = document.__hmrT;
                if (t.qrls) {
                    for (const n of t.qrls) {
                        const e = n.deref();
                        e ? e.resolved && (e.resolved = void 0) : t.qrls.delete(n);
                    }
                }
            }
        }
    });
})(Bc);

const Jc = Symbol();

const Hc = t => t?.[Jc] ?? t;

class Yc {
    _e;
    resolved=void 0;
    qt;
    $;
    constructor(t, n, e) {
        this._e = t;
        ce && ((t, n, e) => {
            if (n && typeof n === "object") {
                for (let t = 0; t < n.length; t++) {
                    const e = n[t];
                    dc(e, "Captured variable in the closure can not be serialized");
                }
            }
            t.qrls && t.qrls.add(new WeakRef(e));
        })(t, n, this);
        if (n) {
            this.qt = n;
            typeof n === "string" && (this.$ = e);
        }
        t.ve == null || typeof this.qt === "string" || gr(t.ve) || (this.resolved = sf(this, t.ve));
    }
}

const Gc = function(t, ...n) {
    const e = Hc(this);
    if (e.resolved) {
        return e.resolved.apply(t, n);
    }
    const s = Cc();
    return Kc.call(e, s?.$).then(() => te.call(t, s, e.resolved, n));
};

const Kc = async function(t) {
    const n = Hc(this);
    return _r(of(n, t), () => n.resolved);
};

const Zc = Object.create(Function.prototype, {
    resolved: {
        get() {
            return this[Jc].resolved;
        },
        set(t) {
            this[Jc].resolved = t;
        }
    },
    qt: {
        get() {
            return this[Jc].qt;
        },
        set(t) {
            this[Jc].qt = t;
        }
    },
    $: {
        get() {
            return this[Jc].$;
        },
        set(t) {
            this[Jc].$ = t;
        }
    },
    _e: {
        get() {
            return this[Jc]._e;
        }
    },
    vt: {
        get() {
            return this[Jc]._e.vt;
        }
    },
    bt: {
        get() {
            return this[Jc]._e.bt;
        }
    },
    st: {
        get() {
            return this[Jc]._e.st;
        }
    },
    dev: {
        get() {
            return this[Jc]._e.dev;
        }
    },
    ...ce ? {
        se: {
            value(t) {
                this[Jc]._e.dev = t;
            }
        }
    } : void 0,
    ke: {
        value: Gc
    },
    w: {
        value: function(t) {
            const n = Hc(this);
            const e = new Yc(n._e, t, n.qt ? n.$ : void 0);
            return uf(e);
        }
    },
    s: {
        value: function(t) {
            const n = Hc(this);
            n._e.ge(t);
            n.resolved = sf(n, t);
        }
    },
    resolve: {
        value: Kc
    },
    getSymbol: {
        value: function() {
            return Hc(this)._e.bt;
        }
    },
    getHash: {
        value: function() {
            return Hc(this)._e.st;
        }
    },
    getCaptured: {
        value: function() {
            const t = Hc(this);
            rf(t);
            return t.qt;
        }
    },
    getFn: {
        value: function(t, n) {
            const e = Hc(this);
            const s = (...o) => {
                if (!e.resolved) {
                    return Kc.call(e).then(t => {
                        if (ce && !Re(t)) {
                            throw Te(5);
                        }
                        return s(...o);
                    });
                }
                if (n && n() === !1) {
                    return;
                }
                return te(t, e.resolved, o);
            };
            return s;
        }
    }
});

let tf = null;

const nf = t => {
    tf = t;
};

const ef = (t, n) => {
    const e = [];
    const s = n.split(" ");
    for (let n = 0; n < s.length; n++) {
        const o = s[n];
        e.push(t._(o));
    }
    return e;
};

const rf = t => {
    tf = t.qt;
    const n = t.$;
    if (typeof tf === "string") {
        if (!n) {
            throw Te(13);
        }
        const e = rc;
        tf = t.qt = ef(n, tf);
        if (rc !== e) {
            return rc;
        }
    }
};

const sf = (t, n) => {
    if (typeof n !== "function" || !t.qt) {
        return n;
    }
    return function e(...s) {
        rf(t);
        return n.apply(this, s);
    };
};

const of = (t, n) => {
    const e = t._e;
    const s = typeof t.qt === "string";
    s && !t.$ && (t.$ = n || Cc()?.$);
    if (t.resolved) {
        return;
    }
    const o = hf();
    const r = Cc();
    const i = e.Se();
    const c = _r(i, n => {
        t.resolved = sf(t, n);
    });
    if (c) {
        const t = e.bt;
        ff(t, r?.m instanceof wi ? r?.m.node : void 0, o);
    }
    const l = s && t.$ && rf(t);
    if (l) {
        return l.then(() => c);
    }
    return c;
};

const lf = (t, n, e, s, o, r) => {
    const i = Xc(t, n, s, e, r);
    const c = new Yc(i, o, r);
    return uf(c);
};

const uf = t => {
    const n = async function(...t) {
        return Gc.call(n, this, ...t);
    };
    n[Jc] = t;
    Object.setPrototypeOf(n, Zc);
    return n;
};

const cf = /*#__PURE__*/ new Set;

const ff = (t, n, e) => {
    if (!cf.has(t)) {
        cf.add(t);
        af("qsymbol", {
            symbol: t,
            element: n,
            reqTime: e
        });
    }
};

const af = (t, n) => {
    ae || ui() || typeof document !== "object" || document.dispatchEvent(new CustomEvent(t, {
        bubbles: !1,
        detail: n
    }));
};

const hf = () => {
    if (ae || ui()) {
        return 0;
    }
    if (typeof performance === "object") {
        return performance.now();
    }
    return 0;
};

let df = 0;

const pf = t => {
    if (!he && ce) {
        throw Error("Optimizer should replace all usages of $() with some special syntax. If you need to create a QRL manually, use inlinedQrl() instead.");
    }
    return lf(null, "s" + df++, t, null, null);
};

const $f = pf;

const mf = t => t;

const yf = t => {
    if (!he && ce) {
        throw Error("Optimizer should replace all usages of sync$() with some special syntax. If you need to create a QRL manually, use inlinedSyncQrl() instead.");
    }
    ce && (t = Function("return " + t)());
    return lf("", qe, t, null, null);
};

const wf = (t, n) => {
    n === void 0 && (n = "" + t);
    t.serialized = n;
    return lf("", qe, t, null, null);
};

const bf = t => {
    function n(n, e, s = 0) {
        const o = ae ? "sX" : t.st.slice(0, 4);
        const r = o + ":" + (e || "");
        const i = () => {};
        i[vf] = [ t ];
        return Ps(i, n, null, n.children, s, r);
    }
    n[vf] = [ t ];
    return n;
};

const vf = Symbol();

const gf = t => typeof t == "function" && t[vf] !== void 0;

const Sf = t => bf($f(t));

const _f = Zi(mf);

const kf = () => {
    const t = globalThis.__QWIK_MANIFEST__;
    if (!globalThis.__QWIK_MANIFEST__) {
        throw Error("Client manifest is not available. It should have been automatically injected during the build process. Make sure that @qwik.dev/core is internal to the build.");
    }
    return t;
};

const Ef = async (t, n, e = {}) => {
    if ((t => t.nodeType === 9)(t)) {
        let n = t.firstChild;
        for (;n && !ci(n); ) {
            n = n.nextSibling;
        }
        t = n;
    }
    if (ce && t.hasAttribute(Ge)) {
        throw Te(4, [ t ]);
    }
    t.setAttribute(Ge, "resumed");
    const s = Jn(t);
    s.Ft = e.serverData || {};
    const o = s.rootVNode;
    zo(o, ki, n);
    sn(s, o, 2);
    await s.l;
    return {
        cleanup: () => {
            kt(s, [], s.rootVNode);
        }
    };
};

const xf = (t, n) => {
    const {val: e, set: s, iCtx: o} = lo();
    if (e != null) {
        return e;
    }
    const r = Re(t) ? Zn(void 0, t) : t;
    if (n?.reactive === !1) {
        s(r);
        return r;
    }
    {
        const t = o.$;
        const e = n?.deep ?? !0;
        const i = e ? 1 : 0;
        const c = cu(r, i, t);
        s(c);
        return c;
    }
};

const Rf = () => {
    const {val: t, set: n, iCtx: e} = lo();
    if (t != null) {
        return t;
    }
    const s = e.$.ce || "";
    const o = s ? Ar(s).substring(0, 3) : "";
    const r = e.$.getHostProp(e.m, Ne);
    const i = r?.getHash().substring(0, 3) || "";
    const c = (t => (t => t.toString(36))(t.le++))(e.$) || "";
    let l = `${o}${i}${c}`;
    let u = l.charCodeAt(0);
    if (u >= 48 && u <= 57) {
        u += 17;
        l = String.fromCharCode(u) + l.substring(1);
    }
    return n(l);
};

function re(t, n) {
    const e = Cc();
    return e?.$?.Ft[t] ?? n;
}

const Tf = /*#__PURE__*/ new Map;

const qf = (t, n) => {
    if (ce) {
        return Pf(t, n);
    }
    let e = Tf.get(n);
    e || Tf.set(n, e = Pf(t, n));
    return e;
};

const Pf = (t, n) => {
    const e = t.length;
    const s = [];
    const o = [];
    let r = 0;
    let i = r;
    let c = If;
    let l = 0;
    for (;r < e; ) {
        const n = r;
        let e = t.charCodeAt(r++);
        if (e === ua) {
            r++;
            e = sa;
        }
        const s = ma[c];
        for (let d = 0; d < s.length; d++) {
            const p = s[d];
            const [$, m, y] = p;
            if (($ === l || $ === Wf || $ === Qf && Mf(l) || $ === Bf && Nf(l)) && (m === e || m === Wf || m === Qf && Mf(e) || m === Xf && !Mf(e) && e !== na || m === Bf && Nf(e)) && (p.length == 3 || a(p))) {
                p.length > 3 && (e = t.charCodeAt(r - 1));
                if (y === Uf || y == Vf) {
                    if (y === Vf) {
                        if (c !== jf || h()) {
                            if (!Af(e)) {
                                const t = m == Xf ? 1 : m == Zf ? 2 : 0;
                                f(r - t);
                            }
                        } else {
                            Af(e) ? u(r - 2) : f(r - 2);
                            i++;
                        }
                    }
                    if (m === Xf) {
                        r--;
                        e = l;
                    }
                    do {
                        c = o.pop() || If;
                        if (c === Of) {
                            u(r - 1);
                            i++;
                        }
                    } while (Cf(c));
                } else {
                    o.push(c);
                    if (c === Of && y === If) {
                        u(r - 8);
                        i = r;
                    } else {
                        y === Lf && f(n);
                    }
                    c = y;
                }
                break;
            }
        }
        l = e;
    }
    u(r);
    return s.join("");
    function u(n) {
        s.push(t.substring(i, n));
        i = n;
    }
    function f(t) {
        if (c === Of || h()) {
            return;
        }
        u(t);
        s.push(".", je, n);
    }
    function a(n) {
        let e = 0;
        if (t.charCodeAt(r) === ta) {
            for (let n = 1; n < 10; n++) {
                if (t.charCodeAt(r + n) === ta) {
                    e = n + 1;
                    break;
                }
            }
        }
        t: for (let s = 3; s < n.length; s++) {
            const o = n[s];
            for (let n = 0; n < o.length; n++) {
                if ((t.charCodeAt(r + n + e) | fa) !== o.charCodeAt(n)) {
                    continue t;
                }
            }
            r += o.length + e;
            return !0;
        }
        return !1;
    }
    function h() {
        return o.indexOf(Of) !== -1 || o.indexOf(Ff) !== -1;
    }
};

const Mf = t => t >= ea && t <= ra || t >= sa && t <= oa || t >= aa && t <= ha || t >= 128 || t === ca || t === ta;

const Af = t => t === ia || t === na || t === la || t === Kf || Mf(t);

const Cf = t => t === Df || t === Ff || t === zf || t === Of;

const Nf = t => t === Gf || t === Jf || t === Hf || t === Yf;

const If = 0;

const jf = 2;

const Of = 5;

const Lf = 6;

const Ff = 10;

const Df = 11;

const zf = 12;

const Uf = 17;

const Vf = 18;

const Wf = 0;

const Qf = 1;

const Xf = 2;

const Bf = 3;

const Jf = 9;

const Hf = 10;

const Yf = 13;

const Gf = 32;

const Kf = 35;

const Zf = 41;

const ta = 45;

const na = 46;

const ea = 48;

const ra = 57;

const ia = 58;

const sa = 65;

const oa = 90;

const la = 91;

const ua = 92;

const ca = 95;

const fa = 32;

const aa = 97;

const ha = 122;

const da = 123;

const pa = 125;

const $a = /*@__PURE__*/ (() => [ [ Wf, 39, 14 ], [ Wf, 34, 15 ], [ Wf, 47, 16, "*" ] ])();

const ma = /*@__PURE__*/ (() => [ [ [ Wf, 42, jf ], [ Wf, la, 7 ], [ Wf, ia, Lf, ":", "before", "after", "first-letter", "first-line" ], [ Wf, ia, Of, "global" ], [ Wf, ia, 3, "has", "host-context", "not", "where", "is", "matches", "any" ], [ Wf, ia, 4 ], [ Wf, Qf, 1 ], [ Wf, na, 1 ], [ Wf, Kf, 1 ], [ Wf, 64, Ff, "keyframe" ], [ Wf, 64, Df, "media", "supports", "container" ], [ Wf, 64, zf ], [ Wf, da, 13 ], [ 47, 42, 16 ], [ Wf, 59, Uf ], [ Wf, pa, Uf ], [ Wf, Zf, Uf ], ...$a ], [ [ Wf, Xf, Vf ] ], [ [ Wf, Xf, Vf ] ], [ [ Wf, 40, If ], [ Wf, Xf, Vf ] ], [ [ Wf, 40, 8 ], [ Wf, Xf, Vf ] ], [ [ Wf, 40, If ], [ Wf, Xf, Uf ] ], [ [ Wf, Xf, Uf ] ], [ [ Wf, 93, Vf ], [ Wf, 39, 14 ], [ Wf, 34, 15 ] ], [ [ Wf, Zf, Uf ], ...$a ], [ [ Wf, pa, Uf ], ...$a ], [ [ Wf, pa, Uf ], [ Bf, Qf, 1 ], [ Wf, ia, Of, "global" ], [ Wf, da, 13 ], ...$a ], [ [ Wf, da, If ], [ Wf, 59, Uf ], ...$a ], [ [ Wf, 59, Uf ], [ Wf, da, 9 ], ...$a ], [ [ Wf, pa, Uf ], [ Wf, da, 13 ], [ Wf, 40, 8 ], ...$a ], [ [ Wf, 39, Uf ] ], [ [ Wf, 34, Uf ] ], [ [ 42, 47, Uf ] ] ])();

const ya = t => ({
    styleId: ga(t, t => t, !1)
});

const wa = /*#__PURE__*/ Zi(ya);

const ba = t => ({
    scopeId: je + ga(t, qf, !0)
});

const va = /*#__PURE__*/ Zi(ba);

const ga = (t, n, e) => {
    let {val: s, set: o, iCtx: r, i} = lo();
    if (s) {
        return s;
    }
    const c = ((t, n) => `${Ar(t.st)}-${n}`)(t, i);
    const l = r.m;
    o(c);
    if (!t.resolved) {
        throw t.resolve().then(t => r.$.we(n(t, c), c, l, e));
    }
    r.$.we(n(t.resolved, c), c, l, e);
    return c;
};

const Sa = (t, n) => {
    t.resolve();
    return ns(t, n);
};

const _a = (t, n) => fo(Sa, t, n);

const ka = Zi(_a);

const Ea = t => {
    t.resolve();
    return rs(t);
};

const xa = t => fo(Ea, t);

const Ra = Zi(xa);

const Ta = (t, n) => {
    const {val: e, set: s, i: o, iCtx: r} = lo();
    const i = n?.strategy ?? "intersection-observer";
    if (e) {
        if (!(e.h & 32) && !ui()) {
            e.h |= 32;
            qa(e, i);
        }
        return;
    }
    let c;
    if (ui()) {
        c = 1;
    } else {
        c = 5;
        t.resolve();
        sn(r.$, r.m, 1);
    }
    const l = new Ql(c, o, r.m, t, void 0, null);
    s(l);
    qa(l, i);
};

const qa = (t, n) => {
    n === "intersection-observer" ? Yu("qvisible", Pa(t)) : n === "document-ready" ? Gu("qinit", Pa(t)) : n === "document-idle" && Gu("qidle", Pa(t));
};

const Pa = t => lf(null, "_task", bn, null, [ t ]);

const Ma = Zi(Bu);

const Aa = /*#__PURE__*/ Zi(Vl);

const Ca = /*#__PURE__*/ Zi(Ta);

const Na = (t, n) => {
    t.resolve();
    return es(t, n);
};

const Ia = (t, n) => fo(Na, t, n);

const ja = Zi(Ia);

const Oa = () => {
    const t = xf({
        error: void 0
    });
    Sc(xc, t);
    return t;
};

const La = async ({track: t}) => {
    const n = tf[0];
    t(() => n.items);
    const e = Cc();
    const s = e.m;
    const o = e.$;
    sn(o, s, 128);
    const r = import.meta.env.TEST ? ui() : se;
    r && await o.l;
};

const Fa = t => {
    if (!__EXPERIMENTAL__.each) {
        throw Error('Each is experimental and must be enabled with `experimental: ["each"]` in the `qwikVite` plugin.');
    }
    Vl(/*#__PURE__*/ ju(La, "_eaT", [ t ]));
    return Us;
};

const Da = /*#__PURE__*/ bf(
/*#__PURE__*/ ju(Fa, "_eaC"));

const za = /*#__PURE__*/ gc("qk-reveal");

const Ua = t => ({
    order: t.order ?? "parallel",
    collapsed: t.collapsed === !0,
    items: [],
    version: is(0)
});

const Va = () => {
    const t = tf[0];
    if (t === null) {
        return !0;
    }
    const n = t.reveal;
    const e = t.item;
    const s = n.items;
    if (n.version.value < 0) {
        return !1;
    }
    switch (n.order) {
      case "together":
        for (let t = 0; t < s.length; t++) {
            if (s[t].boundary.pending.untrackedValue > 0) {
                return !1;
            }
        }
        return !0;

      case "sequential":
        for (let t = 0; t < s.length; t++) {
            const n = s[t];
            if (n === e) {
                return !0;
            }
            if (n.boundary.pending.untrackedValue > 0) {
                return !1;
            }
        }
        return !0;

      case "reverse":
        for (let t = s.length - 1; t >= 0; t--) {
            const n = s[t];
            if (n === e) {
                return !0;
            }
            if (n.boundary.pending.untrackedValue > 0) {
                return !1;
            }
        }
        return !0;

      default:
        return !0;
    }
};

const Wa = ({cleanup: t}) => {
    const n = tf[0];
    t(() => {
        if (import.meta.env.TEST ? ui() : !oe) {
            return;
        }
        const t = n.reveal.items;
        const e = t.indexOf(n.item);
        if (e !== -1) {
            t.splice(e, 1);
            n.reveal.version.value++;
        }
    });
};

const Qa = t => {
    if (!__EXPERIMENTAL__.suspense) {
        throw Error('Reveal is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
    }
    const n = fo(Ua, t);
    Sc(za, n);
    /*#__PURE__*/
    return qs(zs, null, null, null, 0, "u7_0");
};

const Xa = /*#__PURE__*/ bf(
/*#__PURE__*/ ju(Qa, "_reC"));

const Ba = (t, n, e, s) => ({
    display: n.value !== "fallback" || t.fallback == null || t.fallback === !1 || e !== null && !e.value && s.reveal.collapsed ? "none" : "contents"
});

const Ja = (t, n, e) => ({
    display: e !== null && !e.value || n.value !== "content" && !t.showStale ? "none" : "contents"
});

const Ha = ({track: t, cleanup: n}) => {
    const e = tf[0], s = tf[1], o = tf[2], r = tf[3];
    const i = t(e.pending);
    const c = import.meta.env.TEST ? !ui() : oe;
    r !== null && c && r.reveal.version.value++;
    if (!c || i === 0) {
        o.value = "content";
        return;
    }
    const l = setTimeout(() => {
        e.pending.value > 0 && (o.value = "fallback");
    }, s.delay ?? 0);
    n(() => clearTimeout(l));
};

const Ya = t => {
    if (!__EXPERIMENTAL__.suspense) {
        throw Error('Suspense is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
    }
    const n = co("content");
    const e = (() => {
        if (!__EXPERIMENTAL__.suspense) {
            throw Error('useCursorBoundary is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
        }
        return fo(ao);
    })();
    const s = (t => {
        const n = _c(za, null);
        const e = fo(() => {
            if (n === null) {
                return null;
            }
            const e = {
                boundary: t
            };
            n.items.push(e);
            return {
                reveal: n,
                item: e
            };
        });
        e !== null && Vl(/*#__PURE__*/ ju(Wa, "_reT", [ e ]), {
            deferUpdates: !1
        });
        return e;
    })(e);
    const o = _a(
    /*#__PURE__*/ ju(Va, "_reR", [ s ]));
    Vl(
    /*#__PURE__*/ ju(Ha, "_suT", [ e, t, n, s ]));
    /*#__PURE__*/
    return qs(Ls, null, null, [ 
    /*#__PURE__*/ qs("div", {
        style: Uu(Ba, [ t, n, o, s ], '{display:p1.value==="fallback"&&p0.fallback!=null&&p0.fallback!==false&&(p2===null||p2.value||!p3.reveal.collapsed)?"contents":"none"}')
    }, null, as(t, "fallback"), 1, null), 
    /*#__PURE__*/ qs("div", null, {
        style: Uu(Ja, [ t, n, o ], '{display:(p2===null||p2.value)&&(p1.value==="content"||p0.showStale)?"contents":"none"}')
    }, 
    /*#__PURE__*/ qs(zs, {
        [$r]: e
    }, null, null, 3, "u6_0"), 1, null) ], 1, "u6_1");
};

const Ga = /*#__PURE__*/ bf(
/*#__PURE__*/ ju(Ya, "_suC"));

const Ka = t => {
    import.meta;
    const n = import.meta.env.BASE_URL || "/";
    const e = {
        path: "qwik-prefetch-service-worker.js",
        ...t
    };
    e.path = t?.path?.startsWith?.("/") ? t.path : n + e.path;
    let s = Za.replace('"_URL_"', JSON.stringify(e.path.split("/").pop()));
    s = s.replaceAll(/\s\s+/gm, "");
    const o = {
        dangerouslySetInnerHTML: "(" + s + ")(navigator.serviceWorker);",
        nonce: e.nonce
    };
    return qs("script", null, o, null, 0, "prefetch-service-worker");
};

const Za = /*#__PURE__*/ "" + (t => {
    "getRegistrations" in t && t.getRegistrations().then(t => {
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            e.active && e.active.scriptURL.endsWith("_URL_") && e.unregister().catch(console.error);
        }
    });
    "caches" in window && caches.keys().then(t => {
        const n = t.find(t => t.startsWith("QwikBundles"));
        n && caches.delete(n).catch(console.error);
    }).catch(console.error);
});

const th = () => null;

globalThis.__qwik && Te(30, [ globalThis.__qwik, ei ]);

globalThis.__qwik = ei;

import.meta.hot && import.meta.hot.dispose(() => {
    globalThis.__qwik = void 0;
});

export { pf as $, Da as Each, Ls as Fragment, bc as NoSerializeSymbol, th as PrefetchGraph, Ka as PrefetchServiceWorker, Fs as RenderOnce, Ju as Resource, Xa as Reveal, Ws as SSRComment, Vs as SSRRaw, Xs as SSRStream, Qs as SSRStreamBlock, vc as SerializerSymbol, Us as SkipRender, zs as Slot, Ga as Suspense, Oi as _CONST_PROPS, Pc as _DomContainer, fi as _EFFECT_BACK_REF, Vi as _EMPTY_ARRAY, Wi as _EMPTY_OBJ, zi as _IMMUTABLE, Vu as _SharedContainer, $s as _SubscriptionData, Ui as _UNINITIALIZED, Li as _VAR_PROPS, Ln as _addProjection, tf as _captures, m as _chk, lf as _createQRL, Xn as _deserialize, qu as _dumpState, Fa as _eaC, La as _eaT, en as _executeSsrChores, Uu as _fnSignal, Gi as _getConstProps, Vc as _getContextContainer, Uc as _getContextEvent, zc as _getContextHostElement, Jn as _getDomContainer, Yn as _getQContainerElement, Yi as _getVarProps, ou as _hasStoreEffects, nc as _hmr, vs as _isJSXNode, uu as _isStore, Mn as _isStringifiable, Xl as _isTask, Wc as _jsxBranch, Ms as _jsxC, Cs as _jsxQ, As as _jsxS, qs as _jsxSorted, Ps as _jsxSplit, be as _mapApp_findIndx, ge as _mapArray_get, ve as _mapArray_set, Ou as _noopQrl, Lu as _noopQrlDEV, qn as _preprocessState, wf as _qrlSync, En as _qrlToString, Qa as _reC, Va as _reR, Wa as _reT, zu as _regSymbol, zn as _removeProjection, y as _res, Ec as _resolveContextWithoutSequentialScope, Ys as _restProps, Xu as _rsc, N as _run, Qn as _serialize, In as _setEvent, Fn as _setProjectionTarget, Ya as _suC, Ha as _suT, bn as _task, Dn as _updateProjectionProps, On as _useHmr, $ as _val, dc as _verifySerializable, Wo as _vnode_ensureElementInflated, Cl as _vnode_getAttrKeys, hl as _vnode_getElementName, $l as _vnode_getFirstChild, Do as _vnode_getProp, Go as _vnode_getVNodeForChildNode, ll as _vnode_insertBefore, No as _vnode_isElementVNode, jo as _vnode_isMaterialized, Oo as _vnode_isTextVNode, Lo as _vnode_isVirtualVNode, Ao as _vnode_newVirtual, fl as _vnode_remove, zo as _vnode_setProp, hn as _vnode_toString, Qc as _waitUntilRendered, Cn as _walkJSX, as as _wrapProp, ds as _wrapSignal, Sf as component$, bf as componentQrl, os as createAsync$, es as createAsyncQrl, ss as createComputed$, ns as createComputedQrl, gc as createContextId, w as createElement, ls as createSerializer$, rs as createSerializerQrl, is as createSignal, _f as event$, mf as eventQrl, su as forceStoreEffects, kf as getClientManifest, Jn as getDomContainer, Gn as getLocale, li as getPlatform, w as h, Zi as implicit$FirstArg, ju as inlinedQrl, Du as inlinedQrlDEV, le as isDev, Jl as isSignal, Is as jsx, js as jsxDEV, Os as jsxs, wc as noSerialize, Iu as qrl, Fu as qrlDEV, Ef as render, oi as setPlatform, yf as sync$, Oc as untrack, lu as unwrapStore, ja as useAsync$, Ia as useAsyncQrl, ka as useComputed$, _a as useComputedQrl, fo as useConstant, _c as useContext, Sc as useContextProvider, Oa as useErrorBoundary, Rf as useId, Qu as useLexicalScope, Yu as useOn, Gu as useOnDocument, Ku as useOnWindow, Ma as useResource$, Bu as useResourceQrl, Ra as useSerializer$, xa as useSerializerQrl, re as useServerData, co as useSignal, xf as useStore, wa as useStyles$, ya as useStylesQrl, va as useStylesScoped$, ba as useStylesScopedQrl, Aa as useTask$, Vl as useTaskQrl, Ca as useVisibleTask$, Ta as useVisibleTaskQrl, ei as version, Kn as withLocale };
